webpackJsonp([13],{

/***/ "+/6L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"key_stats":"key_stats__Gtidt","stat":"stat__2K5LB","value":"value__3JVIt","shrink_unit":"shrink_unit__22HI2","label":"label__1WeFP","extra":"extra__2xlfc","stat_high_temperature":"stat_high_temperature__e12qb","stat_low_temperature":"stat_low_temperature__3HpQ4","stat_high_wind_gust":"stat_high_wind_gust__2qOwv","stat_rainfall":"stat_rainfall__l6zyV"};

/***/ }),

/***/ "+vFT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"navigation":"navigation__1EJRm","submenu_header":"submenu_header__de5ev","active":"active__3a8FO","submenu":"submenu__3ZsFV","open":"open__2lymk","history_links":"history_links__1QvYT","submenu_items":"submenu_items__1BtMd","submenu_dropdown":"submenu_dropdown__3YGUY","more_links":"more_links__ade6p"};

/***/ }),

/***/ "/QC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribers", function() { return subscribers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentUrl", function() { return getCurrentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "route", function() { return route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exec", function() { return exec; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var EMPTY$1 = {};

function assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.props;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0) == ':' ? 1 + '*+?'.indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.props.default ? 0 : rank(vnode.props.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}
	routeFromLink(e.currentTarget || e.target || this);
	return prevent(e);
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href')) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		var children = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["toChildArray"])(this.props.children);
		return this.getMatchingChildren(children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this.setState({ url: url });

		var didRoute = this.canRoute(url);

		// trigger a manual re-route if we're not in the middle of an update:
		if (!this.updating) {
			this.forceUpdate();
		}

		return didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.filter(prepareVNodeForRanking).sort(pathRankSort).map(function (vnode) {
			var matches = exec(url, vnode.props.path, vnode.props);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					assign(newProps, matches);
					delete newProps.ref;
					delete newProps.key;
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(vnode, newProps);
				}
				return vnode;
			}
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(Object(__WEBPACK_IMPORTED_MODULE_0_preact__["toChildArray"])(children), url, true);

		var current = active[0] || null;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Link = function Link(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["createElement"])('a', assign({ onClick: handleLinkClick }, props));
};

var Route = function Route(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["createElement"])(props.component, props);
};

Router.subscribers = subscribers;
Router.getCurrentUrl = getCurrentUrl;
Router.route = route;
Router.Router = Router;
Router.Route = Route;
Router.Link = Link;
Router.exec = exec;

/* harmony default export */ __webpack_exports__["default"] = (Router);
//# sourceMappingURL=preact-router.es.js.map

/***/ }),

/***/ "/R+W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ABORT_ERROR_NAME; });
/* harmony export (immutable) */ __webpack_exports__["b"] = abortRequests;
/* harmony export (immutable) */ __webpack_exports__["i"] = fetchLiveData;
/* harmony export (immutable) */ __webpack_exports__["o"] = fetchTodayHistory;
/* harmony export (immutable) */ __webpack_exports__["l"] = fetchObservations;
/* harmony export (immutable) */ __webpack_exports__["m"] = fetchObservationsHourly;
/* harmony export (immutable) */ __webpack_exports__["g"] = fetchDailyExtremes;
/* harmony export (immutable) */ __webpack_exports__["h"] = fetchDataRange;
/* harmony export (immutable) */ __webpack_exports__["k"] = fetchMonthlyStats;
/* harmony export (immutable) */ __webpack_exports__["n"] = fetchRecords;
/* harmony export (immutable) */ __webpack_exports__["q"] = fetchYearlyRainfall;
/* harmony export (immutable) */ __webpack_exports__["p"] = fetchWindRoseData;
/* harmony export (immutable) */ __webpack_exports__["f"] = fetchClimateWindRoseData;
/* harmony export (immutable) */ __webpack_exports__["e"] = fetchClimateSummaryData;
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchClimateDetailData;
/* harmony export (immutable) */ __webpack_exports__["j"] = fetchMessages;
/* harmony export (immutable) */ __webpack_exports__["c"] = buildUri;
var ABORT_ERROR_NAME = 'AbortError';

var defaultApiBaseUrl =  true ? 'https://api.howickweather.co.nz' : '/api';
var apiBaseUrl = ("/api" || defaultApiBaseUrl).replace(/\/+$/, '');

function getAbortController() {
	if ('AbortController' in window) {
		return new AbortController();
	}
	return null;
}

function abortRequests(requestsObj) {
	for (var key in requestsObj) {
		if (requestsObj.hasOwnProperty(key) && requestsObj[key] !== null) {
			requestsObj[key]();
		}
	}
}

function fetchWithTimeout(uri) {
	var abortController = getAbortController();

	var promise = new Promise(function (resolve, reject) {

		var fetchOpts = {};
		var timedOut = false;

		if (abortController !== null) {
			fetchOpts.signal = abortController.signal;
		}

		var timer = setTimeout(function () {
			reject(new Error('Request timed out'));
			timedOut = true;

			if (abortController !== null) {
				abortController.abort();
			}
		}, 20000);

		fetch(uri, fetchOpts).then(function (res) {
			return res.json();
		}).then(function (data) {
			clearTimeout(timer);
			if (data.error) {
				reject(data);
			} else {
				resolve(data);
			}
		}).catch(function (err) {
			clearTimeout(timer);
			if (!timedOut) {
				reject(err);
			}
		});
	});

	return {
		promise: promise,
		abort: abortController === null ? function () {} // noop
		: function () {
			return abortController.abort();
		}
	};
}

function params2QueryString(params) {
	var parts = Object.keys(params).map(function (key) {
		return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
	});
	return '?' + parts.join('&');
}

function fetchLiveData(params) {
	return fetchWithTimeout(buildUri('/live', params));
}

function fetchTodayHistory() {
	return fetchWithTimeout(buildUri('/history/today'));
}

function fetchObservations(params) {
	return fetchWithTimeout(buildUri('/observations', params));
}

function fetchObservationsHourly(params) {
	return fetchWithTimeout(buildUri('/observations/hourly', params));
}

function fetchDailyExtremes(params) {
	return fetchWithTimeout(buildUri('/stats/daily', params));
}

function fetchDataRange(params) {
	return fetchWithTimeout(buildUri('/datarange', params));
}

function fetchMonthlyStats(params) {
	return fetchWithTimeout(buildUri('/stats/monthly', params));
}

function fetchRecords() {
	return fetchWithTimeout(buildUri('/records'));
}

function fetchYearlyRainfall(params) {
	return fetchWithTimeout(buildUri('/stats/rainfall', params));
}

function fetchWindRoseData(params) {
	return fetchWithTimeout(buildUri('/windrose', params));
}

function fetchClimateWindRoseData() {
	return fetchWithTimeout(buildUri('/climate/windrose'));
}

function fetchClimateSummaryData() {
	return fetchWithTimeout(buildUri('/climate/summary'));
}

function fetchClimateDetailData() {
	return fetchWithTimeout(buildUri('/climate/detail'));
}

function fetchMessages() {
	return fetchWithTimeout(buildUri('/messages'));
}

function buildUri(route, params) {
	return apiBaseUrl + route + (params ? params2QueryString(params) : '');
}

/***/ }),

/***/ "/Umn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"header__3IhT1"};

/***/ }),

/***/ "/zgt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./components/loader/index.js
var loader = __webpack_require__("Cvo2");

// EXTERNAL MODULE: ./components/error/style.scss
var style = __webpack_require__("yR6k");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./components/button/index.js
var components_button = __webpack_require__("rAoZ");

// EXTERNAL MODULE: ./components/icons/refresh.js
var refresh = __webpack_require__("lRsh");

// CONCATENATED MODULE: ./components/error/index.js





/**
 * The ErrorMessage component is displayed when an error occurs within a particular context,
 * for instance if a data loading error occurs. A default message is displayed if none is
 * specified in props.
 *
 * props:
 * - noRetry: set this to false if retrying is not desired
 * - isRetryPending: is a retry operation currently in progress (true or false)
 * - retryCount: how many times has the a retry been attempted without success
 * - retryHandler: handler function which is called when the retry button is clicked
 * - message: custom message
 */

var _ref = Object(preact_min["h"])(refresh["a" /* default */], null);

var error_ErrorMessage = function ErrorMessage(props) {

	var message = props.message || 'An error occurred and the data could not be loaded';

	if (props.retryCount > 0) {
		message += ' (retried ' + props.retryCount + ' time' + (props.retryCount > 1 ? 's' : '') + ')';
	}

	return Object(preact_min["h"])(
		'div',
		{ 'class': style_default.a.error },
		Object(preact_min["h"])(
			'div',
			{ 'class': style_default.a.error_message },
			message
		),
		props.noRetry ? null : Object(preact_min["h"])(
			'div',
			{ 'class': style_default.a.error_retry },
			Object(preact_min["h"])(
				components_button["a" /* default */],
				{ clickHandler: props.retryHandler, isDisabled: props.isRetryPending },
				_ref,
				props.isRetryPending ? 'Loading' : 'Retry'
			)
		)
	);
};

/* harmony default export */ var error = (error_ErrorMessage);
// EXTERNAL MODULE: ./components/card/index.js
var card = __webpack_require__("MTo3");

// EXTERNAL MODULE: ./components/notify-mounted/index.js
var notify_mounted = __webpack_require__("Oqou");

// CONCATENATED MODULE: ./components/handle-loading-and-error/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * This higher order component wraps a component such that it will display a loader
 * if initial data is still loading and will display an error message if that data
 * failed to load.
 *
 * props:
 * - data: loader will be displayed when set to undefined, and an error message when set to null, otherwise passed into the wrapped component as a prop
 * - retryHandler: as per the Error component
 * - retryCount: as per the Error component
 * - isLoading: as per the Error component
 * - noRetry: as per the Error component
 * - wrapLoadingErrorInCard: whether the load/error stats should be wrapped in a Card
 * - errorMessage: custom error message as per the Error component
 *
 * Any other props are passed straight down into the wrapped component.
 */

var handle_loading_and_error__ref = Object(preact_min["h"])(loader["a" /* default */], null);

var handle_loading_and_error_handleLoadingAndError = function handleLoadingAndError(WrappedComponent) {

	return function (props) {
		var data = props.data,
		    retryHandler = props.retryHandler,
		    retryCount = props.retryCount,
		    isLoading = props.isLoading,
		    noRetry = props.noRetry,
		    errorMessage = props.errorMessage,
		    wrapLoadingErrorInCard = props.wrapLoadingErrorInCard,
		    mounted = props.mounted,
		    rest = _objectWithoutProperties(props, ['data', 'retryHandler', 'retryCount', 'isLoading', 'noRetry', 'errorMessage', 'wrapLoadingErrorInCard', 'mounted']);

		if (data !== null && data !== undefined) {
			return Object(preact_min["h"])(WrappedComponent, _extends({ data: data, mounted: mounted }, rest));
		}

		var content = void 0;

		if (data === undefined) {
			content = handle_loading_and_error__ref;
		} else {
			var ErrorComponent = typeof props.mounted === 'function' ? Object(notify_mounted["a" /* default */])(error) : error;

			content = Object(preact_min["h"])(ErrorComponent, { retryHandler: retryHandler,
				isRetryPending: isLoading,
				noRetry: noRetry,
				message: errorMessage,
				retryCount: retryCount,
				mounted: props.mounted });
		}

		return wrapLoadingErrorInCard ? Object(preact_min["h"])(
			card["a" /* default */],
			null,
			content
		) : content;
	};
};

/* harmony default export */ var handle_loading_and_error = __webpack_exports__["a"] = (handle_loading_and_error_handleLoadingAndError);

/***/ }),

/***/ "04o6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"checkbox__3K1BN","radio_btn":"radio_btn__1znyb"};

/***/ }),

/***/ "1zZQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = plotLine;
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PlotLine = function () {
	function PlotLine(name) {
		_classCallCheck(this, PlotLine);

		this.config = {
			x: 0,
			label: null,
			name: name
		};
	}

	PlotLine.prototype.x = function x(_x) {
		this.config.x = _x;
		return this;
	};

	PlotLine.prototype.label = function label(_label) {
		this.config.label = _label;
		return this;
	};

	return PlotLine;
}();

function plotLine(name) {
	return new PlotLine(name);
}

/***/ }),

/***/ "3s4+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"high_temperature":"high_temperature__1U93S","low_temperature":"low_temperature__2ZP5-","mean_temperature":"mean_temperature__1eriL","high_wind_gust":"high_wind_gust__3OBCA","rainfall":"rainfall__1QapN"};

/***/ }),

/***/ "5Xep":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__("lWMT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);



/**
 * The Table component provides a wrapper table element
 * that applies consistent styling. Rows are provided as children
 * (within thead and tbody sections).
 */
var Table = function Table(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'table',
    { 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.table },
    props.children
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Table);

/***/ }),

/***/ "5gwI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footnote":"footnote__1-Bja"};

/***/ }),

/***/ "6XQo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__("hafV");

// EXTERNAL MODULE: ./utils/tracking.js
var utils_tracking = __webpack_require__("x4D6");

// CONCATENATED MODULE: ./utils/preferences-converter.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * Helper function which converts legacy preferences into new settings data
 * and saves it to local storage.
 * @param prefs
 * @param tracking
 */
function convertOldPreferencesToNewUserSettings(prefs, tracking) {

	var pressureUnit = void 0,
	    rainUnit = void 0,
	    speedUnit = void 0;

	switch (prefs['unit-pressure']) {
		case 'inhg':
			pressureUnit = constants["e" /* PRESSURE_UNIT */].INHG;
			break;
		default:
			pressureUnit = constants["e" /* PRESSURE_UNIT */].HPA;
	}

	switch (prefs['unit-rainfall']) {
		case 'inches':
			rainUnit = constants["f" /* RAIN_UNIT */].IN;
			break;
		default:
			rainUnit = constants["f" /* RAIN_UNIT */].MM;
	}

	switch (prefs['unit-windspeed']) {
		default:
			speedUnit = constants["g" /* SPEED_UNIT */].KMH;
	}

	var temperatureUnit = prefs['unit-temperature'].toUpperCase();

	var settings = _extends({}, user_settings_getDefaultSettings(), {
		temperatureUnit: temperatureUnit,
		pressureUnit: pressureUnit,
		rainUnit: rainUnit,
		speedUnit: speedUnit
	});

	var settingsStr = JSON.stringify(settings);

	try {

		window.localStorage.setItem('user-settings', settingsStr);
		document.cookie = 'preferences=; expires=Thu, 01 Jan 1970 00:00:00 GMT';

		tracking.recordEvent(utils_tracking["a" /* EVENT_ACTION */].SETTINGS_CONVERT, utils_tracking["b" /* EVENT_CATEGORY */].SETTINGS);
	} catch (e) {

		tracking.recordException('Error converting old preferences to new settings', e);
	}
}
// CONCATENATED MODULE: ./utils/user-settings.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return user_settings_getUserSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return user_settings_getDefaultSettings; });



var user_settings_getUserSettings = function getUserSettings(tracking) {

	var settings = readSettings();

	if (settings === null) {

		// Check if the user has a preferences cookie (legacy)
		var prefsCookieMatch = document.cookie.match(/preferences=([^;]+)/);

		if (prefsCookieMatch !== null) {
			var prefs = void 0;
			try {
				prefs = JSON.parse(window.decodeURIComponent(prefsCookieMatch[1]));
			} catch (e) {}

			if (prefs) {
				// convert legacy units to new units and save to local storage
				convertOldPreferencesToNewUserSettings(prefs, tracking);

				// read in the settings just saved.
				settings = readSettings();
			}
		}

		if (settings === null) {
			settings = user_settings_getDefaultSettings();
		}
	}

	return {
		units: {
			temperature: settings.temperatureUnit,
			speed: settings.speedUnit,
			rain: settings.rainUnit,
			pressure: settings.pressureUnit
		},
		ui: {
			alwaysDisplayRecentObsAsList: false, // settings.alwaysDisplayRecentObsAsList,
			alwaysExpandRecentObsList: false, // settings.alwaysExpandRecentObsList,
			liveUpdatesEnabled: settings.liveUpdatesEnabled
		}
	};
};

var readSettings = function readSettings() {
	var settings = void 0;

	try {
		settings = JSON.parse(window.localStorage.getItem('user-settings'));
	} catch (e) {
		settings = null;
	}

	return settings;
};

var user_settings_getDefaultSettings = function getDefaultSettings() {
	return {
		temperatureUnit: constants["h" /* TEMPERATURE_UNIT */].C,
		speedUnit: constants["g" /* SPEED_UNIT */].KMH,
		rainUnit: constants["f" /* RAIN_UNIT */].MM,
		pressureUnit: constants["e" /* PRESSURE_UNIT */].HPA,
		alwaysDisplayRecentObsAsList: false,
		alwaysExpandRecentObsList: false,
		liveUpdatesEnabled: true
	};
};

/***/ }),

/***/ "6hGj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);

/**
 * The RainDrop component renders a rain drop SVG image.
 *
 * props:
 * - size: Width & height (pixels) of the image
 * - fill: The fill color of the rain drop
 */

var RainDrop = function RainDrop(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "svg",
    { width: props.size, height: props.size, viewBox: "0 0 400 400", preserveAspectRatio: "none" },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { transform: "translate(70,30)", fill: props.fill, d: "M 243.44676,222.01677 C 243.44676,288.9638 189.17548,343.23508 122.22845,343.23508 C 55.281426,343.23508 1.0101458,288.9638 1.0101458,222.01677 C 1.0101458,155.06975 40.150976,142.95572 122.22845,0.79337431 C 203.60619,141.74374 243.44676,155.06975 243.44676,222.01677 z" })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (RainDrop);

/***/ }),

/***/ "7N8r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (req) {
	function Async() {
		var _this = this;

		_preact.Component.call(this);

		var b = void 0,
		    old = void 0;
		this.componentWillMount = function () {
			b = _this.base = _this.nextBase || _this.__b;
			req(function (m) {
				_this.setState({ child: m.default || m });
			});
		};

		this.shouldComponentUpdate = function (_, nxt) {
			nxt = nxt.child === void 0;
			if (nxt && old === void 0 && !!b) {
				old = (0, _preact.h)(b.nodeName, { dangerouslySetInnerHTML: { __html: b.innerHTML } });
			} else {
				old = '';
			}
			return !nxt;
		};

		this.render = function (p, s) {
			return s.child ? (0, _preact.h)(s.child, p) : old;
		};
	}
	(Async.prototype = new _preact.Component()).constructor = Async;
	return Async;
};

var _preact = __webpack_require__("KM04");

/***/ }),

/***/ "9SP1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__("pCTO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'div',
	null,
	'Loading'
);

var LoadingScreen = function (_Component) {
	_inherits(LoadingScreen, _Component);

	function LoadingScreen(props) {
		_classCallCheck(this, LoadingScreen);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			isVisible: false
		};
		return _this;
	}

	LoadingScreen.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		// Don't show the loader if content loads immediately. Only show if it takes longer than approx. 0.3s.
		setTimeout(function () {
			return _this2.setState({ isVisible: true });
		}, 300);
	};

	LoadingScreen.prototype.render = function render() {
		if (!this.state.isVisible) {
			return null;
		}

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.loading_screen },
			_ref
		);
	};

	return LoadingScreen;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (LoadingScreen);

/***/ }),

/***/ "9c5c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/d3-scale/src/index.js + 38 modules
var src = __webpack_require__("zL2z");

// EXTERNAL MODULE: ../node_modules/d3-selection/src/index.js + 50 modules
var d3_selection_src = __webpack_require__("//ys");

// EXTERNAL MODULE: ../node_modules/d3-ease/src/index.js + 11 modules
var d3_ease_src = __webpack_require__("pJ11");

// EXTERNAL MODULE: ../node_modules/d3-array/src/index.js + 31 modules
var d3_array_src = __webpack_require__("K0bd");

// EXTERNAL MODULE: ../node_modules/d3-shape/src/index.js + 51 modules
var d3_shape_src = __webpack_require__("9maw");

// EXTERNAL MODULE: ../node_modules/d3-transition/src/index.js + 32 modules
var d3_transition_src = __webpack_require__("UqVV");

// EXTERNAL MODULE: ./utils/formatters.js
var formatters = __webpack_require__("gNwm");

// CONCATENATED MODULE: ./utils/wind-rose.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }









var wind_rose_WindRose = function () {
	function WindRose(data, speedUnit) {
		_classCallCheck(this, WindRose);

		this.data = data;
		this.unit = speedUnit;
	}

	WindRose.prototype.render = function render(containerNode) {
		this._init(containerNode);
		this._setupScales();
		this._renderSpokes();
		this._renderAxis();
		this._renderDirectionLines();
		this._renderLegend();
	};

	WindRose.prototype._init = function _init(containerNode) {

		this.container = Object(d3_selection_src["select"])(containerNode);
		var containerSize = containerNode.getBoundingClientRect();

		this.dim = {
			marginTop: 20,
			marginBottom: 20,
			marginLeft: 20,
			marginRight: 20,
			innerRadius: containerSize.width * 0.025,
			legendWidth: 84,
			directionLabelSpacing: 20,
			totalWidth: containerSize.width
		};

		this.dim.totalHeight = this.dim.totalWidth - this.dim.legendWidth;

		this.dim.roseSize = this.dim.totalWidth - this.dim.legendWidth - this.dim.marginLeft - this.dim.marginRight - 2 * this.dim.directionLabelSpacing;

		this.dim.roseCentroid = [0.5 * this.dim.roseSize + this.dim.directionLabelSpacing + this.dim.marginLeft, 0.5 * this.dim.roseSize + this.dim.directionLabelSpacing + this.dim.marginTop];

		this.dim.outerRadius = 0.5 * this.dim.roseSize - 10;

		this.angleOffset = -180 / this.data.spokes.length;

		this.container.html('');

		this.svg = this.container.append('svg').attr('width', this.dim.totalWidth).attr('height', this.dim.totalHeight);

		this.windRose = this.svg.append('g').attr('transform', 'translate(' + this.dim.roseCentroid[0] + ',' + this.dim.roseCentroid[1] + ')');
	};

	WindRose.prototype._setupScales = function _setupScales() {

		this.thetaScale = Object(src["scaleBand"])().domain(this.data.spokes.map(function (spoke) {
			return spoke.direction;
		})).range([0, 2 * Math.PI]).align(0);

		this.radiusScale = Object(src["scaleLinear"])().domain([0, Object(d3_array_src["max"])(this.data.spokes.map(function (spoke) {
			return Object(d3_array_src["sum"])(spoke.values);
		}))]).range([this.dim.innerRadius, this.dim.outerRadius]);

		this.colourScale = Object(src["scaleOrdinal"])().domain(this.data.categories).range(['#4242f4', '#42c5f4', '#42f4ce', '#42f456', '#adf442', '#f4e242', '#f4a142', '#f44242']);
	};

	WindRose.prototype._renderSpokes = function _renderSpokes() {
		var _this = this;

		var stackLayout = Object(d3_shape_src["stack"])().keys(this.data.categories);

		var stackData = this.data.spokes.map(function (spoke) {
			var item = { direction: spoke.direction };
			_this.data.categories.forEach(function (c, i) {
				item[c] = spoke.values[i];
			});
			return item;
		});

		this.windRose.append('g').attr('class', 'wind-rose-spokes').selectAll('g').data(stackLayout(stackData)).enter().append('g').style('fill', function (d) {
			return _this.colourScale(d.key);
		}).selectAll('path').data(function (d) {
			return d;
		}).enter().append('path').attr('transform', 'rotate(' + this.angleOffset + ')').transition().ease(d3_ease_src["easeBackOut"]).delay(function (d, i) {
			return i * 50;
		}).duration(300).attrTween('d', function (d) {
			// Return function that takes t from 0 to 1 (transition start to end) and generates the
			// arc to render at that time point.
			return function (t) {
				return Object(d3_shape_src["arc"])().innerRadius(t * _this.radiusScale(d[0])).outerRadius(t * _this.radiusScale(d[1])).startAngle(_this.thetaScale(d.data.direction)).endAngle(_this.thetaScale(d.data.direction) + 0.5 * (t + 1) * _this.thetaScale.bandwidth()).padAngle(0.05).padRadius(_this.dim.innerRadius)();
			};
		});
	};

	WindRose.prototype._renderDirectionLines = function _renderDirectionLines() {
		var _this2 = this;

		this.windRose.append('circle').attr('class', 'hw_wind_rose_center').attr('cx', 0).attr('cy', 0).attr('r', this.radiusScale(0));

		var labels = this.windRose.append('g').attr('class', 'hw_wind_rose_labels').selectAll('g').data(this.data.spokes).enter().append('g').attr('text-anchor', 'middle').attr('transform', function (spoke) {
			var angle = rad2deg(_this2.thetaScale(spoke.direction) + 0.5 * _this2.thetaScale.bandwidth()) + _this2.angleOffset - 90;
			return 'rotate(' + angle + ')';
		});

		labels.transition().ease(d3_ease_src["easeCircleOut"]).duration(500).attrTween('transform', function (spoke) {
			var translateX = _this2.dim.outerRadius + _this2.dim.directionLabelSpacing + 5;
			var angle = rad2deg(_this2.thetaScale(spoke.direction) + 0.5 * _this2.thetaScale.bandwidth()) + _this2.angleOffset - 90;
			return function (t) {
				return 'rotate(' + angle + ') translate(' + t * translateX + ',0)';
			};
		});

		labels.append('text').attr('transform', function (spoke) {
			var angle = rad2deg(_this2.thetaScale(spoke.direction) + 0.5 * _this2.thetaScale.bandwidth()) + _this2.angleOffset - 90;
			if (angle < 0 || angle >= 180) {
				return 'translate(0,0) rotate(90)';
			}
			return 'translate(10,0) rotate(270)';
		}).text(function (spoke) {
			return spoke.direction;
		});

		var lines = this.windRose.append('g').attr('class', 'hw_wind_rose_lines').selectAll('line').data(this.data.spokes).enter().append('g').attr('transform', function (spoke) {
			return 'rotate(' + rad2deg(_this2.thetaScale(spoke.direction)) + ')';
		});

		lines.append('line').attr('x1', 0).attr('y1', this.dim.innerRadius).attr('x2', 0).attr('y2', this.dim.innerRadius).transition().ease(d3_ease_src["easeCircleOut"]).duration(500).attrTween('y2', function () {
			var endY = 0.5 * _this2.dim.roseSize + _this2.dim.directionLabelSpacing - 10;
			return function (t) {
				return t * endY;
			};
		});

		lines.append('path').transition().ease(d3_ease_src["easeCircleOut"]).duration(500).attrTween('d', function () {
			var endRadius = 0.5 * _this2.dim.roseSize + _this2.dim.directionLabelSpacing - 10;
			return function (t) {
				return Object(d3_shape_src["arc"])().innerRadius(t * endRadius).outerRadius(t * endRadius).startAngle(deg2rad(-2)).endAngle(deg2rad(2))();
			};
		});
	};

	WindRose.prototype._renderAxis = function _renderAxis() {
		var _this3 = this;

		var ticks = this.windRose.append('g').attr('class', 'hw_wind_rose_axis').attr('text-anchor', 'end').selectAll('text').data(this.radiusScale.ticks(5).slice(1)).enter();

		ticks.append('text').attr('x', -3).attr('y', function (value) {
			return -_this3.radiusScale(value);
		}).attr('dy', '-0.25em').text(function (value) {
			return value;
		});

		ticks.append('circle').attr('class', 'hw_wind_rose_gridline').attr('cx', 0).attr('cy', 0).attr('r', function (value) {
			return _this3.radiusScale(value);
		});
	};

	WindRose.prototype._renderLegend = function _renderLegend() {
		var _this4 = this;

		var boxSize = 16;
		var boxSpacing = 6;

		var legend = this.svg.append('g').attr('class', 'hw_wind_rose_legend').attr('transform', 'translate(' + (this.dim.totalWidth - this.dim.legendWidth) + ',' + this.dim.marginTop + ')');

		var title = legend.append('text').attr('class', 'hw_wind_rose_legend_title');

		title.append('tspan').attr('x', 0).text('Mean wind');

		title.append('tspan').attr('x', 0).attr('dy', '1.2em').text('speed (' + this.unit + ')');

		var legendItems = legend.selectAll('g').data(this.data.categories).enter().append('g').attr('transform', function (d, i) {
			return 'translate(0,' + (24 + i * (boxSize + boxSpacing)) + ')';
		});

		legendItems.append('rect').attr('width', boxSize).attr('height', boxSize).style('fill', function (category) {
			return _this4.colourScale(category);
		});

		var formatLegendValue = function formatLegendValue(value) {
			return Object(formatters["h" /* formatWindGust */])(value, _this4.unit);
		};

		legendItems.append('text').attr('x', boxSize + boxSpacing).attr('y', 0).attr('dy', '1em').text(function (category) {
			if (category[1] === null) {
				return formatLegendValue(category[0]) + '+';
			}
			return category.map(formatLegendValue).join('-');
		});
	};

	return WindRose;
}();

function rad2deg(radians) {
	return 180 * radians / Math.PI;
}

function deg2rad(degrees) {
	return degrees * Math.PI / 180;
}

/* harmony default export */ var wind_rose = (wind_rose_WindRose);
// EXTERNAL MODULE: ./components/handle-loading-and-error/index.js + 1 modules
var handle_loading_and_error = __webpack_require__("/zgt");

// EXTERNAL MODULE: ./components/size-aware/index.js
var size_aware = __webpack_require__("ZnYl");

// EXTERNAL MODULE: ./components/windrose/style.scss
var style = __webpack_require__("zfcO");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./components/windrose/index.js


function windrose__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The WindRose component renders a windrose chart.
 *
 * props:
 * - data: the windrose data from the api.
 * - speedUnit: see SPEED_UNIT
 * - onUpdate: optional callback function called when the wind rose has rendered
 */

var windrose_WindRose = function (_Component) {
	_inherits(WindRose, _Component);

	function WindRose(props) {
		windrose__classCallCheck(this, WindRose);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.windrose = null;
		return _this;
	}

	WindRose.prototype.componentDidMount = function componentDidMount() {
		if (this.props.data) {
			this.update(this.props.data, this.props.speedUnit);
		}
	};

	WindRose.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if (nextProps.data !== this.props.data || nextProps.speedUnit !== this.props.speedUnit) {
			this.update(nextProps.data, nextProps.speedUnit);
		} else if (nextProps.windowWidth !== this.props.windowWidth) {
			this.update(this.props.data, this.props.speedUnit);
		}
	};

	WindRose.prototype.update = function update(data, speedUnit) {
		// If there is data existing, keep the container size constant
		// before destroying and re-rendering so that the page doesn't jump.
		if (this.windrose !== null) {
			var size = this.windroseContainer.getBoundingClientRect();
			this.windroseContainer.style.width = size.width + 'px';
			this.windroseContainer.style.height = size.height + 'px';
		}

		var windrose = new wind_rose(data, speedUnit);
		this.windroseContainer.innerHTML = '';
		windrose.render(this.windroseContainer);

		if (this.props.onUpdate) {
			this.props.onUpdate();
		}

		if (this.windrose !== null) {
			this.windroseContainer.style.width = '';
			this.windroseContainer.style.height = '';
		}

		this.windrose = windrose;
	};

	WindRose.prototype.render = function render(props) {
		var _this2 = this;

		return Object(preact_min["h"])(
			'div',
			null,
			Object(preact_min["h"])('div', { 'class': 'hw_wind_rose', ref: function ref(el) {
					_this2.windroseContainer = el;
				} }),
			Object(preact_min["h"])(
				'p',
				{ 'class': style_default.a.wind_rose_description },
				'The wind rose is a visual representation of wind direction and speed distribution over a certain period of time. Longer bars represent wind directions more prevalent during a period, whilst warmer colours show stronger wind speeds. The numbers on the rings which extend out from the center represent percentages. For instance, a bar which reaches to the ring marked 10 means that the wind blew from that direction 10% of the time during that period. Note that the bars may not sum to 100% as totally calm conditions are not included in the wind rose.'
			)
		);
	};

	return WindRose;
}(preact_min["Component"]);

/* harmony default export */ var components_windrose = __webpack_exports__["a"] = (Object(handle_loading_and_error["a" /* default */])(Object(size_aware["a" /* default */])(windrose_WindRose)));

/***/ }),

/***/ "A/Ka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__("lCuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_constants__ = __webpack_require__("hafV");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The Message component displays a message to the user. Content is supplied through props.children.
 *
 * props:
 * - messageId: id of the message
 * - level: see MESSAGE_LEVEL const
 * - dismiss: callback function for clicking the dismiss button
 * - isDismissable: is the message able to be dismissed
 */

var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { src: '../../assets/icons/material/close.svg', alt: 'close' });

var Message = function (_Component) {
	_inherits(Message, _Component);

	function Message(props) {
		_classCallCheck(this, Message);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.dismiss = _this.dismiss.bind(_this);
		return _this;
	}

	Message.prototype.dismiss = function dismiss(evt) {
		if (evt.type === 'keyup' && evt.keyCode !== 13) {
			return;
		}

		this.props.dismiss(this.props.messageId);
	};

	Message.prototype.renderDismissBtn = function renderDismissBtn() {
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ role: 'button',
				tabIndex: '0',
				'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.close_btn,
				title: 'Dismiss',
				onClick: this.dismiss,
				onKeyUp: this.dismiss },
			_ref
		);
	};

	Message.prototype.render = function render(props) {
		var messageClasses = [__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.message];
		var icon = void 0;

		if (props.level === __WEBPACK_IMPORTED_MODULE_2__utils_constants__["d" /* MESSAGE_LEVEL */].INFO) {

			messageClasses.push(__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.level_info);
			icon = 'info';
		} else if (props.level === __WEBPACK_IMPORTED_MODULE_2__utils_constants__["d" /* MESSAGE_LEVEL */].WARNING) {

			messageClasses.push(__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.level_warning);
			icon = 'warning';
		}

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': messageClasses.join(' ') },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.message_icon },
				icon ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { src: '../../assets/icons/material/' + icon + '.svg', alt: props.level }) : null
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.message_content },
				props.children
			),
			props.isDismissable ? this.renderDismissBtn() : null
		);
	};

	return Message;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Message);

/***/ }),

/***/ "BcOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_constants__ = __webpack_require__("hafV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__("l44Q");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * This component displays a selector for the view mode of observation panelgraphs.
 *
 * props:
 * - activeView: the active panelgraph view (see GRAPH_VIEW enum)
 * - onViewChange: function which gets called when the user selected a different view
 * - exclude: optional array of GRAPH_VIEW values to be excluded from the selector
 * - monthlyRainfall: optionally change the "Daily Rainfall" label to "Monthly Rainfall"
 * - includeWindrose: optionally include a wind rose option
 */

var ObservationsViewSelector = function (_Component) {
	_inherits(ObservationsViewSelector, _Component);

	function ObservationsViewSelector(props) {
		_classCallCheck(this, ObservationsViewSelector);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.options = [{ value: __WEBPACK_IMPORTED_MODULE_1__utils_constants__["c" /* GRAPH_VIEW */].COMBINED, label: 'Overview' }, { value: __WEBPACK_IMPORTED_MODULE_1__utils_constants__["c" /* GRAPH_VIEW */].WIND, label: 'Wind' }, { value: __WEBPACK_IMPORTED_MODULE_1__utils_constants__["c" /* GRAPH_VIEW */].TEMPERATURE, label: 'Temperature' }, { value: __WEBPACK_IMPORTED_MODULE_1__utils_constants__["c" /* GRAPH_VIEW */].RAIN, label: 'Daily Rainfall' }, { value: __WEBPACK_IMPORTED_MODULE_1__utils_constants__["c" /* GRAPH_VIEW */].RAIN_HOURLY, label: 'Hourly Rainfall' }, { value: __WEBPACK_IMPORTED_MODULE_1__utils_constants__["c" /* GRAPH_VIEW */].PRESSURE, label: 'Pressure' }, { value: __WEBPACK_IMPORTED_MODULE_1__utils_constants__["c" /* GRAPH_VIEW */].HUMIDITY, label: 'Humidity' }];

		_this.onViewChange = _this.onViewChange.bind(_this);
		return _this;
	}

	ObservationsViewSelector.prototype.onViewChange = function onViewChange(option) {
		this.props.onViewChange(option.value);
	};

	ObservationsViewSelector.prototype.render = function render(props) {

		var options = props.exclude ? this.options.filter(function (opt) {
			return props.exclude.indexOf(opt.value) === -1;
		}) : [].concat(this.options);

		if (props.monthlyRainfall) {
			var opt = this.options.filter(function (opt) {
				return opt.value === __WEBPACK_IMPORTED_MODULE_1__utils_constants__["c" /* GRAPH_VIEW */].RAIN;
			})[0];
			opt.label = 'Monthly Rainfall';
		}

		if (props.includeWindrose) {
			options.push({
				value: __WEBPACK_IMPORTED_MODULE_1__utils_constants__["c" /* GRAPH_VIEW */].WIND_ROSE,
				label: 'Wind Rose'
			});
		}

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* default */], { options: options,
			selectedValue: props.activeView,
			onOptionSelect: this.onViewChange });
	};

	return ObservationsViewSelector;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ObservationsViewSelector);

/***/ }),

/***/ "C3gn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HighlightHighTemperature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HighlightLowTemperature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HighlightMeanTemperature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HighlightRainfall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HighlightWindGust; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__("3s4+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);



var HighlightHighTemperature = function HighlightHighTemperature(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'span',
		{ 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.high_temperature },
		props.children
	);
};

var HighlightLowTemperature = function HighlightLowTemperature(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'span',
		{ 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.low_temperature },
		props.children
	);
};

var HighlightMeanTemperature = function HighlightMeanTemperature(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'span',
		{ 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.mean_temperature },
		props.children
	);
};

var HighlightRainfall = function HighlightRainfall(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'span',
		{ 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.rainfall },
		props.children
	);
};

var HighlightWindGust = function HighlightWindGust(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'span',
		{ 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.high_wind_gust },
		props.children
	);
};

/***/ }),

/***/ "Cvo2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__("OcWS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);



/**
 * The Loader component displays a loading placeholder.
 *
 * props:
 * - text (optional): the loading message. If not provided, default message is used.
 */
var Loader = function Loader(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.loader },
    props.text || 'Loading'
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),

/***/ "DOAq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dqzv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return convertWindBearing8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertWindBearing16; });
var convertWindBearing = function convertWindBearing(bearing, granularity) {
	var rounded = granularity * Math.round(bearing / granularity);
	switch (rounded) {
		case 0:
		case 360:
			return 'N';
		case 22.5:
			return 'NNE';
		case 45:
			return 'NE';
		case 67.5:
			return 'ENE';
		case 90:
			return 'E';
		case 112.5:
			return 'ESE';
		case 135:
			return 'SE';
		case 157.5:
			return 'SSE';
		case 180:
			return 'S';
		case 202.5:
			return 'SSW';
		case 225:
			return 'SW';
		case 247.5:
			return 'WSW';
		case 270:
			return 'W';
		case 292.5:
			return 'WNW';
		case 315:
			return 'NW';
		case 337.5:
			return 'NNW';
	}
};

var convertWindBearing8 = function convertWindBearing8(bearing) {
	return convertWindBearing(bearing, 45);
};
var convertWindBearing16 = function convertWindBearing16(bearing) {
	return convertWindBearing(bearing, 22.5);
};

/***/ }),

/***/ "FE+1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NoDataNotifyOnMount; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__("iBxh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notify_mounted__ = __webpack_require__("Oqou");




var NoData = function NoData(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.no_data_wrapper },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.no_data },
			props.message || 'No Data Available'
		)
	);
};

var NoDataNotifyOnMount = Object(__WEBPACK_IMPORTED_MODULE_2__notify_mounted__["a" /* default */])(NoData);

/***/ }),

/***/ "J+OV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handle_loading_and_error__ = __webpack_require__("/zgt");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The ObservationsPanelGraph component wraps the panel graph functionality,
 * providing options to select different parameter views.
 *
 * props:
 * - view: The panelgraph view to render (see GRAPH_VIEW enum). Defaults to COMBINED
 * - data: The dataset to render in the panelgraph
 */

var ObservationsPanelGraph = function (_Component) {
	_inherits(ObservationsPanelGraph, _Component);

	function ObservationsPanelGraph(props, context) {
		_classCallCheck(this, ObservationsPanelGraph);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

		_this.units = context.userSettings.units;
		_this.graphContainer = null;
		_this.graphContainerWidth = -1;
		_this.graph = null;
		return _this;
	}

	ObservationsPanelGraph.prototype.updateGraph = function updateGraph(props) {
		this.graph = props.factory(props.data, this.units, props.view, this.graphContainerWidth);
		this.graph.render(this.graphContainer);
	};

	ObservationsPanelGraph.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		this.graphContainerWidth = this.graphContainer.getBoundingClientRect().width;

		this.updateGraph(this.props);

		this.resizeHandlerId = this.context.resize.addHandler(function () {

			var width = _this2.graphContainer.getBoundingClientRect().width;

			// Only re-render the graph if the container width has actually changed.
			if (width !== _this2.graphContainerWidth) {
				_this2.graphContainerWidth = width;
				_this2.updateGraph(_this2.props);
			}
		});

		// Create a touch handler on document which will hide the tooltips if an element
		// that is not the chart event capturing box is touched. This is to handle the case
		// on touch devices where no mouseout event is fired and in some cases no blur event
		// is fired either.
		this.documentTouchHandler = function (evt) {
			if (evt.target !== _this2.graph.eventCapturingBox) {
				_this2.graph.hideTooltips();
			}
		};

		document.addEventListener('touchstart', this.documentTouchHandler);

		if (typeof this.props.mounted === 'function') {
			this.props.mounted();
		}
	};

	ObservationsPanelGraph.prototype.componentWillUnmount = function componentWillUnmount() {
		this.context.resize.removeHandler(this.resizeHandlerId);

		document.removeEventListener('touchstart', this.documentTouchHandler);
	};

	ObservationsPanelGraph.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		this.updateGraph(nextProps);
	};

	ObservationsPanelGraph.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
		return false;
	};

	ObservationsPanelGraph.prototype.render = function render() {
		var _this3 = this;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { 'class': 'hw_panel_graph', ref: function ref(el) {
				_this3.graphContainer = el;
			} });
	};

	return ObservationsPanelGraph;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__handle_loading_and_error__["a" /* default */])(ObservationsPanelGraph));

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/normalize.css/normalize.css
var normalize = __webpack_require__("DOAq");
var normalize_default = /*#__PURE__*/__webpack_require__.n(normalize);

// EXTERNAL MODULE: ./style/index.scss
var style = __webpack_require__("yY49");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ../node_modules/preact-cli/lib/components/async.js
var components_async = __webpack_require__("7N8r");
var async_default = /*#__PURE__*/__webpack_require__.n(components_async);

// CONCATENATED MODULE: ./routes/live/index.js

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(0).then((function (require) {
				cb( __webpack_require__("hS0J") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var live = (async_default()(load));
	
// CONCATENATED MODULE: ./routes/news/index.js

		

		function news_load(cb) {
			__webpack_require__.e/* require.ensure */(11).then((function (require) {
				cb( __webpack_require__("+1X0") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var news = (async_default()(news_load));
	
// CONCATENATED MODULE: ./routes/about/index.js

		

		function about_load(cb) {
			__webpack_require__.e/* require.ensure */(9).then((function (require) {
				cb( __webpack_require__("LOGg") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var about = (async_default()(about_load));
	
// CONCATENATED MODULE: ./routes/graphs/index.js

		

		function graphs_load(cb) {
			__webpack_require__.e/* require.ensure */(8).then((function (require) {
				cb( __webpack_require__("Kjbg") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var graphs = (async_default()(graphs_load));
	
// CONCATENATED MODULE: ./routes/history-daily/index.js

		

		function history_daily_load(cb) {
			__webpack_require__.e/* require.ensure */(2).then((function (require) {
				cb( __webpack_require__("LMrL") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var history_daily = (async_default()(history_daily_load));
	
// CONCATENATED MODULE: ./routes/history-records/index.js

		

		function history_records_load(cb) {
			__webpack_require__.e/* require.ensure */(6).then((function (require) {
				cb( __webpack_require__("5/M7") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var history_records = (async_default()(history_records_load));
	
// CONCATENATED MODULE: ./routes/history-monthly/index.js

		

		function history_monthly_load(cb) {
			__webpack_require__.e/* require.ensure */(3).then((function (require) {
				cb( __webpack_require__("nFh7") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var history_monthly = (async_default()(history_monthly_load));
	
// CONCATENATED MODULE: ./routes/history-yearly/index.js

		

		function history_yearly_load(cb) {
			__webpack_require__.e/* require.ensure */(4).then((function (require) {
				cb( __webpack_require__("badE") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var history_yearly = (async_default()(history_yearly_load));
	
// CONCATENATED MODULE: ./routes/history-download/index.js

		

		function history_download_load(cb) {
			__webpack_require__.e/* require.ensure */(1).then((function (require) {
				cb( __webpack_require__("qYaS") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var history_download = (async_default()(history_download_load));
	
// CONCATENATED MODULE: ./routes/history-rainfall/index.js

		

		function history_rainfall_load(cb) {
			__webpack_require__.e/* require.ensure */(10).then((function (require) {
				cb( __webpack_require__("iBO4") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var history_rainfall = (async_default()(history_rainfall_load));
	
// CONCATENATED MODULE: ./routes/not-found/index.js

		

		function not_found_load(cb) {
			__webpack_require__.e/* require.ensure */(12).then((function (require) {
				cb( __webpack_require__("LOzz") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var not_found = (async_default()(not_found_load));
	
// EXTERNAL MODULE: ./components/header/style.scss
var header_style = __webpack_require__("/Umn");
var header_style_default = /*#__PURE__*/__webpack_require__.n(header_style);

// CONCATENATED MODULE: ./components/header/index.js



/**
 * The Header component displays the header of the website.
 *
 * props: none
 */

var _ref = Object(preact_min["h"])(
  'h1',
  null,
  'Howick Weather Station'
);

var header_Header = function Header() {
  return Object(preact_min["h"])(
    'header',
    { 'class': header_style_default.a.header },
    _ref
  );
};

/* harmony default export */ var header = (header_Header);
// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var preact_router_match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(preact_router_match);

// EXTERNAL MODULE: ./components/navigation/style.scss
var navigation_style = __webpack_require__("+vFT");
var navigation_style_default = /*#__PURE__*/__webpack_require__.n(navigation_style);

// EXTERNAL MODULE: ./components/size-aware/index.js
var size_aware = __webpack_require__("ZnYl");

// CONCATENATED MODULE: ./components/navigation/submenu.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * The SubMenu component renders a submenu with functionality to indicate
 * to the parent component when it should be expanded or collapsed.
 *
 * props:
 * - isExpanded: whether the submenu should be expanded or not
 * - cssClass: additional cssClass to include on the submenu <ul> element
 * - activeUrl: the currently active url within the application
 * - items: the submenu items data. An array containing objects like `{ route: '/about', label: 'About' }
 */

var submenu_SubMenu = function (_Component) {
	_inherits(SubMenu, _Component);

	function SubMenu(props) {
		_classCallCheck(this, SubMenu);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.itemFocus = _this.itemFocus.bind(_this);
		_this.itemClick = _this.itemClick.bind(_this);
		_this.itemBlur = _this.itemBlur.bind(_this);
		_this.itemKeyDown = _this.itemKeyDown.bind(_this);
		return _this;
	}

	SubMenu.prototype.emit = function emit(isExpanded) {
		if (this.props.isExpanded !== isExpanded) {
			this.props.stateChange(isExpanded);
		}
	};

	// When a submenu item is focused, make sure the menu is expanded.


	SubMenu.prototype.itemFocus = function itemFocus(evt) {
		// Check if the related target is not null. This fixes strange behaviour where blurring the browser
		// window closes the submenu and then returning to the window re-opens the submenu.
		if (evt.relatedTarget !== null) {
			this.emit(true);
		}
	};

	// When a submenu item is clicked, make sure the menu is collapsed.
	// It's more expected behaviour that when a link is clicked the menu closes.


	SubMenu.prototype.itemClick = function itemClick() {
		this.emit(false);
	};

	// When a submenu item is blurred, make sure the menu is collapsed
	// if the next item in itemFocus is outside the submenu.


	SubMenu.prototype.itemBlur = function itemBlur(evt) {
		if (!this.submenuContainer.contains(evt.relatedTarget)) {
			this.emit(false);
		}
	};

	// When a submenu item is in focus and the enter key is pressed, make sure the
	// menu is collapsed. This situation occurs if the user is tabbing through the menu.
	// They can press enter to follow a link.


	SubMenu.prototype.itemKeyDown = function itemKeyDown(evt) {
		if (evt.keyCode === 13) {
			this.emit(false);
		}
	};

	SubMenu.prototype.isActive = function isActive(item) {
		if (item.pattern) {
			return item.pattern.test(this.props.activeUrl);
		}

		return this.props.activeUrl === item.route;
	};

	SubMenu.prototype.render = function render(props) {
		var _this2 = this;

		var cssClasses = [navigation_style_default.a.submenu_items];

		if (props.cssClass) {
			cssClasses.push(props.cssClass);
		}

		return Object(preact_min["h"])(
			'ul',
			{ 'class': cssClasses.join(' '), ref: function ref(el) {
					_this2.submenuContainer = el;
				} },
			this.props.items.map(function (item) {
				return Object(preact_min["h"])(
					'li',
					null,
					Object(preact_min["h"])(
						'a',
						{ 'class': _this2.isActive(item) ? navigation_style_default.a.active : null,
							href: item.route,
							onClick: _this2.itemClick,
							onKeyDown: _this2.itemKeyDown,
							onBlur: _this2.itemBlur,
							onFocus: _this2.itemFocus },
						item.label
					)
				);
			})
		);
	};

	return SubMenu;
}(preact_min["Component"]);

/* harmony default export */ var submenu = (submenu_SubMenu);
// EXTERNAL MODULE: ./components/icons/dropdown.js
var dropdown = __webpack_require__("lHSP");

// CONCATENATED MODULE: ./components/navigation/index.js


function navigation__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function navigation__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function navigation__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









/**
 * The Navigation component takes care of the app navigation. It provides
 * a fully functional accessible menu with a dropdown submenu for the history
 * section, and on small screens the last several items become grouped in
 * a generic More items submenu.
 *
 * props:
 * - activeUrl: the currently active url in the application
 */

var navigation__ref = Object(preact_min["h"])('img', { src: '../../assets/icons/material/more-vert.svg', alt: '' });

var _ref2 = Object(preact_min["h"])('img', { src: '../../assets/icons/material/settings.svg', alt: 'Settings' });

var _ref3 = Object(preact_min["h"])(
	'span',
	null,
	'History'
);

var _ref4 = Object(preact_min["h"])(dropdown["a" /* default */], { fill: 'white' });

var navigation_Navigation = function (_Component) {
	navigation__inherits(Navigation, _Component);

	function Navigation(props) {
		navigation__classCallCheck(this, Navigation);

		var _this = navigation__possibleConstructorReturn(this, _Component.call(this, props));

		_this.toggleMoreItems = _this.toggleMoreItems.bind(_this);
		_this.toggleHistoryItems = _this.toggleHistoryItems.bind(_this);
		_this.moreItemsMouseover = _this.moreItemsMouseover.bind(_this);
		_this.moreItemsMouseout = _this.moreItemsMouseout.bind(_this);
		_this.historyMouseover = _this.historyMouseover.bind(_this);
		_this.historyMouseout = _this.historyMouseout.bind(_this);

		_this.state = {
			isHistoryExpanded: false,
			isMoreItemsExpanded: false
		};

		_this.moreItemsData = [{ route: '/about', label: 'About' }, { route: '/news', label: 'News' }, { route: '/settings', label: 'Settings' }];

		_this.historyItemsData = [{
			route: '/history-daily',
			label: 'Daily',
			pattern: /^\/history-daily(\/[0-9]{4}-[0-9]{2}-[0-9]{2})?$/
		}, {
			route: '/history-monthly',
			label: 'Monthly',
			pattern: /^\/history-monthly(\/(january|february|march|april|may|june|july|august|september|october|november|december)-[0-9]{4})?$/
		}, {
			route: '/history-yearly',
			label: 'Yearly',
			pattern: /^\/history-yearly(\/[0-9]{4})?$/
		}, {
			route: '/history-records/overall',
			label: 'Records',
			pattern: /^\/history-records\/(overall|top-ten|monthly(\/(january|february|march|april|may|june|july|august|september|october|november|december))?)$/
		}, {
			route: '/history-climate',
			label: 'Climate'
		}, {
			route: '/history-rainfall',
			label: 'Rainfall'
		}, {
			route: '/history-download/daily',
			label: 'Download',
			pattern: /^\/history-download\/(daily|monthly|observations)$/
		}];

		return _this;
	}

	Navigation.prototype.toggleMoreItems = function toggleMoreItems(isMoreItemsExpanded) {
		this.setState({ isMoreItemsExpanded: isMoreItemsExpanded });
	};

	Navigation.prototype.toggleHistoryItems = function toggleHistoryItems(isHistoryExpanded) {
		this.setState({ isHistoryExpanded: isHistoryExpanded });
	};

	// When the more items menu is moused over, expand it.


	Navigation.prototype.moreItemsMouseover = function moreItemsMouseover() {
		if (!this.state.isMoreItemsExpanded) {
			this.toggleMoreItems(true);
		}
	};

	// When the more items menu is moused out, collapse it.


	Navigation.prototype.moreItemsMouseout = function moreItemsMouseout(evt) {
		if (!document.querySelector('#hw_more_items_submenu').contains(evt.relatedTarget)) {
			this.toggleMoreItems(false);
		}
	};

	Navigation.prototype.historyMouseover = function historyMouseover() {
		if (!this.state.isHistoryExpanded) {
			this.toggleHistoryItems(true);
		}
	};

	Navigation.prototype.historyMouseout = function historyMouseout(evt) {
		if (!document.querySelector('#hw_history_submenu').contains(evt.relatedTarget)) {
			this.toggleHistoryItems(false);
		}
	};

	Navigation.prototype.render = function render(props) {

		var moreItems = void 0;

		if (props.windowWidth < 450) {

			var moreItemsSubmenuClasses = [navigation_style_default.a.submenu];
			if (this.state.isMoreItemsExpanded) {
				moreItemsSubmenuClasses.push(navigation_style_default.a.open);
			}

			moreItems = Object(preact_min["h"])(
				'li',
				{ 'class': moreItemsSubmenuClasses.join(' '),
					id: 'hw_more_items_submenu',
					onMouseOver: this.moreItemsMouseover,
					onMouseOut: this.moreItemsMouseout },
				Object(preact_min["h"])(
					'span',
					{ 'class': navigation_style_default.a.submenu_header, onClick: this.moreItemsMouseover },
					Object(preact_min["h"])(
						'span',
						{ 'class': navigation_style_default.a.submenu_dropdown },
						navigation__ref
					)
				),
				Object(preact_min["h"])(submenu, { items: this.moreItemsData,
					cssClass: navigation_style_default.a.more_links,
					activeUrl: props.activeUrl,
					isExpanded: this.state.isMoreItemsExpanded,
					stateChange: this.toggleMoreItems })
			);
		} else {

			moreItems = [Object(preact_min["h"])(
				'li',
				null,
				Object(preact_min["h"])(
					preact_router_match["Link"],
					{ activeClassName: navigation_style_default.a.active, href: '/about' },
					'About'
				)
			), Object(preact_min["h"])(
				'li',
				null,
				Object(preact_min["h"])(
					preact_router_match["Link"],
					{ activeClassName: navigation_style_default.a.active, href: '/news' },
					'News'
				)
			), Object(preact_min["h"])(
				'li',
				null,
				Object(preact_min["h"])(
					preact_router_match["Link"],
					{ activeClassName: navigation_style_default.a.active, href: '/settings' },
					_ref2
				)
			)];
		}

		var isHistoryActive = false;

		for (var i = 0, n = this.historyItemsData.length; i < n; i++) {
			var item = this.historyItemsData[i];
			if (item.pattern && item.pattern.test(props.activeUrl) || item.route === props.activeUrl) {
				isHistoryActive = true;
				break;
			}
		}

		var historyHeaderClasses = [navigation_style_default.a.submenu_header];

		if (isHistoryActive) {
			historyHeaderClasses.push(navigation_style_default.a.active);
		}

		var historySubmenuClasses = [navigation_style_default.a.submenu];
		if (this.state.isHistoryExpanded) {
			historySubmenuClasses.push(navigation_style_default.a.open);
		}

		return Object(preact_min["h"])(
			'nav',
			{ 'class': navigation_style_default.a.navigation },
			Object(preact_min["h"])(
				'ul',
				null,
				Object(preact_min["h"])(
					'li',
					null,
					Object(preact_min["h"])(
						preact_router_match["Link"],
						{ activeClassName: navigation_style_default.a.active, href: '/' },
						'Live'
					)
				),
				Object(preact_min["h"])(
					'li',
					null,
					Object(preact_min["h"])(
						preact_router_match["Link"],
						{ activeClassName: navigation_style_default.a.active, href: '/graphs' },
						'Graphs'
					)
				),
				Object(preact_min["h"])(
					'li',
					{ 'class': historySubmenuClasses.join(' '),
						id: 'hw_history_submenu',
						onMouseOver: this.historyMouseover,
						onMouseOut: this.historyMouseout },
					Object(preact_min["h"])(
						'span',
						{ 'class': historyHeaderClasses.join(' '), onClick: this.historyMouseover },
						_ref3,
						Object(preact_min["h"])(
							'span',
							{ 'class': navigation_style_default.a.submenu_dropdown },
							_ref4
						)
					),
					Object(preact_min["h"])(submenu, { items: this.historyItemsData,
						cssClass: navigation_style_default.a.history_links,
						activeUrl: props.activeUrl,
						isExpanded: this.state.isHistoryExpanded,
						stateChange: this.toggleHistoryItems })
				),
				moreItems
			)
		);
	};

	return Navigation;
}(preact_min["Component"]);

/* harmony default export */ var navigation = (Object(size_aware["a" /* default */])(navigation_Navigation));
// EXTERNAL MODULE: ../node_modules/debounce/index.js
var debounce = __webpack_require__("dLxY");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// CONCATENATED MODULE: ./utils/resize-events.js


/**
 * This utility allows as many window resize handlers to be registered as required,
 * while only registering 2 event listeners on the window object (one for resize and
 * one for orientationchange).
 */

var resize_events_getResizeEventsHelper = function getResizeEventsHelper() {

	var resizeEvents = {

		_callbacks: [],
		_callbackId: 0,

		_resizeHandler: Object(debounce["debounce"])(function (evt) {
			resizeEvents._callbacks.forEach(function (callback) {
				return callback.handler(evt);
			});
		}, 200),

		_orientationChangeHandler: function _orientationChangeHandler(evt) {
			setTimeout(function () {
				resizeEvents._callbacks.forEach(function (callback) {
					return callback.handler(evt);
				});
			}, 500);
		},

		_register: function _register() {
			window.addEventListener('resize', this._resizeHandler);
			window.addEventListener('orientationchange', this._orientationChangeHandler);
		},
		_deregister: function _deregister() {
			window.removeEventListener('resize', this._resizeHandler);
			window.removeEventListener('orientationchange', this._orientationChangeHandler);
		},
		addHandler: function addHandler(handler) {
			// Increment id - each callback needs a unique id
			var id = this._callbackId++;

			// Add the callback into the list
			this._callbacks.push({ id: id, handler: handler });

			// If we have just gone from 0 callbacks to one, register the event handlers
			if (this._callbacks.length === 1) {
				this._register();
			}

			return id;
		},
		removeHandler: function removeHandler(callbackId) {
			// Find the index in the callbacks list corresponding to the provided id
			var index = this._callbacks.map(function (callback) {
				return callback.id;
			}).indexOf(callbackId);

			// If callback was found, remove it
			if (index !== -1) {
				this._callbacks.splice(index, 1);
			}

			// If there are no callbacks left, deregister the event handlers
			if (this._callbacks.length === 0) {
				this._deregister();
			}
		}
	};

	return resizeEvents;
};
// EXTERNAL MODULE: ./utils/user-settings.js + 1 modules
var user_settings = __webpack_require__("6XQo");

// CONCATENATED MODULE: ./routes/history-climate/index.js

		

		function history_climate_load(cb) {
			__webpack_require__.e/* require.ensure */(7).then((function (require) {
				cb( __webpack_require__("aD/H") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var history_climate = (async_default()(history_climate_load));
	
// CONCATENATED MODULE: ./routes/settings/index.js

		

		function settings_load(cb) {
			__webpack_require__.e/* require.ensure */(5).then((function (require) {
				cb( __webpack_require__("i8EF") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var settings = (async_default()(settings_load));
	
// EXTERNAL MODULE: ./utils/api.js
var api = __webpack_require__("/R+W");

// EXTERNAL MODULE: ./utils/request-idle-callback.js
var request_idle_callback = __webpack_require__("hVjA");

// EXTERNAL MODULE: ./components/message/message.js
var message_message = __webpack_require__("A/Ka");

// EXTERNAL MODULE: ./utils/tracking.js
var tracking = __webpack_require__("x4D6");

// CONCATENATED MODULE: ./components/global-message-list/index.js


function global_message_list__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function global_message_list__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function global_message_list__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The GlobalMessageList component displays any messages currently available from the API.
 * It allows messages to be dismissed in the UI if the message data specifies this.
 *
 * props: none
 */

var global_message_list_GlobalMessageList = function (_Component) {
	global_message_list__inherits(GlobalMessageList, _Component);

	function GlobalMessageList(props, context) {
		global_message_list__classCallCheck(this, GlobalMessageList);

		var _this = global_message_list__possibleConstructorReturn(this, _Component.call(this, props, context));

		_this.state = {
			messages: null
		};

		_this.linkRegex = /<%link:([^:]+):([^(?:%>)]+)%>/g;
		_this.savedMessageState = null;

		_this.dismiss = _this.dismiss.bind(_this);
		return _this;
	}

	GlobalMessageList.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		Object(api["j" /* fetchMessages */])().promise.then(function (res) {

			// Later messages come first.
			var messages = res.data;
			messages.sort(function (m1, m2) {
				return m2.id - m1.id;
			});

			try {
				_this2.savedMessageState = JSON.parse(window.localStorage.getItem('messages')) || [];
			} catch (e) {
				_this2.savedMessageState = [];
			}

			var messagesToShow = messages.filter(function (msg) {

				var msgState = _this2.savedMessageState.filter(function (item) {
					return item.id === msg.id;
				})[0];

				if (msgState !== undefined) {
					// If an item is found in local storage, the message is seen.
					// We verify it has not been previously dismissed, and the message itself is
					// not hidden once seen.
					return msgState.isDismissed !== true && msg.hideOnceSeen !== true;
				}

				// If it's not in local storage, user hasn't seen it before.
				return true;
			});

			_this2.setState({ messages: messagesToShow });

			messagesToShow.forEach(function (msg) {

				// mark items seen in local storage
				var msgState = _this2.savedMessageState.filter(function (item) {
					return item.id === msg.id;
				})[0];

				if (msgState === undefined) {
					_this2.savedMessageState.push({
						id: msg.id,
						isSeen: true,
						isDismissed: false
					});
				}
			});

			// remove expired items from local storage
			var activeIds = messagesToShow.map(function (msg) {
				return msg.id;
			});

			_this2.savedMessageState = _this2.savedMessageState.filter(function (msgState) {
				return activeIds.indexOf(msgState.id) !== -1;
			});

			if (messagesToShow.length > 0) {
				// Save local storage
				_this2.persistSavedMessageState();
			}
		});
	};

	GlobalMessageList.prototype.dismiss = function dismiss(messageId) {
		this.setState(function (state) {
			var messages = state.messages.filter(function (msg) {
				return msg.id !== messageId;
			});
			return { messages: messages };
		});

		var msgState = this.savedMessageState.filter(function (s) {
			return s.id === messageId;
		})[0];

		msgState.isDismissed = true;

		this.context.tracking.recordEvent(tracking["a" /* EVENT_ACTION */].DISMISS_MESSAGE, tracking["b" /* EVENT_CATEGORY */].SETTINGS, 'id: ' + messageId);

		this.persistSavedMessageState();
	};

	GlobalMessageList.prototype.persistSavedMessageState = function persistSavedMessageState() {
		var _this3 = this;

		Object(request_idle_callback["a" /* requestIdleCallbackWithFallback */])(function () {
			try {
				window.localStorage.setItem('messages', JSON.stringify(_this3.savedMessageState));
			} catch (err) {
				_this3.context.tracking.recordException('Error saving messages state', err);
			}
		});
	};

	GlobalMessageList.prototype.render = function render() {
		var _this4 = this;

		if (this.state.messages === null) {
			return null;
		}

		var messages = this.state.messages.map(function (message) {

			var linkMatch = void 0;
			var linkMatches = [];

			// collect all links inside the message content
			do {

				linkMatch = _this4.linkRegex.exec(message.content);
				if (linkMatch) {
					linkMatches.push(linkMatch);
				}
			} while (linkMatch);

			var content = void 0;

			if (linkMatches.length === 0) {

				// No links found. Just return the message content.
				content = Object(preact_min["h"])(
					'span',
					null,
					message.content
				);
			} else {

				content = [];
				var index = 0;

				linkMatches.forEach(function (match) {

					// There is non-link content preceding this link, so first add this to the contents array.
					if (index < match.index) {
						content.push(Object(preact_min["h"])(
							'span',
							null,
							message.content.substring(index, match.index)
						));
					}

					// Now add the link to the contents array.
					content.push(Object(preact_min["h"])(
						'a',
						{ href: match[1] },
						match[2]
					));

					// Update the index to the character following the end of the link.
					index = match.index + match[0].length;
				});

				// Check if there is non-link content remaining at the end of the message, and if so, add it
				// to the content list.
				if (index < message.content.length) {
					content.push(Object(preact_min["h"])(
						'span',
						null,
						message.content.slice(index)
					));
				}
			}

			return Object(preact_min["h"])(
				message_message["a" /* default */],
				{ key: message.id, level: message.level, isDismissable: message.isDismissable, messageId: message.id, dismiss: _this4.dismiss },
				content
			);
		});

		return messages.length > 0 ? Object(preact_min["h"])(
			'div',
			null,
			messages
		) : null;
	};

	return GlobalMessageList;
}(preact_min["Component"]);

/* harmony default export */ var global_message_list = (global_message_list_GlobalMessageList);
// EXTERNAL MODULE: ./components/app.scss
var app = __webpack_require__("Wjq/");
var app_default = /*#__PURE__*/__webpack_require__.n(app);

// CONCATENATED MODULE: ./utils/title-service.js
var TitleService = function TitleService() {
	return {
		update: function update(pageName) {
			document.title = "Howick Weather | " + pageName;
		}
	};
};
// EXTERNAL MODULE: ./components/footer/style.scss
var footer_style = __webpack_require__("R99g");
var footer_style_default = /*#__PURE__*/__webpack_require__.n(footer_style);

// CONCATENATED MODULE: ./components/footer/index.js



/**
 * The Footer component displays the website footer, with copyright and build version.
 */
var footer_Footer = function Footer() {

	var year = new Date().getFullYear();
	var version = window.HowickWeather.version;

	return Object(preact_min["h"])(
		'footer',
		{ 'class': footer_style_default.a.footer },
		Object(preact_min["h"])(
			'div',
			null,
			'Copyright \xA9 ',
			year,
			' howickweather.co.nz'
		),
		Object(preact_min["h"])(
			'div',
			null,
			'Version: ',
			Object(preact_min["h"])(
				'strong',
				null,
				version
			)
		)
	);
};

/* harmony default export */ var footer = (footer_Footer);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__("hafV");

// CONCATENATED MODULE: ./components/offline-message/index.js




/**
 * Displays a message that the user is offline
 * props: none
 */
var offline_message_OfflineMessage = function OfflineMessage() {
  return Object(preact_min["h"])(
    message_message["a" /* default */],
    { level: constants["d" /* MESSAGE_LEVEL */].WARNING },
    'It appears you are offline. Weather data can\'t be loaded while offline, so please retry when you\'re back online.'
  );
};

/* harmony default export */ var offline_message = (offline_message_OfflineMessage);
// CONCATENATED MODULE: ./components/app.js


function app__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function app__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function app__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





























var app__ref = Object(preact_min["h"])(header, null);

var app__ref2 = Object(preact_min["h"])(offline_message, null);

var app__ref3 = Object(preact_min["h"])(global_message_list, null);

var app__ref4 = Object(preact_min["h"])(graphs, { path: '/graphs' });

var _ref5 = Object(preact_min["h"])(history_daily, { path: '/history-daily/:date?' });

var _ref6 = Object(preact_min["h"])(history_monthly, { path: '/history-monthly/:month?' });

var _ref7 = Object(preact_min["h"])(history_yearly, { path: '/history-yearly/:year?' });

var _ref8 = Object(preact_min["h"])(history_records, { path: '/history-records/:view/:subview?' });

var _ref9 = Object(preact_min["h"])(history_rainfall, { path: '/history-rainfall' });

var _ref10 = Object(preact_min["h"])(history_climate, { path: '/history-climate' });

var _ref11 = Object(preact_min["h"])(history_download, { path: '/history-download/:view' });

var _ref12 = Object(preact_min["h"])(about, { path: '/about' });

var _ref13 = Object(preact_min["h"])(news, { path: '/news' });

var _ref14 = Object(preact_min["h"])(settings, { path: '/settings' });

var _ref15 = Object(preact_min["h"])(not_found, { path: '/not-found' });

var _ref16 = Object(preact_min["h"])(not_found, { 'default': true });

var _ref17 = Object(preact_min["h"])(footer, null);

var app_App = function (_Component) {
	app__inherits(App, _Component);

	function App(props) {
		app__classCallCheck(this, App);

		var _this = app__possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			activeUrl: window.location.pathname,
			isOnline: 'onLine' in window.navigator ? window.navigator.onLine : true,
			monthlyHistoryView: null
		};

		_this.handleRouteChange = _this.handleRouteChange.bind(_this);

		_this.tracking = Object(tracking["c" /* Tracker */])();
		_this.titleService = TitleService();
		_this.resizeEvents = resize_events_getResizeEventsHelper();
		_this.userSettings = Object(user_settings["b" /* getUserSettings */])(_this.tracking);
		_this.monthlyHistoryView = {
			set: function set(view) {
				return _this.setMonthlyHistoryView(view);
			},
			get: function get() {
				return _this.state.monthlyHistoryView;
			}
		};
		return _this;
	}

	App.prototype.handleRouteChange = function handleRouteChange(evt) {
		this.setState({ activeUrl: evt.url });
	};

	App.prototype.setMonthlyHistoryView = function setMonthlyHistoryView(view) {
		this.setState({ monthlyHistoryView: view });
	};

	App.prototype.getChildContext = function getChildContext() {
		var _this2 = this;

		return {

			resize: this.resizeEvents,
			userSettings: this.userSettings,
			tracking: this.tracking,
			titleService: this.titleService,
			monthlyHistoryView: this.monthlyHistoryView,

			// provide callback for updating units, to minimise local storage reads
			onUnitUpdate: function onUnitUpdate() {
				_this2.userSettings = Object(user_settings["b" /* getUserSettings */])(_this2.tracking);
			}

		};
	};

	App.prototype.componentDidMount = function componentDidMount() {
		var _this3 = this;

		// Remove splash screen from DOM
		var splash = document.getElementById('hw_splash_screen');
		splash.parentNode.removeChild(splash);
		var splashCss = document.getElementById('hw_splash_screen_styles');
		splashCss.parentNode.removeChild(splashCss);

		window.addEventListener('offline', function () {
			_this3.setState({ isOnline: false });
		});

		window.addEventListener('online', function () {
			_this3.setState({ isOnline: true });
		});
	};

	App.prototype.render = function render() {
		return Object(preact_min["h"])(
			'div',
			{ 'class': app_default.a.page },
			app__ref,
			Object(preact_min["h"])(navigation, { activeUrl: this.state.activeUrl }),
			Object(preact_min["h"])(
				'div',
				{ 'class': app_default.a.content_wrapper },
				this.state.isOnline ? null : app__ref2,
				app__ref3,
				Object(preact_min["h"])(
					'div',
					{ 'class': app_default.a.content },
					Object(preact_min["h"])(
						preact_router_es["Router"],
						{ onChange: this.handleRouteChange },
						Object(preact_min["h"])(live, { path: '/', isOnline: this.state.isOnline }),
						app__ref4,
						_ref5,
						_ref6,
						_ref7,
						_ref8,
						_ref9,
						_ref10,
						_ref11,
						_ref12,
						_ref13,
						_ref14,
						_ref15,
						_ref16
					)
				)
			),
			_ref17
		);
	};

	return App;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./index.js




/* harmony default export */ var index_0 = __webpack_exports__["default"] = (app_App);

/***/ }),

/***/ "Jxom":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"selector_wrapper":"selector_wrapper__37DQi"};

/***/ }),

/***/ "KM04":
/***/ (function(module, exports) {

!function () {
  var n,
      l,
      u,
      t,
      i,
      o,
      r,
      f,
      e,
      c = {},
      a = [],
      s = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;function h(n, l) {
    for (var u in l) {
      n[u] = l[u];
    }return n;
  }function v(n) {
    var l = n.parentNode;l && l.removeChild(n);
  }function y(l, u, t) {
    var i,
        o,
        r,
        f = {};for (r in u) {
      "key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    }if (arguments.length > 2 && (f.children = arguments.length > 3 ? n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for (r in l.defaultProps) {
      void 0 === f[r] && (f[r] = l.defaultProps[r]);
    }return d(l, f, i, o, null);
  }function d(n, t, i, o, r) {
    var f = { type: n, props: t, key: i, ref: o, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: null == r ? ++u : r };return null == r && null != l.vnode && l.vnode(f), f;
  }function p(n) {
    return n.children;
  }function _(n, l) {
    this.props = n, this.context = l;
  }function m(n, l) {
    if (null == l) return n.__ ? m(n.__, n.__.__k.indexOf(n) + 1) : null;for (var u; l < n.__k.length; l++) {
      if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    }return "function" == typeof n.type ? m(n) : null;
  }function k(n) {
    var l, u;if (null != (n = n.__) && null != n.__c) {
      for (n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++) {
        if (null != (u = n.__k[l]) && null != u.__e) {
          n.__e = n.__c.base = u.__e;break;
        }
      }return k(n);
    }
  }function b(n) {
    (!n.__d && (n.__d = !0) && i.push(n) && !g.__r++ || r !== l.debounceRendering) && ((r = l.debounceRendering) || o)(g);
  }function g() {
    for (var n; g.__r = i.length;) {
      n = i.sort(function (n, l) {
        return n.__v.__b - l.__v.__b;
      }), i = [], n.some(function (n) {
        var l, u, t, i, o, r;n.__d && (o = (i = (l = n).__v).__e, (r = l.__P) && (u = [], (t = h({}, i)).__v = i.__v + 1, I(r, i, t, l.__n, void 0 !== r.ownerSVGElement, null != i.__h ? [o] : null, u, null == o ? m(i) : o, i.__h), T(u, i), i.__e != o && k(i)));
      });
    }
  }function w(n, l, u, t, i, o, r, f, e, s) {
    var h,
        v,
        y,
        _,
        k,
        b,
        g,
        w = t && t.__k || a,
        A = w.length;for (u.__k = [], h = 0; h < l.length; h++) {
      if (null != (_ = u.__k[h] = null == (_ = l[h]) || "boolean" == typeof _ ? null : "string" == typeof _ || "number" == typeof _ || "bigint" == typeof _ ? d(null, _, null, null, _) : Array.isArray(_) ? d(p, { children: _ }, null, null, null) : _.__b > 0 ? d(_.type, _.props, _.key, null, _.__v) : _)) {
        if (_.__ = u, _.__b = u.__b + 1, null === (y = w[h]) || y && _.key == y.key && _.type === y.type) w[h] = void 0;else for (v = 0; v < A; v++) {
          if ((y = w[v]) && _.key == y.key && _.type === y.type) {
            w[v] = void 0;break;
          }y = null;
        }I(n, _, y = y || c, i, o, r, f, e, s), k = _.__e, (v = _.ref) && y.ref != v && (g || (g = []), y.ref && g.push(y.ref, null, _), g.push(v, _.__c || k, _)), null != k ? (null == b && (b = k), "function" == typeof _.type && _.__k === y.__k ? _.__d = e = C(_, e, n) : e = x(n, _, y, w, k, e), "function" == typeof u.type && (u.__d = e)) : e && y.__e == e && e.parentNode != n && (e = m(y));
      }
    }for (u.__e = b, h = A; h--;) {
      null != w[h] && ("function" == typeof u.type && null != w[h].__e && w[h].__e == u.__d && (u.__d = m(t, h + 1)), F(w[h], w[h]));
    }if (g) for (h = 0; h < g.length; h++) {
      z(g[h], g[++h], g[++h]);
    }
  }function C(n, l, u) {
    for (var t, i = n.__k, o = 0; i && o < i.length; o++) {
      (t = i[o]) && (t.__ = n, l = "function" == typeof t.type ? C(t, l, u) : x(u, t, t, i, t.__e, l));
    }return l;
  }function x(n, l, u, t, i, o) {
    var r, f, e;if (void 0 !== l.__d) r = l.__d, l.__d = void 0;else if (null == u || i != o || null == i.parentNode) n: if (null == o || o.parentNode !== n) n.appendChild(i), r = null;else {
      for (f = o, e = 0; (f = f.nextSibling) && e < t.length; e += 2) {
        if (f == i) break n;
      }n.insertBefore(i, o), r = o;
    }return void 0 !== r ? r : i.nextSibling;
  }function A(n, l, u, t, i) {
    var o;for (o in u) {
      "children" === o || "key" === o || o in l || E(n, o, null, u[o], t);
    }for (o in l) {
      i && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || E(n, o, l[o], u[o], t);
    }
  }function P(n, l, u) {
    "-" === l[0] ? n.setProperty(l, u) : n[l] = null == u ? "" : "number" != typeof u || s.test(l) ? u : u + "px";
  }function E(n, l, u, t, i) {
    var o;n: if ("style" === l) {
      if ("string" == typeof u) n.style.cssText = u;else {
        if ("string" == typeof t && (n.style.cssText = t = ""), t) for (l in t) {
          u && l in u || P(n.style, l, "");
        }if (u) for (l in u) {
          t && u[l] === t[l] || P(n.style, l, u[l]);
        }
      }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t || n.addEventListener(l, o ? H : $, o) : n.removeEventListener(l, o ? H : $, o);else if ("dangerouslySetInnerHTML" !== l) {
      if (i) l = l.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");else if ("href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
        n[l] = null == u ? "" : u;break n;
      } catch (n) {}"function" == typeof u || (null != u && (!1 !== u || "a" === l[0] && "r" === l[1]) ? n.setAttribute(l, u) : n.removeAttribute(l));
    }
  }function $(n) {
    this.l[n.type + !1](l.event ? l.event(n) : n);
  }function H(n) {
    this.l[n.type + !0](l.event ? l.event(n) : n);
  }function I(n, u, t, i, o, r, f, e, c) {
    var a,
        s,
        v,
        y,
        d,
        m,
        k,
        b,
        g,
        C,
        x,
        A = u.type;if (void 0 !== u.constructor) return null;null != t.__h && (c = t.__h, e = u.__e = t.__e, u.__h = null, r = [e]), (a = l.__b) && a(u);try {
      n: if ("function" == typeof A) {
        if (b = u.props, g = (a = A.contextType) && i[a.__c], C = a ? g ? g.props.value : a.__ : i, t.__c ? k = (s = u.__c = t.__c).__ = s.__E : ("prototype" in A && A.prototype.render ? u.__c = s = new A(b, C) : (u.__c = s = new _(b, C), s.constructor = A, s.render = L), g && g.sub(s), s.props = b, s.state || (s.state = {}), s.context = C, s.__n = i, v = s.__d = !0, s.__h = []), null == s.__s && (s.__s = s.state), null != A.getDerivedStateFromProps && (s.__s == s.state && (s.__s = h({}, s.__s)), h(s.__s, A.getDerivedStateFromProps(b, s.__s))), y = s.props, d = s.state, v) null == A.getDerivedStateFromProps && null != s.componentWillMount && s.componentWillMount(), null != s.componentDidMount && s.__h.push(s.componentDidMount);else {
          if (null == A.getDerivedStateFromProps && b !== y && null != s.componentWillReceiveProps && s.componentWillReceiveProps(b, C), !s.__e && null != s.shouldComponentUpdate && !1 === s.shouldComponentUpdate(b, s.__s, C) || u.__v === t.__v) {
            s.props = b, s.state = s.__s, u.__v !== t.__v && (s.__d = !1), s.__v = u, u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function (n) {
              n && (n.__ = u);
            }), s.__h.length && f.push(s);break n;
          }null != s.componentWillUpdate && s.componentWillUpdate(b, s.__s, C), null != s.componentDidUpdate && s.__h.push(function () {
            s.componentDidUpdate(y, d, m);
          });
        }s.context = C, s.props = b, s.state = s.__s, (a = l.__r) && a(u), s.__d = !1, s.__v = u, s.__P = n, a = s.render(s.props, s.state, s.context), s.state = s.__s, null != s.getChildContext && (i = h(h({}, i), s.getChildContext())), v || null == s.getSnapshotBeforeUpdate || (m = s.getSnapshotBeforeUpdate(y, d)), x = null != a && a.type === p && null == a.key ? a.props.children : a, w(n, Array.isArray(x) ? x : [x], u, t, i, o, r, f, e, c), s.base = u.__e, u.__h = null, s.__h.length && f.push(s), k && (s.__E = s.__ = null), s.__e = !1;
      } else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = j(t.__e, u, t, i, o, r, f, c);(a = l.diffed) && a(u);
    } catch (n) {
      u.__v = null, (c || null != r) && (u.__e = e, u.__h = !!c, r[r.indexOf(e)] = null), l.__e(n, u, t);
    }
  }function T(n, u) {
    l.__c && l.__c(u, n), n.some(function (u) {
      try {
        n = u.__h, u.__h = [], n.some(function (n) {
          n.call(u);
        });
      } catch (n) {
        l.__e(n, u.__v);
      }
    });
  }function j(l, u, t, i, o, r, f, e) {
    var a,
        s,
        h,
        y = t.props,
        d = u.props,
        p = u.type,
        _ = 0;if ("svg" === p && (o = !0), null != r) for (; _ < r.length; _++) {
      if ((a = r[_]) && (a === l || (p ? a.localName == p : 3 == a.nodeType))) {
        l = a, r[_] = null;break;
      }
    }if (null == l) {
      if (null === p) return document.createTextNode(d);l = o ? document.createElementNS("http://www.w3.org/2000/svg", p) : document.createElement(p, d.is && d), r = null, e = !1;
    }if (null === p) y === d || e && l.data === d || (l.data = d);else {
      if (r = r && n.call(l.childNodes), s = (y = t.props || c).dangerouslySetInnerHTML, h = d.dangerouslySetInnerHTML, !e) {
        if (null != r) for (y = {}, _ = 0; _ < l.attributes.length; _++) {
          y[l.attributes[_].name] = l.attributes[_].value;
        }(h || s) && (h && (s && h.__html == s.__html || h.__html === l.innerHTML) || (l.innerHTML = h && h.__html || ""));
      }if (A(l, d, y, o, e), h) u.__k = [];else if (_ = u.props.children, w(l, Array.isArray(_) ? _ : [_], u, t, i, o && "foreignObject" !== p, r, f, r ? r[0] : t.__k && m(t, 0), e), null != r) for (_ = r.length; _--;) {
        null != r[_] && v(r[_]);
      }e || ("value" in d && void 0 !== (_ = d.value) && (_ !== l.value || "progress" === p && !_) && E(l, "value", _, y.value, !1), "checked" in d && void 0 !== (_ = d.checked) && _ !== l.checked && E(l, "checked", _, y.checked, !1));
    }return l;
  }function z(n, u, t) {
    try {
      "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
      l.__e(n, t);
    }
  }function F(n, u, t) {
    var i, o;if (l.unmount && l.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || z(i, null, u)), null != (i = n.__c)) {
      if (i.componentWillUnmount) try {
        i.componentWillUnmount();
      } catch (n) {
        l.__e(n, u);
      }i.base = i.__P = null;
    }if (i = n.__k) for (o = 0; o < i.length; o++) {
      i[o] && F(i[o], u, "function" != typeof n.type);
    }t || null == n.__e || v(n.__e), n.__e = n.__d = void 0;
  }function L(n, l, u) {
    return this.constructor(n, u);
  }function M(u, t, i) {
    var o, r, f;l.__ && l.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], I(t, u = (!o && i || t).__k = y(p, null, [u]), r || c, c, void 0 !== t.ownerSVGElement, !o && i ? [i] : r ? null : t.firstChild ? n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o), T(f, u);
  }n = a.slice, l = { __e: function __e(n, l) {
      for (var u, t, i; l = l.__;) {
        if ((u = l.__c) && !u.__) try {
          if ((t = u.constructor) && null != t.getDerivedStateFromError && (u.setState(t.getDerivedStateFromError(n)), i = u.__d), null != u.componentDidCatch && (u.componentDidCatch(n), i = u.__d), i) return u.__E = u;
        } catch (l) {
          n = l;
        }
      }throw n;
    } }, u = 0, t = function t(n) {
    return null != n && void 0 === n.constructor;
  }, _.prototype.setState = function (n, l) {
    var u;u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = h({}, this.state), "function" == typeof n && (n = n(h({}, u), this.props)), n && h(u, n), null != n && this.__v && (l && this.__h.push(l), b(this));
  }, _.prototype.forceUpdate = function (n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), b(this));
  }, _.prototype.render = p, i = [], o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, g.__r = 0, f = 0, e = { render: M, hydrate: function n(l, u) {
      M(l, u, n);
    }, createElement: y, h: y, Fragment: p, createRef: function createRef() {
      return { current: null };
    }, isValidElement: t, Component: _, cloneElement: function cloneElement(l, u, t) {
      var i,
          o,
          r,
          f = h({}, l.props);for (r in u) {
        "key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
      }return arguments.length > 2 && (f.children = arguments.length > 3 ? n.call(arguments, 2) : t), d(l.type, f, i || l.key, o || l.ref, null);
    }, createContext: function createContext(n, l) {
      var u = { __c: l = "__cC" + f++, __: n, Consumer: function Consumer(n, l) {
          return n.children(l);
        }, Provider: function Provider(n) {
          var u, t;return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function () {
            return t;
          }, this.shouldComponentUpdate = function (n) {
            this.props.value !== n.value && u.some(b);
          }, this.sub = function (n) {
            u.push(n);var l = n.componentWillUnmount;n.componentWillUnmount = function () {
              u.splice(u.indexOf(n), 1), l && l.call(n);
            };
          }), n.children;
        } };return u.Provider.__ = u.Consumer.contextType = u;
    }, toChildArray: function n(l, u) {
      return u = u || [], null == l || "boolean" == typeof l || (Array.isArray(l) ? l.some(function (l) {
        n(l, u);
      }) : u.push(l)), u;
    }, options: l }, typeof module < "u" ? module.exports = e : self.preact = e;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "MTo3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__("wGJf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);



/**
 * Card component to display a stylised card. The content of the card should be passed in
 * as children.
 *
 * props:
 * - cardTitle: the title displayed at the top of the card
 * - enlargeTitle: whether or not the title should be enlarged compared to normal (true or false)
 * - noMargin: set to true to remove card bottom margin
 */

var Card = function Card(props) {

	var cssClasses = [__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.card];

	if (props.noMargin) {
		cssClasses.push(__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.no_margin);
	}

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': cssClasses.join(' ') },
		props.cardTitle ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'h3',
			{ 'class': props.enlargeTitle ? __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.card_title_large : __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.card_title },
			props.cardTitle
		) : null,
		props.children
	);
};

/* harmony default export */ __webpack_exports__["a"] = (Card);

/***/ }),

/***/ "N0ou":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = yAxis;
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Axis = function () {
	function Axis(isPrimary) {
		_classCallCheck(this, Axis);

		this.config = {
			min: null,
			max: null,
			tickValues: null,
			formatters: [function (value) {
				return value;
			}],
			constraints: null,
			isPrimary: isPrimary
		};
	}

	Axis.prototype.tickValues = function tickValues(_tickValues) {
		this.config.tickValues = _tickValues;
		return this;
	};

	Axis.prototype.formatter = function formatter(formatter1, formatter2) {
		// For a dual axis, 2 formatters can be provided. The first one will be applied to
		// the left side and the second one to the right side.
		this.config.formatters = formatter2 ? [formatter1, formatter2] : [formatter1];
		return this;
	};

	/**
  * Apply constraints to the axis, passed into the algorithm for calculating tick values.
  * @param constraints
  *
  * Constraints is an object containing any subset of below fields:
  * {
  *     fixedMinValue: number,
  *     fixedMaxValue: number,
  *     lowestMinValue: number,
  *     highestMinValue: number,
  *     lowestMaxValue: number,
  *     highestMaxValue: number,
  *     stepOptions: number[],
  *     fixedNumberOfTicks: number
  * }
  */


	Axis.prototype.constraints = function constraints(_constraints) {
		this.config.constraints = _constraints;
		return this;
	};

	return Axis;
}();

function yAxis() {
	var isPrimary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

	return new Axis(isPrimary);
}

/***/ }),

/***/ "NGFW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "a",
  { href: "mailto:feedback@howickweather.co.nz" },
  "feedback@howickweather.co.nz"
);

/**
 * Displays a feedback email address.
 */
var FeedbackEmail = function FeedbackEmail() {
  return _ref;
};

/* harmony default export */ __webpack_exports__["a"] = (FeedbackEmail);

/***/ }),

/***/ "O7V0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);

/**
 * The PageTitle component displays the title of a page.
 * The title/heading is passed in as children elements
 */
var PageTitle = function PageTitle(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "h2",
    null,
    props.children
  );
};

/* harmony default export */ __webpack_exports__["a"] = (PageTitle);

/***/ }),

/***/ "OcWS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loader":"loader__20ouB","glow":"glow__1AaT4"};

/***/ }),

/***/ "OqZK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/d3-shape/src/index.js + 51 modules
var src = __webpack_require__("9maw");

// EXTERNAL MODULE: ./utils/panelgraph/components/series.js
var series = __webpack_require__("PhSF");

// EXTERNAL MODULE: ./utils/formatters.js
var formatters = __webpack_require__("gNwm");

// EXTERNAL MODULE: ./utils/panelgraph/components/axis-y.js
var axis_y = __webpack_require__("N0ou");

// EXTERNAL MODULE: ./utils/panelgraph/components/panel.js
var panel = __webpack_require__("vNH8");

// EXTERNAL MODULE: ./utils/convert-wind-bearing.js
var convert_wind_bearing = __webpack_require__("Dqzv");

// EXTERNAL MODULE: ./utils/panelgraph/components/axis-x.js
var axis_x = __webpack_require__("nTP0");

// EXTERNAL MODULE: ./utils/panelgraph/components/plot-line.js
var plot_line = __webpack_require__("1zZQ");

// CONCATENATED MODULE: ./utils/panelgraph/components/plot-band.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PlotBand = function () {
	function PlotBand(name) {
		_classCallCheck(this, PlotBand);

		this.config = {
			range: [0, 0],
			name: name
		};
	}

	PlotBand.prototype.range = function range(_range) {
		this.config.range = _range;
		return this;
	};

	return PlotBand;
}();

function plotBand(name) {
	return new PlotBand(name);
}
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__("hafV");

// EXTERNAL MODULE: ./utils/unit-converters.js
var unit_converters = __webpack_require__("rbCG");

// EXTERNAL MODULE: ./utils/graph-limits.js
var graph_limits = __webpack_require__("VjiX");

// CONCATENATED MODULE: ./utils/observations-graph-components.js
/* harmony export (immutable) */ __webpack_exports__["c"] = addSunLinesAndBands;
/* harmony export (immutable) */ __webpack_exports__["b"] = addDstLines;
/* harmony export (immutable) */ __webpack_exports__["a"] = addDateChangeLines;
/* harmony export (immutable) */ __webpack_exports__["q"] = xFormatter24h;
/* harmony export (immutable) */ __webpack_exports__["r"] = xFormatter7d;
/* harmony export (immutable) */ __webpack_exports__["s"] = xFormatterMonth;
/* unused harmony export tooltipTimeFormatter */
/* harmony export (immutable) */ __webpack_exports__["m"] = tooltipTimeFormatter24h;
/* harmony export (immutable) */ __webpack_exports__["n"] = tooltipTimeFormatterMultiDay;
/* harmony export (immutable) */ __webpack_exports__["e"] = getTimeAxis;
/* harmony export (immutable) */ __webpack_exports__["d"] = chartHeight;
/* harmony export (immutable) */ __webpack_exports__["p"] = windSpeedPanel;
/* harmony export (immutable) */ __webpack_exports__["o"] = windDirectionPanel;
/* harmony export (immutable) */ __webpack_exports__["l"] = temperaturePanel;
/* harmony export (immutable) */ __webpack_exports__["k"] = rainfallPanel;
/* harmony export (immutable) */ __webpack_exports__["f"] = hourlyRainfallPanel;
/* harmony export (immutable) */ __webpack_exports__["j"] = rainRatePanel;
/* harmony export (immutable) */ __webpack_exports__["h"] = pressureHumidityPanel;
/* harmony export (immutable) */ __webpack_exports__["i"] = pressurePanel;
/* harmony export (immutable) */ __webpack_exports__["g"] = humidityPanel;














function addSunLinesAndBands(data, plotLines, plotBands) {
	// If sun events are present in the data, create plotlines and plotbands for these.
	if (data.sunEvents) {

		data.sunEvents.forEach(function (sunEvent) {
			plotLines.push(Object(plot_line["a" /* plotLine */])(sunEvent.type).label(sunEvent.type === 'sunrise' ? 'Sunrise' : 'Sunset').x(sunEvent.time));
		});

		var numSunEvents = data.sunEvents.length;

		if (numSunEvents > 0) {

			// Night time band from data start until first sunrise
			if (data.sunEvents[0].type === 'sunrise') {
				plotBands.push(plotBand('night').range([null, data.sunEvents[0].time]));
			}

			for (var i = 1; i < numSunEvents; i++) {
				if (data.sunEvents[i].type === 'sunrise') {
					plotBands.push(plotBand('night').range([data.sunEvents[i - 1].time, data.sunEvents[i].time]));
				}
			}

			// Night time band from last sunset until data end
			if (data.sunEvents[numSunEvents - 1].type === 'sunset') {
				plotBands.push(plotBand('night').range([data.sunEvents[numSunEvents - 1].time, null]));
			}
		}
	}
}

function addDstLines(data, plotLines) {
	// Add plotlines for any DST events present
	if (data.dstEvents) {

		data.dstEvents.forEach(function (dstEvent) {
			plotLines.push(Object(plot_line["a" /* plotLine */])('dst').label(dstEvent.type === 'start' ? 'DST start' : 'DST end').x(dstEvent.time));
		});
	}
}

function addDateChangeLines(data, plotLines) {
	// If date changes are present, add plotlines for these
	if (data.dateChanges) {

		data.dateChanges.forEach(function (dateChange) {
			plotLines.push(Object(plot_line["a" /* plotLine */])('dateChange').x(dateChange.time));
		});
	}
}

function xFormatter24h(data) {
	return function (tickTime) {
		var tick = data.axis.filter(function (tick) {
			return tick.time === tickTime;
		})[0];
		var hour = Number(tick.timeString.split(' ')[1].split(':')[0]);

		if (hour === 0) {
			return '12am';
		}

		if (hour < 12) {
			return hour + 'am';
		}

		if (hour === 12) {
			return '12pm';
		}

		return hour - 12 + 'pm';
	};
}

function xFormatter7d(data) {
	var dateFormatter = Object(formatters["j" /* getDateTimeFormatConverter */])('%Y-%m-%d %H:%M:%S', '%-d %b');

	return function (tickTime) {
		var tick = data.axis.filter(function (tick) {
			return tick.time === tickTime;
		})[0];
		return dateFormatter(tick.timeString);
	};
}

function xFormatterMonth(data) {
	var dateFormatter = Object(formatters["j" /* getDateTimeFormatConverter */])('%Y-%m-%d %H:%M:%S', '%e');

	return function (tickTime) {
		var tick = data.axis.filter(function (tick) {
			return tick.time === tickTime;
		})[0];
		return dateFormatter(tick.timeString);
	};
}

function tooltipTimeFormatter(format) {
	return function (formatter) {
		return function (pt) {
			return formatter(pt.timestamp);
		};
	}(Object(formatters["j" /* getDateTimeFormatConverter */])('%Y-%m-%d %H:%M:%S', format));
}

function tooltipTimeFormatter24h() {
	return tooltipTimeFormatter('%-I:%M %p');
}

function tooltipTimeFormatterMultiDay() {
	return tooltipTimeFormatter('%-d %b %-I:%M %p');
}

function getTimeAxis(data, tickValues, xFormatter, tooltipFormatter) {
	return Object(axis_x["a" /* xAxis */])().data(function (pt) {
		return pt.time;
	}).range(data.range).tooltipFormatter(tooltipFormatter).tickValues(tickValues).formatter(xFormatter);
}

function chartHeight(graphView) {
	switch (graphView) {

		case constants["c" /* GRAPH_VIEW */].COMBINED:
			return function (w) {
				return Math.max(0.8 * w, 640);
			};

		case constants["c" /* GRAPH_VIEW */].WIND:
			return function (w) {
				return Math.max(0.5 * w, 300);
			};

		default:
			return function (w) {
				return Math.max(0.5 * w, 200);
			};
	}
}

function windSpeedPanel(speedUnit, curveFn) {
	var useHourlyHighGust = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;


	var windSpeedSeries = Object(series["a" /* areaSeries */])('windspeed').data(function (pt) {
		return pt.windSpeed === null ? null : [0, Object(unit_converters["e" /* convertWindSpeed */])(pt.windSpeed, speedUnit)];
	}).curve(curveFn).label('Wind Speed ' + speedUnit).tooltipFormatter(function (pt) {
		return Object(formatters["i" /* formatWindSpeed */])(pt.windSpeed, speedUnit) + ' ' + speedUnit;
	});

	var gustKey = useHourlyHighGust ? 'hourlyHighWindGust' : 'windGust';

	var windGustSeries = Object(series["a" /* areaSeries */])('windgust').data(function (pt) {
		return pt[gustKey] === null ? null : [Object(unit_converters["e" /* convertWindSpeed */])(pt.windSpeed, speedUnit), Object(unit_converters["e" /* convertWindSpeed */])(pt[gustKey], speedUnit)];
	}).curve(curveFn).label('Gust ' + speedUnit).tooltipFormatter(function (pt) {
		return Object(formatters["h" /* formatWindGust */])(pt[gustKey], speedUnit) + ' ' + speedUnit;
	});

	var speedAxis = Object(axis_y["a" /* yAxis */])().formatter(function (v) {
		return Math.round(v);
	}).constraints({
		fixedMinValue: 0,
		lowestMaxValue: Object(graph_limits["b" /* getLowestMaxWindAxisValue */])(speedUnit),
		stepOptions: Object(graph_limits["e" /* getWindAxisStepOptions */])(speedUnit)
	});

	return Object(panel["a" /* panel */])().series([windSpeedSeries, windGustSeries]).axisDual(speedAxis);
}

function windDirectionPanel() {

	var windDirectionSeries = Object(series["d" /* scatterSeries */])('winddirection').data(function (pt) {
		return pt.windBearing;
	}).label('Wind Bearing').tooltipFormatter(function (pt) {
		return Object(convert_wind_bearing["a" /* convertWindBearing16 */])(pt.windBearing) + (' (' + pt.windBearing + '\xB0)');
	});

	var directionLabels = {
		0: 'N',
		90: 'E',
		180: 'S',
		270: 'W',
		360: 'N'
	};

	var bearingAxis = Object(axis_y["a" /* yAxis */])().tickValues([0, 90, 180, 270, 360]).formatter(function (value) {
		return directionLabels[value];
	}, function (value) {
		return value;
	});

	return Object(panel["a" /* panel */])().series([windDirectionSeries]).axisDual(bearingAxis);
}

function temperaturePanel(tempUnit, curveFn) {

	var temperatureSeries = Object(series["b" /* lineSeries */])('temperature').data(function (pt) {
		return pt.temperature === null ? null : Object(unit_converters["c" /* convertTemperature */])(pt.temperature, tempUnit);
	}).curve(curveFn).label('Temperature \xB0' + tempUnit).tooltipFormatter(function (pt) {
		return Object(formatters["f" /* formatTemperature */])(pt.temperature, tempUnit) + ('\xB0' + tempUnit);
	});

	var dewpointSeries = Object(series["b" /* lineSeries */])('dewpoint').data(function (pt) {
		return pt.dewpoint === null ? null : Object(unit_converters["c" /* convertTemperature */])(pt.dewpoint, tempUnit);
	}).curve(curveFn).label('Dewpoint \xB0' + tempUnit).tooltipFormatter(function (pt) {
		return Object(formatters["f" /* formatTemperature */])(pt.dewpoint, tempUnit) + ('\xB0' + tempUnit);
	});

	var temperatureAxis = Object(axis_y["a" /* yAxis */])().formatter(function (v) {
		return Math.round(v);
	}).constraints({
		stepOptions: [1, 2, 3, 4, 5, 10]
	});

	return Object(panel["a" /* panel */])().series([temperatureSeries, dewpointSeries]).axisDual(temperatureAxis);
}

function rainfallPanel(rainUnit) {
	var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Daily Rainfall';
	var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'dailyRainfall';


	var rainSeries = Object(series["a" /* areaSeries */])('rainfall').curve(src["curveStep"]).data(function (pt) {
		return pt[key] === null ? null : [0, Object(unit_converters["b" /* convertRainfall */])(pt[key], rainUnit)];
	}).label(label + ' ' + rainUnit).tooltipFormatter(function (pt) {
		return Object(formatters["e" /* formatRainfall */])(pt[key], rainUnit) + ' ' + rainUnit;
	});

	var rainAxis = Object(axis_y["a" /* yAxis */])().formatter(function (v) {
		return rainUnit === constants["f" /* RAIN_UNIT */].IN ? Math.round(v * 10) / 10 : Math.round(v);
	}).constraints({
		fixedMinValue: 0,
		lowestMaxValue: Object(graph_limits["a" /* getLowestMaxRainAxisValue */])(rainUnit),
		stepOptions: Object(graph_limits["d" /* getRainAxisStepOptions */])(rainUnit)
	});

	return Object(panel["a" /* panel */])().series([rainSeries]).axisDual(rainAxis);
}

function hourlyRainfallPanel(rainUnit) {

	var hourlyRainSeries = Object(series["a" /* areaSeries */])('hourlyrainfall').curve(src["curveStep"]).data(function (pt) {
		return pt.hourlyRainfall === null ? null : [0, Object(unit_converters["b" /* convertRainfall */])(pt.hourlyRainfall, rainUnit)];
	}).label('Hourly Rainfall ' + rainUnit).tooltipFormatter(function (pt) {
		return Object(formatters["e" /* formatRainfall */])(pt.hourlyRainfall, rainUnit) + ' ' + rainUnit;
	});

	var hourlyRainAxis = Object(axis_y["a" /* yAxis */])().formatter(function (v) {
		return rainUnit === constants["f" /* RAIN_UNIT */].IN ? Math.round(v * 10) / 10 : Math.round(v);
	}).constraints({
		fixedMinValue: 0,
		lowestMaxValue: Object(graph_limits["a" /* getLowestMaxRainAxisValue */])(rainUnit),
		stepOptions: Object(graph_limits["d" /* getRainAxisStepOptions */])(rainUnit)
	});

	return Object(panel["a" /* panel */])().series([hourlyRainSeries]).axisDual(hourlyRainAxis);
}

function rainRatePanel(rainUnit) {

	var rainrateSeries = Object(series["a" /* areaSeries */])('rainrate').curve(src["curveStep"]).data(function (pt) {
		return pt.meanRainRate === null ? null : [0, Object(unit_converters["b" /* convertRainfall */])(pt.meanRainRate, rainUnit)];
	}).label('Mean Rain Rate ' + rainUnit + '/hr').tooltipFormatter(function (pt) {
		return Object(formatters["e" /* formatRainfall */])(pt.meanRainRate, rainUnit) + ' ' + rainUnit + '/hr';
	});

	var rainrateAxis = Object(axis_y["a" /* yAxis */])().formatter(function (v) {
		return rainUnit === constants["f" /* RAIN_UNIT */].IN ? Math.round(v * 10) / 10 : Math.round(v);
	}).constraints({
		fixedMinValue: 0,
		lowestMaxValue: Object(graph_limits["a" /* getLowestMaxRainAxisValue */])(rainUnit),
		stepOptions: Object(graph_limits["d" /* getRainAxisStepOptions */])(rainUnit)
	});

	return Object(panel["a" /* panel */])().series([rainrateSeries]).axisDual(rainrateAxis);
}

function pressureHumidityPanel(pressureUnit, curveFn) {

	var pressureSeries = Object(series["b" /* lineSeries */])('pressure').data(function (pt) {
		return pt.pressure === null ? null : Object(unit_converters["a" /* convertPressure */])(pt.pressure, pressureUnit);
	}).label('Pressure ' + pressureUnit).side('left').curve(curveFn).tooltipFormatter(function (pt) {
		return Object(formatters["c" /* formatPressure */])(pt.pressure, pressureUnit) + ' ' + pressureUnit;
	});

	var humiditySeries = Object(series["b" /* lineSeries */])('humidity').data(function (pt) {
		return pt.humidity;
	}).label('Humidity %').side('right').curve(curveFn).tooltipFormatter(function (pt) {
		return pt.humidity + '%';
	});

	// primary y axis is pressure
	var pressureAxis = Object(axis_y["a" /* yAxis */])(true).formatter(function (v) {
		return pressureUnit === constants["e" /* PRESSURE_UNIT */].INHG ? v.toFixed(1) : Math.round(v);
	}).constraints({
		stepOptions: Object(graph_limits["c" /* getPressureAxisStepOptions */])(pressureUnit)
	});

	// secondary axis is humidity - the calculated tick values will be subject to the additional
	// constraint of having an identical number of ticks as the primary axis
	var humidityAxis = Object(axis_y["a" /* yAxis */])().formatter(function (v) {
		return Math.round(v);
	}).constraints({
		lowestMinValue: 0,
		highestMaxValue: 100,
		stepOptions: [5, 10, 15, 20, 25, 50]
	});

	return Object(panel["a" /* panel */])().series([pressureSeries, humiditySeries]).axisLeft(pressureAxis).axisRight(humidityAxis);
}

function pressurePanel(pressureUnit, curveFn) {

	var pressureSeries = Object(series["b" /* lineSeries */])('pressure').data(function (pt) {
		return pt.pressure === null ? null : Object(unit_converters["a" /* convertPressure */])(pt.pressure, pressureUnit);
	}).label('Pressure ' + pressureUnit).curve(curveFn).tooltipFormatter(function (pt) {
		return Object(formatters["c" /* formatPressure */])(pt.pressure, pressureUnit) + ' ' + pressureUnit;
	});

	var pressureAxis = Object(axis_y["a" /* yAxis */])().formatter(function (v) {
		return pressureUnit === constants["e" /* PRESSURE_UNIT */].INHG ? v.toFixed(1) : Math.round(v);
	}).constraints({
		stepOptions: Object(graph_limits["c" /* getPressureAxisStepOptions */])(pressureUnit)
	});

	return Object(panel["a" /* panel */])().series([pressureSeries]).axisDual(pressureAxis);
}

function humidityPanel(curveFn) {

	var humiditySeries = Object(series["b" /* lineSeries */])('humidity').data(function (pt) {
		return pt.humidity;
	}).label('Humidity %').curve(curveFn).tooltipFormatter(function (pt) {
		return pt.humidity + '%';
	});

	var humidityAxis = Object(axis_y["a" /* yAxis */])().formatter(function (v) {
		return Math.round(v);
	}).constraints({
		lowestMinValue: 0,
		highestMaxValue: 100,
		stepOptions: [5, 10, 15, 20, 25, 50]
	});

	return Object(panel["a" /* panel */])().series([humiditySeries]).axisDual(humidityAxis);
}

/***/ }),

/***/ "Oqou":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



/**
 * Higher order component which extends a component by accepting a mounted callback, which
 * gets called in the componentDidMount lifecycle method.
 *
 * props:
 * - mounted: (optional) callback function
 * - other props passed down into wrapped component
 */
var notifyMounted = function notifyMounted(WrappedComponent) {

	return function (_Component) {
		_inherits(_class, _Component);

		function _class() {
			_classCallCheck(this, _class);

			return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		}

		_class.prototype.componentDidMount = function componentDidMount() {
			if (typeof this.props.mounted === 'function') {
				this.props.mounted();
			}
		};

		_class.prototype.render = function render(props) {
			var mounted = props.mounted,
			    rest = _objectWithoutProperties(props, ['mounted']);

			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(WrappedComponent, rest);
		};

		return _class;
	}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);
};

/* harmony default export */ __webpack_exports__["a"] = (notifyMounted);

/***/ }),

/***/ "OzCj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__("04o6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);



/**
 * The CheckboxIcon component renders a checkbox icon, either checked or unchecked.
 *
 * props:
 * - checked: true is the checkbox is checked, false if unchecked
 * - fill: fill colour for the checkbox
 */

var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M0 0h24v24H0z", fill: "none" });

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" });

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" });

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M0 0h24v24H0z", fill: "none" });

var CheckboxIcon = function CheckboxIcon(props) {

	var inlineStyles = {};

	if (props.fill) {
		inlineStyles.fill = props.fill;
	}

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"svg",
		{ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", "class": __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.checkbox, style: inlineStyles },
		props.checked ? [_ref, _ref2] : [_ref3, _ref4]
	);
};

/* harmony default export */ __webpack_exports__["a"] = (CheckboxIcon);

/***/ }),

/***/ "PhSF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = lineSeries;
/* harmony export (immutable) */ __webpack_exports__["a"] = areaSeries;
/* harmony export (immutable) */ __webpack_exports__["c"] = rangeBarSeries;
/* harmony export (immutable) */ __webpack_exports__["d"] = scatterSeries;
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Series = function () {
	function Series(type, name) {
		_classCallCheck(this, Series);

		this.config = {
			type: type,
			name: name,
			dataAccessor: function dataAccessor(d) {
				return 0;
			},
			curve: null,
			color: null,
			side: 'left',
			label: null,
			activePointEnabled: true,
			tooltipOrder: null,
			isValid: function isValid(value) {
				return true;
			},
			tooltipFormatter: function tooltipFormatter(value) {
				return value;
			}
		};

		this.associatedScale = null;
	}

	Series.prototype.type = function type(_type) {
		this.config.type = _type;
		return this;
	};

	Series.prototype.data = function data(_data) {
		// Data accessor function - for example d => d.temperature.
		// Or for area series, return a length-2 array, with first item being the base
		// and the second item being the ceiling.
		this.config.dataAccessor = _data;
		return this;
	};

	Series.prototype.curve = function curve(_curve) {
		this.config.curve = _curve;
		return this;
	};

	Series.prototype.color = function color(_color) {
		this.config.color = _color;
		return this;
	};

	Series.prototype.side = function side(_side) {
		this.config.side = _side;
		return this;
	};

	Series.prototype.label = function label(_label) {
		this.config.label = _label;
		return this;
	};

	Series.prototype.activePoint = function activePoint(isEnabled) {
		this.config.activePointEnabled = isEnabled;
		return this;
	};

	Series.prototype.tooltipOrder = function tooltipOrder(order) {
		this.config.tooltipOrder = order;
		return this;
	};

	Series.prototype.isValid = function isValid(_isValid) {
		this.config.isValid = _isValid;
		return this;
	};

	Series.prototype.tooltipFormatter = function tooltipFormatter(formatter) {
		this.config.tooltipFormatter = formatter;
		return this;
	};

	return Series;
}();

function lineSeries(name) {
	return new Series('line', name);
}

function areaSeries(name) {
	var s = new Series('area', name);

	// Replace default tooltip formatter
	s.config.tooltipFormatter = function (value) {
		return value[1];
	};

	return s;
}

function rangeBarSeries(name) {
	var s = new Series('range-bar', name);

	// Display the upper value by default, matching area series.
	s.config.tooltipFormatter = function (value) {
		return value[1];
	};

	return s;
}

function scatterSeries(name) {
	return new Series('scatter', name);
}

/***/ }),

/***/ "R99g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__3_VRr"};

/***/ }),

/***/ "UqVV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/d3-selection/src/index.js + 50 modules
var src = __webpack_require__("//ys");

// CONCATENATED MODULE: ../node_modules/d3-dispatch/src/dispatch.js
var noop = { value: function value() {} };

function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function (t) {
    var name = "",
        i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return { type: t, name: name };
  });
}

Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function on(typename, callback) {
    var _ = this._,
        T = parseTypenames(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) {
        if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
      }return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);else if (callback == null) for (t in _) {
        _[t] = set(_[t], typename.name, null);
      }
    }

    return this;
  },
  copy: function copy() {
    var copy = {},
        _ = this._;
    for (var t in _) {
      copy[t] = _[t].slice();
    }return new Dispatch(copy);
  },
  call: function call(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) {
      args[i] = arguments[i + 2];
    }if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) {
      t[i].value.apply(that, args);
    }
  },
  apply: function apply(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) {
      t[i].value.apply(that, args);
    }
  }
};

function get(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({ name: name, value: callback });
  return type;
}

/* harmony default export */ var src_dispatch = (dispatch);
// CONCATENATED MODULE: ../node_modules/d3-dispatch/src/index.js

// CONCATENATED MODULE: ../node_modules/d3-timer/src/timer.js
var timer_frame = 0,
    // is an animation frame pending?
timeout = 0,
    // is a timeout pending?
interval = 0,
    // are any timers active?
pokeDelay = 1000,
    // how frequently we check for clock skew
taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (f) {
  setTimeout(f, 17);
};

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call = this._time = this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function restart(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function stop() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer();
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++timer_frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead,
      e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --timer_frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  timer_frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    timer_frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(),
      delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0,
      t1 = taskHead,
      t2,
      time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (timer_frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    timer_frame = 1, setFrame(wake);
  }
}
// CONCATENATED MODULE: ../node_modules/d3-timer/src/timeout.js


/* harmony default export */ var src_timeout = (function (callback, delay, time) {
  var t = new Timer();
  delay = delay == null ? 0 : +delay;
  t.restart(function (elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
});
// CONCATENATED MODULE: ../node_modules/d3-timer/src/interval.js


/* harmony default export */ var src_interval = (function (callback, delay, time) {
  var t = new Timer(),
      total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  delay = +delay, time = time == null ? now() : +time;
  t.restart(function tick(elapsed) {
    elapsed += total;
    t.restart(tick, total += delay, time);
    callback(elapsed);
  }, delay, time);
  return t;
});
// CONCATENATED MODULE: ../node_modules/d3-timer/src/index.js





// CONCATENATED MODULE: ../node_modules/d3-transition/src/transition/schedule.js



var emptyOn = src_dispatch("start", "end", "cancel", "interrupt");
var emptyTween = [];

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

/* harmony default export */ var transition_schedule = (function (node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};else if (id in schedules) return;
  create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
});

function init(node, id) {
  var schedule = schedule_get(node, id);
  if (schedule.state > CREATED) throw new Error("too late; already scheduled");
  return schedule;
}

function schedule_set(node, id) {
  var schedule = schedule_get(node, id);
  if (schedule.state > STARTED) throw new Error("too late; already running");
  return schedule;
}

function schedule_get(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
  return schedule;
}

function create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = timer(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return src_timeout(start);

      // Interrupt the active transition, if any.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions.
      else if (+i < id) {
          o.state = ENDED;
          o.timer.stop();
          o.on.call("cancel", node, node.__data__, o.index, o.group);
          delete schedules[i];
        }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    src_timeout(function () {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(node, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) {
      return;
    } // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}
// CONCATENATED MODULE: ../node_modules/d3-transition/src/interrupt.js


/* harmony default export */ var interrupt = (function (node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) {
      empty = false;continue;
    }
    active = schedule.state > STARTING && schedule.state < ENDING;
    schedule.state = ENDED;
    schedule.timer.stop();
    schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
});
// CONCATENATED MODULE: ../node_modules/d3-transition/src/selection/interrupt.js


/* harmony default export */ var selection_interrupt = (function (name) {
  return this.each(function () {
    interrupt(this, name);
  });
});
// EXTERNAL MODULE: ../node_modules/d3-interpolate/src/index.js + 24 modules
var d3_interpolate_src = __webpack_require__("k9aH");

// CONCATENATED MODULE: ../node_modules/d3-transition/src/transition/tween.js


function tweenRemove(id, name) {
  var tween0, tween1;
  return function () {
    var schedule = schedule_set(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error();
  return function () {
    var schedule = schedule_set(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = { name: name, value: value }, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

/* harmony default export */ var transition_tween = (function (name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = schedule_get(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
});

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function () {
    var schedule = schedule_set(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function (node) {
    return schedule_get(node, id).value[name];
  };
}
// EXTERNAL MODULE: ../node_modules/d3-color/src/index.js + 5 modules
var d3_color_src = __webpack_require__("Peej");

// CONCATENATED MODULE: ../node_modules/d3-transition/src/transition/interpolate.js



/* harmony default export */ var transition_interpolate = (function (a, b) {
    var c;
    return (typeof b === "number" ? d3_interpolate_src["interpolateNumber"] : b instanceof d3_color_src["color"] ? d3_interpolate_src["interpolateRgb"] : (c = Object(d3_color_src["color"])(b)) ? (b = c, d3_interpolate_src["interpolateRgb"]) : d3_interpolate_src["interpolateString"])(a, b);
});
// CONCATENATED MODULE: ../node_modules/d3-transition/src/transition/attr.js





function attrRemove(name) {
  return function () {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function () {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function () {
    var string0 = this.getAttribute(name);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function attrConstantNS(fullname, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function () {
    var string0 = this.getAttributeNS(fullname.space, fullname.local);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function attrFunction(name, interpolate, value) {
  var string00, string10, interpolate0;
  return function () {
    var string0,
        value1 = value(this),
        string1;
    if (value1 == null) return void this.removeAttribute(name);
    string0 = this.getAttribute(name);
    string1 = value1 + "";
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function attrFunctionNS(fullname, interpolate, value) {
  var string00, string10, interpolate0;
  return function () {
    var string0,
        value1 = value(this),
        string1;
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    string0 = this.getAttributeNS(fullname.space, fullname.local);
    string1 = value1 + "";
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

/* harmony default export */ var attr = (function (name, value) {
  var fullname = Object(src["namespace"])(name),
      i = fullname === "transform" ? d3_interpolate_src["interpolateTransformSvg"] : transition_interpolate;
  return this.attrTween(name, typeof value === "function" ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, tweenValue(this, "attr." + name, value)) : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname) : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value));
});
// CONCATENATED MODULE: ../node_modules/d3-transition/src/transition/attrTween.js


function attrInterpolate(name, i) {
  return function (t) {
    this.setAttribute(name, i(t));
  };
}

function attrInterpolateNS(fullname, i) {
  return function (t) {
    this.setAttributeNS(fullname.space, fullname.local, i(t));
  };
}

function attrTweenNS(fullname, value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
    return t0;
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
    return t0;
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ var transition_attrTween = (function (name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error();
  var fullname = Object(src["namespace"])(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
});
// CONCATENATED MODULE: ../node_modules/d3-transition/src/transition/delay.js


function delayFunction(id, value) {
  return function () {
    init(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function () {
    init(this, id).delay = value;
  };
}

/* harmony default export */ var transition_delay = (function (value) {
  var id = this._id;

  return arguments.length ? this.each((typeof value === "function" ? delayFunction : delayConstant)(id, value)) : schedule_get(this.node(), id).delay;
});
// CONCATENATED MODULE: ../node_modules/d3-transition/src/transition/duration.js


function durationFunction(id, value) {
  return function () {
    schedule_set(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function () {
    schedule_set(this, id).duration = value;
  };
}

/* harmony default export */ var duration = (function (value) {
  var id = this._id;

  return arguments.length ? this.each((typeof value === "function" ? durationFunction : durationConstant)(id, value)) : schedule_get(this.node(), id).duration;
});
// CONCATENATED MODULE: ../node_modules/d3-transition/src/transition/ease.js


function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error();
  return function () {
    schedule_set(this, id).ease = value;
  };
}

/* harmony default export */ var ease = (function (value) {
  var id = this._id;

  return arguments.length ? this.each(easeConstant(id, value)) : schedule_get(this.node(), id).ease;
});
// CONCATENATED MODULE: ../node_modules/d3-transition/src/transition/filter.js



/* harmony default export */ var filter = (function (match) {
  if (typeof match !== "function") match = Object(src["matcher"])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Transition(subgroups, this._parents, this._name, this._id);
});
// CONCATENATED MODULE: ../node_modules/d3-transition/src/transition/merge.js


/* harmony default export */ var transition_merge = (function (transition) {
  if (transition._id !== this._id) throw new Error();

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Transition(merges, this._parents, this._name, this._id);
});
// CONCATENATED MODULE: ../node_modules/d3-transition/src/transition/on.js


function on_start(name) {
  return (name + "").trim().split(/^|\s+/).every(function (t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0,
      on1,
      sit = on_start(name) ? init : schedule_set;
  return function () {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

/* harmony default export */ var transition_on = (function (name, listener) {
  var id = this._id;

  return arguments.length < 2 ? schedule_get(this.node(), id).on.on(name) : this.each(onFunction(id, name, listener));
});
// CONCATENATED MODULE: ../node_modules/d3-transition/src/transition/remove.js
function removeFunction(id) {
  return function () {
    var parent = this.parentNode;
    for (var i in this.__transition) {
      if (+i !== id) return;
    }if (parent) parent.removeChild(this);
  };
}

/* harmony default export */ var transition_remove = (function () {
  return this.on("end.remove", removeFunction(this._id));
});
// CONCATENATED MODULE: ../node_modules/d3-transition/src/transition/select.js




/* harmony default export */ var transition_select = (function (select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = Object(src["selector"])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        transition_schedule(subgroup[i], name, id, i, subgroup, schedule_get(node, id));
      }
    }
  }

  return new Transition(subgroups, this._parents, name, id);
});
// CONCATENATED MODULE: ../node_modules/d3-transition/src/transition/selectAll.js




/* harmony default export */ var selectAll = (function (select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = Object(src["selectorAll"])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select.call(node, node.__data__, i, group), child, inherit = schedule_get(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            transition_schedule(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new Transition(subgroups, parents, name, id);
});
// CONCATENATED MODULE: ../node_modules/d3-transition/src/transition/selection.js


var Selection = src["selection"].prototype.constructor;

/* harmony default export */ var selection = (function () {
  return new Selection(this._groups, this._parents);
});
// CONCATENATED MODULE: ../node_modules/d3-transition/src/transition/style.js






function styleNull(name, interpolate) {
  var string00, string10, interpolate0;
  return function () {
    var string0 = Object(src["style"])(this, name),
        string1 = (this.style.removeProperty(name), Object(src["style"])(this, name));
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
  };
}

function styleRemove(name) {
  return function () {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function () {
    var string0 = Object(src["style"])(this, name);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function styleFunction(name, interpolate, value) {
  var string00, string10, interpolate0;
  return function () {
    var string0 = Object(src["style"])(this, name),
        value1 = value(this),
        string1 = value1 + "";
    if (value1 == null) string1 = value1 = (this.style.removeProperty(name), Object(src["style"])(this, name));
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function styleMaybeRemove(id, name) {
  var on0,
      on1,
      listener0,
      key = "style." + name,
      event = "end." + key,
      remove;
  return function () {
    var schedule = schedule_set(this, id),
        on = schedule.on,
        listener = schedule.value[key] == null ? remove || (remove = styleRemove(name)) : undefined;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);

    schedule.on = on1;
  };
}

/* harmony default export */ var style = (function (name, value, priority) {
  var i = (name += "") === "transform" ? d3_interpolate_src["interpolateTransformCss"] : transition_interpolate;
  return value == null ? this.styleTween(name, styleNull(name, i)).on("end.style." + name, styleRemove(name)) : typeof value === "function" ? this.styleTween(name, styleFunction(name, i, tweenValue(this, "style." + name, value))).each(styleMaybeRemove(this._id, name)) : this.styleTween(name, styleConstant(name, i, value), priority).on("end.style." + name, null);
});
// CONCATENATED MODULE: ../node_modules/d3-transition/src/transition/styleTween.js
function styleInterpolate(name, i, priority) {
  return function (t) {
    this.style.setProperty(name, i(t), priority);
  };
}

function styleTween(name, value, priority) {
  var t, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
    return t;
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ var transition_styleTween = (function (name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error();
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
});
// CONCATENATED MODULE: ../node_modules/d3-transition/src/transition/text.js


function textConstant(value) {
  return function () {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function () {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

/* harmony default export */ var transition_text = (function (value) {
  return this.tween("text", typeof value === "function" ? textFunction(tweenValue(this, "text", value)) : textConstant(value == null ? "" : value + ""));
});
// CONCATENATED MODULE: ../node_modules/d3-transition/src/transition/transition.js



/* harmony default export */ var transition_transition = (function () {
  var name = this._name,
      id0 = this._id,
      id1 = newId();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = schedule_get(node, id0);
        transition_schedule(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new Transition(groups, this._parents, name, id1);
});
// CONCATENATED MODULE: ../node_modules/d3-transition/src/transition/end.js


/* harmony default export */ var transition_end = (function () {
  var on0,
      on1,
      that = this,
      id = that._id,
      size = that.size();
  return new Promise(function (resolve, reject) {
    var cancel = { value: reject },
        end = { value: function value() {
        if (--size === 0) resolve();
      } };

    that.each(function () {
      var schedule = schedule_set(this, id),
          on = schedule.on;

      // If this node shared a dispatch with the previous node,
      // just assign the updated shared dispatch and we’re done!
      // Otherwise, copy-on-write.
      if (on !== on0) {
        on1 = (on0 = on).copy();
        on1._.cancel.push(cancel);
        on1._.interrupt.push(cancel);
        on1._.end.push(end);
      }

      schedule.on = on1;
    });
  });
});
// CONCATENATED MODULE: ../node_modules/d3-transition/src/transition/index.js




















var transition_id = 0;

function Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function src_transition_transition(name) {
  return Object(src["selection"])().transition(name);
}

function newId() {
  return ++transition_id;
}

var selection_prototype = src["selection"].prototype;

Transition.prototype = src_transition_transition.prototype = {
  constructor: Transition,
  select: transition_select,
  selectAll: selectAll,
  filter: filter,
  merge: transition_merge,
  selection: selection,
  transition: transition_transition,
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: transition_on,
  attr: attr,
  attrTween: transition_attrTween,
  style: style,
  styleTween: transition_styleTween,
  text: transition_text,
  remove: transition_remove,
  tween: transition_tween,
  delay: transition_delay,
  duration: duration,
  ease: ease,
  end: transition_end
};
// EXTERNAL MODULE: ../node_modules/d3-ease/src/index.js + 11 modules
var d3_ease_src = __webpack_require__("pJ11");

// CONCATENATED MODULE: ../node_modules/d3-transition/src/selection/transition.js





var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: d3_ease_src["easeCubicInOut"]
};

function transition_inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      return defaultTiming.time = now(), defaultTiming;
    }
  }
  return timing;
}

/* harmony default export */ var selection_transition = (function (name) {
  var id, timing;

  if (name instanceof Transition) {
    id = name._id, name = name._name;
  } else {
    id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        transition_schedule(node, name, id, i, group, timing || transition_inherit(node, id));
      }
    }
  }

  return new Transition(groups, this._parents, name, id);
});
// CONCATENATED MODULE: ../node_modules/d3-transition/src/selection/index.js




src["selection"].prototype.interrupt = selection_interrupt;
src["selection"].prototype.transition = selection_transition;
// CONCATENATED MODULE: ../node_modules/d3-transition/src/active.js



var root = [null];

/* harmony default export */ var src_active = (function (node, name) {
  var schedules = node.__transition,
      schedule,
      i;

  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule = schedules[i]).state > SCHEDULED && schedule.name === name) {
        return new Transition([[node]], root, name, +i);
      }
    }
  }

  return null;
});
// CONCATENATED MODULE: ../node_modules/d3-transition/src/index.js
/* unused concated harmony import transition */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return src_transition_transition; });
/* unused concated harmony import active */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return src_active; });
/* unused concated harmony import interrupt */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return interrupt; });





/***/ }),

/***/ "VjiX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLowestMaxWindAxisValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getWindAxisStepOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLowestMaxRainAxisValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getRainAxisStepOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPressureAxisStepOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("hafV");


var getLowestMaxWindAxisValue = function getLowestMaxWindAxisValue(speedUnit) {
	switch (speedUnit) {
		case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SPEED_UNIT */].KNOTS:
			return 20;
		case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SPEED_UNIT */].MPH:
			return 25;
		case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SPEED_UNIT */].MS:
			return 10;
		case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SPEED_UNIT */].KMH:
			return 40;
	}
};

var getWindAxisStepOptions = function getWindAxisStepOptions(speedUnit) {
	switch (speedUnit) {
		case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SPEED_UNIT */].KNOTS:
			return [5, 10, 15, 20];
		case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SPEED_UNIT */].MPH:
			return [5, 10, 15, 20];
		case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SPEED_UNIT */].MS:
			return [2, 5, 10];
		case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SPEED_UNIT */].KMH:
			return [10, 15, 20, 25, 30];
	}
};

var getLowestMaxRainAxisValue = function getLowestMaxRainAxisValue(rainUnit) {
	return rainUnit === __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* RAIN_UNIT */].IN ? 0.2 : 3;
};

var getRainAxisStepOptions = function getRainAxisStepOptions(rainUnit) {
	return rainUnit === __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* RAIN_UNIT */].IN ? [0.1, 0.2, 0.25, 0.5, 1, 2, 4] : [1, 2, 5, 10, 20, 25, 50, 100];
};

var getPressureAxisStepOptions = function getPressureAxisStepOptions(pressureUnit) {
	return pressureUnit === __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* PRESSURE_UNIT */].INHG ? [0.1, 0.2, 0.25, 0.5, 1] : [1, 2, 3, 4, 5, 10, 20];
};

/***/ }),

/***/ "VqWv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getTemperatureColourInterpolator;
/* harmony export (immutable) */ __webpack_exports__["a"] = getRainColourInterpolator;
/* harmony export (immutable) */ __webpack_exports__["c"] = getWindColourInterpolator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__("k9aH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("hafV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unit_converters__ = __webpack_require__("rbCG");




/**
 * Return a function which takes temperature values and returns the
 * colour for that value. Used in data visualisations
 *
 * @param isLight - use a light/pale colour scale instead of a more saturated colour scale
 * @param unit - see TEMPERATURE_UNIT (default C)
 * @returns {function(number): string}
 */
function getTemperatureColourInterpolator(isLight) {
	var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* TEMPERATURE_UNIT */].C;

	var colors = void 0;

	if (isLight) {
		colors = ['#EDA8FF', '#a8b8ff', '#99ffd2', '#cfffa8', '#fff3a8', '#ffcaa8', '#ffb0a8'];
	} else {
		colors = ['#CC00FF', '#002CDE', '#007A47', '#4CAD00', '#D1B800', '#FF6600', '#FF1600'];
	}

	var interpolator = Object(__WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["interpolateRgbBasis"])(colors);

	return unit === __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* TEMPERATURE_UNIT */].F ? function (temp) {
		return interpolator(Math.max(0, Math.min(1, (temp - 32) / 54)));
	} : function (temp) {
		return interpolator(Math.max(0, Math.min(1, temp / 30)));
	};
}

/**
 * Return a function which takes rainfall values and returns the
 * colour for that value. Used in data visualisations
 *
 * @param maxValue - value where the colour depth maxes out
 * @returns {function(number): string}
 */
function getRainColourInterpolator(maxValue) {
	var interpolator = Object(__WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["interpolateRgb"])('#4BA7EB', '#0023AD');

	return function (rainfall) {
		return interpolator(Math.min(1, rainfall / maxValue));
	};
}

/**
 * Return a function which takes wind speed values and returns the
 * colour for that value. Used in data visualisations
 *
 * @param unit - see SPEED_UNIT (defaults to KMH)
 * @returns {function(number): string}
 */
function getWindColourInterpolator() {
	var unit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* SPEED_UNIT */].KMH;

	var interpolatorLow = Object(__WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["interpolateRgb"])('#222222', '#727272');

	var interpolatorHigh = Object(__WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["interpolateRgb"])('#BD5A00', '#C70000');

	var threshold = Object(__WEBPACK_IMPORTED_MODULE_2__unit_converters__["e" /* convertWindSpeed */])(50, unit);
	var upperRange = Object(__WEBPACK_IMPORTED_MODULE_2__unit_converters__["e" /* convertWindSpeed */])(40, unit);

	return function (speed) {
		var v = speed < threshold ? speed / threshold : Math.min((speed - threshold) / upperRange, 1);

		return speed < threshold ? interpolatorLow(v) : interpolatorHigh(v);
	};
}

/***/ }),

/***/ "Wjq/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"page":"page__3oCcC","content_wrapper":"content_wrapper__3f8v9","content":"content__2KO8w"};

/***/ }),

/***/ "X8eH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button_group_option":"button_group_option__1eKHL"};

/***/ }),

/***/ "Z83D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getPreviousDate;
/* harmony export (immutable) */ __webpack_exports__["b"] = getNextDate;
/* harmony export (immutable) */ __webpack_exports__["a"] = getMonthNames;
/* harmony export (immutable) */ __webpack_exports__["d"] = isDateInRange;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatters__ = __webpack_require__("gNwm");


function getPreviousDate(date) {

	var d = new Date(date);
	d.setDate(d.getDate() - 1);

	return __WEBPACK_IMPORTED_MODULE_0__formatters__["b" /* customLocale */].format('%Y-%m-%d')(d);
}

function getNextDate(date) {

	var d = new Date(date);
	d.setDate(d.getDate() + 1);

	return __WEBPACK_IMPORTED_MODULE_0__formatters__["b" /* customLocale */].format('%Y-%m-%d')(d);
}

function getMonthNames() {
	return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
}

function isDateInRange(time, minDate, maxDate) {
	var minTime = minDate != null ? Number(Object(__WEBPACK_IMPORTED_MODULE_0__formatters__["j" /* getDateTimeFormatConverter */])('%Y-%m-%d %H:%M:%S', '%Q')(minDate + ' 00:00:00')) : Number.NEGATIVE_INFINITY;

	var maxTime = maxDate != null ? Number(Object(__WEBPACK_IMPORTED_MODULE_0__formatters__["j" /* getDateTimeFormatConverter */])('%Y-%m-%d %H:%M:%S', '%Q')(maxDate + ' 00:00:00')) : Number.POSITIVE_INFINITY;

	return time >= minTime && time <= maxTime;
}

/***/ }),

/***/ "ZnYl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



/**
 * This higher order component will wrap a component in logic that monitors window width.
 * It will pass windowWidth as an additional prop down into the wrapped component, thus
 * enabling the wrapped component to be size aware.
 */
var sizeAware = function sizeAware(WrappedComponent) {

	return function (_Component) {
		_inherits(_class, _Component);

		function _class(props, context) {
			_classCallCheck(this, _class);

			var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

			_this.state = {
				windowWidth: window.innerWidth
			};
			return _this;
		}

		_class.prototype.componentDidMount = function componentDidMount() {
			var _this2 = this;

			this.handlerId = this.context.resize.addHandler(function () {
				_this2.setState({ windowWidth: window.innerWidth });
			});
		};

		_class.prototype.componentWillUnmount = function componentWillUnmount() {
			this.context.resize.removeHandler(this.handlerId);
		};

		_class.prototype.render = function render(props) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(WrappedComponent, _extends({}, props, { windowWidth: this.state.windowWidth }));
		};

		return _class;
	}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);
};

/* harmony default export */ __webpack_exports__["a"] = (sizeAware);

/***/ }),

/***/ "appZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"button__1wKCV","button_wide":"button_wide__17SsF","active":"active__2HHpc"};

/***/ }),

/***/ "bv0A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/d3-selection/src/index.js + 50 modules
var src = __webpack_require__("//ys");

// EXTERNAL MODULE: ../node_modules/d3-scale/src/index.js + 38 modules
var d3_scale_src = __webpack_require__("zL2z");

// EXTERNAL MODULE: ../node_modules/d3-axis/src/index.js + 3 modules
var d3_axis_src = __webpack_require__("mp0m");

// EXTERNAL MODULE: ../node_modules/d3-array/src/index.js + 31 modules
var d3_array_src = __webpack_require__("K0bd");

// CONCATENATED MODULE: ./utils/panelgraph/functions/layout-graph.js


function layoutGraph(graph, container) {
	var _graph$config = graph.config,
	    margins = _graph$config.margins,
	    panels = _graph$config.panels,
	    height = _graph$config.height;

	var _container$getBoundin = container.getBoundingClientRect(),
	    width = _container$getBoundin.width;

	var heightPx = typeof height === 'function' ? height(width) : height;

	// The vertical spacing in pixels in between each panel
	var panelSpacing = 25;

	// Only take into consideration active panels
	var activePanels = panels.filter(function (panel) {
		return panel.config.isActive;
	});

	var availableWidthPx = width - margins[1] - margins[3];
	var availableHeightPx = heightPx - margins[0] - margins[2] - (panels.length - 1) * panelSpacing;

	// Get the total height explicitly apportioned
	var sumExplicitHeights = Object(d3_array_src["sum"])(activePanels.map(function (panel) {
		return panel.config.height === null ? 0 : panel.config.height;
	}));

	// Get the remaining height
	var remainingHeight = Math.max(0, 1 - sumExplicitHeights);
	var numPanelsToApportion = activePanels.filter(function (panel) {
		return panel.config.height === null;
	}).length;

	// Panels with null height will get an equal share of the remaining height
	var panelHeights = activePanels.map(function (panel) {
		return panel.config.height === null ? remainingHeight / numPanelsToApportion : panel.config.height;
	});

	var y = margins[0];
	var panelLayout = [];

	for (var i = 0, n = panels.length; i < n; i++) {

		if (!panels[i].config.isActive) {
			panelLayout.push(null);
			continue;
		}

		var panelHeightPx = availableHeightPx * panelHeights[i];

		panelLayout.push({
			x: margins[3],
			width: availableWidthPx,
			y: y,
			height: panelHeightPx
		});

		y += panelHeightPx + panelSpacing;
	}

	return {
		plotAreaX: margins[3],
		plotAreaY: margins[0],
		plotAreaWidth: availableWidthPx,
		plotAreaHeight: heightPx - margins[0] - margins[2],
		width: width,
		height: heightPx,
		panels: panelLayout,
		xPadding: 1
	};
}
// CONCATENATED MODULE: ./utils/panelgraph/functions/get-axis-extent.js


function getAxisExtent(graph, panel, side) {

	// select only the series for the given side (left or right)
	var relevantSeries = side === null ? panel.config.series : panel.config.series.filter(function (s) {
		return s.config.side === side;
	});

	// Get the data sets all in one big array
	var data = Array.prototype.concat.apply([], relevantSeries.map(function (s) {

		if (s.config.type === 'area' || s.config.type === 'range-bar') {

			// combine lower values with upper values
			var lower = graph.config.data.map(function (d) {
				var value = s.config.dataAccessor(d);
				return value === null ? null : value[0];
			});

			var upper = graph.config.data.map(function (d) {
				var value = s.config.dataAccessor(d);
				return value === null ? null : value[1];
			});

			return lower.concat(upper).filter(function (value) {
				return value !== null;
			});
		}

		return graph.config.data.map(s.config.dataAccessor).filter(function (value) {
			return value !== null;
		});
	}));

	return data.length > 0 ? Object(d3_array_src["extent"])(data) : [0, 0];
}
// CONCATENATED MODULE: ./utils/panelgraph/functions/get-default-step-options.js
/**
 * Calculate a nice set of options for axis step sizes given the data min and max values.
 * @param min
 * @param max
 * @returns {number[]}
 */
function getDefaultStepOptions(min, max) {

	var dataRange = max - min;

	if (dataRange === 0) {
		return [1];
	}

	var multipliers = [1, 2, 2.5, 5];
	var startPower = Math.floor(Math.log(dataRange / 20) / Math.log(10));

	var i = 0;
	var pow = startPower;
	var opt = multipliers[i] * Math.pow(10, pow);

	var stepOpts = [];

	while (opt <= dataRange) {

		stepOpts.push(opt);

		if (++i === multipliers.length) {
			i = 0;
			pow++;
		}

		opt = multipliers[i] * Math.pow(10, pow);
	}

	return stepOpts;
}
// CONCATENATED MODULE: ./utils/panelgraph/functions/calculate-tick-values.js



var isNum = function isNum(x) {
	return typeof x === 'number';
};

/**
 * @param dataExtent - [min, max] array representing the data limits
 * @param totalPixels - total pixels available for the axis to span
 * @param options - extra constraints
 *
 * Opts can contain:
 * fixedMaxValue: force the maximum tick value to this. Takes precedence over looser constraints
 * fixedMinValue: force the minimum tick value to this. Takes precedence over looser constraints
 * fixedNumberOfTicks: force a specific number of ticks. Takes precedence over looser constraints
 * lowestMaxValue: the maximum tick value should be no lower than this
 * highestMaxValue: the maximum tick value should be no higher than this
 * lowestMinValue: the minimum tick value should be no lower than this
 * highestMinValue: the minimum tick value should be no higher than this
 * stepOptions: array of step options the algorithm will try. If none are suitable, will be ignored.
 * padding: padding on each end of the data extent. Default 0.05
 */
function calculateTickValues(dataExtent, totalPixels, options) {

	// We want to make sure the tick values are not crammed in too close together. Set a minimum
	// number of pixels required in between tick values.
	var minPixelsPerStep = 25;

	var opts = options || {};

	var dataRange = dataExtent[1] - dataExtent[0];

	// Add padding. For data with no range at all, add a default padding of 1 to each side,
	// otherwise add a padding of 10% of the data range to each side
	var padding = typeof opts.padding === 'number' ? opts.padding : 0.05;
	var paddedDataExtent = [dataExtent[0] - (dataRange === 0 ? 1 : padding * dataRange), dataExtent[1] + (dataRange === 0 ? 1 : padding * dataRange)];

	// Minimum constraints
	var min = {
		data: dataExtent[0],
		dataPadded: paddedDataExtent[0],
		fixed: opts.fixedMinValue,
		lowerConstraint: opts.lowestMinValue,
		upperConstraint: opts.highestMinValue
	};

	// Maximum constraints
	var max = {
		data: dataExtent[1],
		dataPadded: paddedDataExtent[1],
		fixed: opts.fixedMaxValue,
		lowerConstraint: opts.lowestMaxValue,
		upperConstraint: opts.highestMaxValue
	};

	// Get the bounds of the range the axis may span
	var rangeBounds = getRangeBounds(min, max);

	var ticks = null;

	if (Array.isArray(opts.stepOptions)) {

		// A set of custom step options has been explicitly provided, so try to find a good set of tick
		// values using these options.
		opts.stepOptions.sort(function (a, b) {
			return a - b;
		});
		ticks = findTicksBasedOnStepOptions(opts.stepOptions, opts, min, max, rangeBounds, totalPixels, minPixelsPerStep);
	}

	if (ticks === null) {

		// Either no custom step options were given, or none of the custom steps satisfied all of the constraints.
		// Try again with default steps.
		var steps = getDefaultStepOptions(rangeBounds.min[1], rangeBounds.max[0]);
		ticks = findTicksBasedOnStepOptions(steps, opts, min, max, rangeBounds, totalPixels, minPixelsPerStep);
	}

	if (ticks === null) {

		// still can't find step to meet constraints. Instead just split the range out ignoring some constraints.
		// Most important is number of ticks. If that is not present, just split it out so none are too close.
		var numTicks = isNum(opts.fixedNumberOfTicks) ? opts.fixedNumberOfTicks : Math.floor(totalPixels / minPixelsPerStep);

		var step = (rangeBounds.max[0] - rangeBounds.min[1]) / (numTicks - 1);
		ticks = Object(d3_array_src["range"])(rangeBounds.min[1], rangeBounds.max[0] + step * 0.1, step);
	}

	return ticks;
}

/**
 * Find an appropriate set of ticks given an array of step sizes to chose from. If such a set cannot
 * be found, null is returned.
 *
 * @param steps
 * @param opts - extra constraints
 * @param min - object containing min data
 * @param max - object containing max data
 * @param rangeBounds - object containing axis range bounds
 * @param totalPixels - total pixels the axis will span
 * @param minPixelsPerStep - how many pixels should be between each tick, at a minimum
 * @returns {number[] | null}
 */
function findTicksBasedOnStepOptions(steps, opts, min, max, rangeBounds, totalPixels, minPixelsPerStep) {

	// Loop through step options, try the different steps.
	for (var i = 0, n = steps.length; i < n; i++) {

		var step = steps[i];

		if (isNum(min.fixed) && isNum(max.fixed) && (max.fixed - min.fixed) % step !== 0) {
			// This step size cannot work given the fixed min and max values. Try another step.
			continue;
		}

		// start with min tick close as possible to the upper bound of the axis minimum value,
		// or set to the fixed minimum if it has been specified. Make sure the min tick does not
		// go below the absolute minimum value allowed.
		var minTick = isNum(min.fixed) ? min.fixed : Math.max(rangeBounds.min[0], step * Math.floor(rangeBounds.min[1] / step));

		// start with max tick close as possible to the lower bound of the axis maximum value,
		// or set to the fixed maximum if it has been specified. Make sure the max tick does not
		// go above the absolute maximum value allowed.
		var maxTick = isNum(max.fixed) ? max.fixed : Math.min(rangeBounds.max[1], step * Math.ceil(rangeBounds.max[0] / step));

		// Due to constraints, it may now be possible to have a range which doesn't divide evenly
		// by the current step size. For example, data with a max limit of 100 and a step size of 15.
		// Min tick could be calculated as 45, and max would be 105 but gets set to 100 due to an axis
		// constraint. In these cases, try to adjust the min/max ticks to get an evenly divisible range.
		var isRangeDivisible = (maxTick - minTick) % step === 0;

		if (!isRangeDivisible) {

			if (maxTick === rangeBounds.max[1] && maxTick % step > 0) {
				// try adjust min tick down, to make sure the range is divisble by the current step size.
				minTick = maxTick - step * Math.ceil((maxTick - minTick) / step);
			}

			if (minTick === rangeBounds.min[0] && minTick % step > 0) {
				// try adjust max tick up, to make sure the range is divisible by the current step size.
				maxTick = minTick + step * Math.ceil((maxTick - minTick) / step);
			}
		}

		// If the rounded value is now below the lower bound, try next step size.
		if (minTick < rangeBounds.min[0]) {
			continue;
		}

		// If the rounded value is now below the lower bound, try next step size.
		if (maxTick > rangeBounds.max[1]) {
			continue;
		}

		var numSteps = (maxTick - minTick) / step;
		var numTicks = numSteps + 1;

		if (totalPixels / numSteps < minPixelsPerStep) {
			// Ticks are too close together. Try a larger step.
			continue;
		}

		if (isNum(opts.fixedNumberOfTicks)) {

			if (numTicks > opts.fixedNumberOfTicks) {
				// Too many ticks required for this step size, unable to adjust to
				// match the required tick count.
				continue;
			}

			if (numTicks === opts.fixedNumberOfTicks) {
				// Just right!
				return Object(d3_array_src["range"])(minTick, maxTick + step, step);
			}

			// We have less ticks than needed. But we might have some room to work with...
			var canAdjust = 1 + (maxTick - minTick) / step < opts.fixedNumberOfTicks;

			// Start adjusting the min and max ticks until we reach the required number of ticks.
			// Start with the tick which has the smaller deviation from it's respective data bound.
			var adjustMinTickFirst = min.data - minTick <= maxTick - max.data;
			var _i = adjustMinTickFirst ? 0 : 1;

			do {

				var canAdjustMin = minTick - step >= rangeBounds.min[0];
				var canAdjustMax = maxTick + step <= rangeBounds.max[1];

				if (canAdjustMin && !canAdjustMax || canAdjustMin && _i % 2 === 0) {

					// Adjust the min tick downwards if either:
					// 1. The max tick is unable to be increased further without breaking constraints
					// 2. For this iteration it is the min ticks turn to be adjusted
					minTick -= step;
				} else if (canAdjustMax && !canAdjustMin || canAdjustMax && _i % 2 === 1) {

					// Adjust the max tick upwards if either:
					// 1. The min tick is unable to be decreased further without breaking constraints
					// 2. For this iteration it is the max ticks turn to be adjusted,
					maxTick += step;
				} else {

					// Neither tick value can be adjusted. An alternative step size will have to be tried.
					canAdjust = false;
					break;
				}

				numTicks += 1;
				numSteps += 1;
				_i++;
			} while (numTicks < opts.fixedNumberOfTicks);

			if (!canAdjust) {
				// Unable to adjust ticks to get required count. Try larger step.
				continue;
			}

			if (totalPixels / numSteps < minPixelsPerStep) {
				// Ticks were adjusted, but now they are too close together. Try larger step.
				continue;
			}
		}

		// At this point, our set of ticks are within axis bounds, abide by any tick count requirement that exists,
		// and are spaced out enough.
		return Object(d3_array_src["range"])(minTick, maxTick + step, step);
	}

	// If we are here, none of the steps were good enough to meet all requirements
	return null;
}

/**
 * Calculate the range bounds given the min data object and max data object.
 * It takes into consideration the present constraints on min/max values.
 *
 * @param min
 * @param max
 * @returns {{min: number[], max: number[], extent: number[]}}
 */
function getRangeBounds(min, max) {

	// The lowest minimum value permitted.
	var lowerMin = void 0;

	if (isNum(min.fixed)) {
		lowerMin = min.fixed;
	} else {
		if (isNum(min.lowerConstraint)) {
			lowerMin = min.lowerConstraint;
		} else {
			lowerMin = Number.NEGATIVE_INFINITY;
		}
	}

	// The highest minimum value permitted.
	var upperMin = void 0;

	if (isNum(min.fixed)) {
		upperMin = min.fixed;
	} else {
		if (isNum(min.upperConstraint)) {
			upperMin = Math.min(min.dataPadded, min.upperConstraint);
		} else {
			upperMin = isNum(min.lowerConstraint) ? Math.max(min.lowerConstraint, min.dataPadded) : min.dataPadded;
		}
	}

	// The lowest maximum value permitted.
	var lowerMax = void 0;

	if (isNum(max.fixed)) {
		lowerMax = max.fixed;
	} else {
		if (isNum(max.lowerConstraint)) {
			lowerMax = Math.max(max.dataPadded, max.lowerConstraint);
		} else {
			lowerMax = isNum(max.upperConstraint) ? Math.min(max.upperConstraint, max.dataPadded) : max.dataPadded;
		}
	}

	// The highest maximum value permitted.
	var upperMax = void 0;

	if (isNum(max.fixed)) {
		upperMax = max.fixed;
	} else {
		if (isNum(max.upperConstraint)) {
			upperMax = max.upperConstraint;
		} else {
			upperMax = Number.POSITIVE_INFINITY;
		}
	}

	var minExtent = lowerMax - upperMin;
	var maxExtent = upperMax - lowerMin;

	return {
		min: [lowerMin, upperMin],
		max: [lowerMax, upperMax],
		extent: [minExtent, maxExtent]
	};
}
// CONCATENATED MODULE: ./utils/panelgraph/functions/render-panel-y-axis.js
function renderPanelYAxis(parentElem, axis, x) {

	parentElem.append('g').attr('class', 'hw_panel_graph_y_axis').attr('transform', 'translate(' + x + ', 0)').call(axis);
}
// CONCATENATED MODULE: ./utils/panelgraph/functions/render-panel-gridlines.js
function renderPanelGridlines(parentElem, tickValues, scale, panelLayout, xPadding) {

	var gridlines = parentElem.append('g').attr('class', 'hw_panel_graph_y_gridlines');

	// Offset the y coordinates by half a pixel - D3 offsets axis ticks by the same amount.
	// Skip the minimum tick value, the baseline will be drawn over the top of it anyway.
	gridlines.selectAll('line').data(tickValues.slice(1)).enter().append('line').attr('x1', panelLayout.x - xPadding).attr('x2', panelLayout.x + panelLayout.width + xPadding).attr('y1', function (d) {
		return scale(d) + 0.5;
	}).attr('y2', function (d) {
		return scale(d) + 0.5;
	});
}
// CONCATENATED MODULE: ./utils/panelgraph/functions/render-panel-legend.js
function renderPanelLegend(parentElem, panel, panelLayout) {

	var x = panelLayout.x + 4;
	var y = panelLayout.y - 14;

	var boxWidth = 12;
	var boxHeight = 10;
	var boxLabelSpacing = 4;
	var itemSpacing = 25;

	panel.config.series.forEach(function (s) {

		var box = parentElem.append('rect').attr('class', 'hw_panel_graph_legend_box hw_panel_graph_legend_box_' + s.config.name).attr('x', x).attr('y', y).attr('width', boxWidth).attr('height', boxHeight);

		if (s.config.color !== null) {
			box.style('fill', s.config.color);
		}

		var text = parentElem.append('text').attr('class', 'hw_panel_graph_legend_label hw_panel_graph_legend_label_' + s.config.name).attr('x', x + boxWidth + boxLabelSpacing).attr('y', y + 9).text(s.config.label || s.config.name);

		var textDim = text.node().getBBox();

		if (x + boxWidth + boxLabelSpacing + textDim.width + 10 > panelLayout.x + panelLayout.width) {

			y += textDim.height + 4;
			x = panelLayout.x + 4;

			box.attr('x', x).attr('y', y);

			text.attr('x', x + boxWidth + boxLabelSpacing).attr('y', y + 9);
		}

		x += boxWidth + boxLabelSpacing + textDim.width + itemSpacing;
	});
}
// EXTERNAL MODULE: ../node_modules/d3-shape/src/index.js + 51 modules
var d3_shape_src = __webpack_require__("9maw");

// CONCATENATED MODULE: ./utils/panelgraph/functions/render-series-area.js


function renderAreaSeries(parentElem, graph, panel, series, xScale, yScale) {

	var areaGenerator = Object(d3_shape_src["area"])().x(function (d) {
		return xScale(graph.config.xAxis.config.dataAccessor(d));
	}).y0(function (d) {
		return yScale(series.config.dataAccessor(d)[0]);
	}).y1(function (d) {
		return yScale(series.config.dataAccessor(d)[1]);
	}).defined(function (d) {
		return series.config.dataAccessor(d) !== null;
	}).curve(series.config.curve || d3_shape_src["curveLinear"]);

	var lineGenerator = Object(d3_shape_src["line"])().x(function (d) {
		return xScale(graph.config.xAxis.config.dataAccessor(d));
	}).y(function (d) {
		return yScale(series.config.dataAccessor(d)[1]);
	}).defined(function (d) {
		return series.config.dataAccessor(d) !== null;
	}).curve(series.config.curve || d3_shape_src["curveLinear"]);

	var areaFill = parentElem.append('path').attr('class', 'hw_panel_graph_series hw_panel_graph_area_series hw_panel_graph_series_' + series.config.name).attr('d', areaGenerator(graph.config.data));

	if (series.config.color !== null) {
		areaFill.style('fill', series.config.color);
	}

	var areaBorder = parentElem.append('path').attr('class', 'hw_panel_graph_series hw_panel_graph_area_series_border hw_panel_graph_series_border_' + series.config.name).attr('d', lineGenerator(graph.config.data));

	if (series.config.color !== null) {
		areaBorder.style('stroke', series.config.color);
	}
}
// CONCATENATED MODULE: ./utils/panelgraph/functions/render-series-line.js


function renderLineSeries(parentElem, graph, panel, series, xScale, yScale) {

	var lineGenerator = Object(d3_shape_src["line"])().x(function (d) {
		return xScale(graph.config.xAxis.config.dataAccessor(d));
	}).y(function (d) {
		return yScale(series.config.dataAccessor(d));
	}).defined(function (d) {
		return series.config.dataAccessor(d) !== null;
	}).curve(series.config.curve || d3_shape_src["curveLinear"]);

	var path = parentElem.append('path').attr('class', 'hw_panel_graph_series hw_panel_graph_line_series hw_panel_graph_series_' + series.config.name).attr('d', lineGenerator(graph.config.data));

	if (series.config.color !== null) {
		path.style('stroke', series.config.color);
	}
}
// CONCATENATED MODULE: ./utils/panelgraph/functions/render-series-range-bar.js


function renderRangeBarSeries(parentElem, graph, panel, series, xScale, yScale) {

	var xData = graph.config.data.map(graph.config.xAxis.config.dataAccessor).sort(function (a, b) {
		return a - b;
	});

	var xDistances = xData.slice(1).map(function (value, index) {
		return Math.abs(xScale(value) - xScale(xData[index]));
	}).filter(function (value) {
		return value > 0;
	});

	var barWidth = xDistances.length > 0 ? Object(d3_array_src["min"])(xDistances) : Math.abs(xScale.range()[1] - xScale.range()[0]);

	parentElem.append('g').attr('class', 'hw_panel_graph_series hw_panel_graph_range_bar_series hw_panel_graph_series_' + series.config.name).selectAll('rect.' + series.config.name).data(graph.config.data.filter(function (d) {
		return series.config.dataAccessor(d) !== null;
	})).enter().append('rect').attr('x', function (d) {
		return xScale(graph.config.xAxis.config.dataAccessor(d)) - barWidth / 2;
	}).attr('y', function (d) {
		var value = series.config.dataAccessor(d);
		return Math.min(yScale(value[0]), yScale(value[1]));
	}).attr('width', barWidth + 0.5).attr('height', function (d) {
		var value = series.config.dataAccessor(d);
		return Math.abs(yScale(value[0]) - yScale(value[1]));
	});
}
// CONCATENATED MODULE: ./utils/panelgraph/functions/render-series-scatter.js


function renderScatterSeries(parentElem, graph, panel, series, xScale, yScale) {

	var symbolGenerator = Object(d3_shape_src["symbol"])().size(function (value) {
		return value === null ? 0 : 16;
	});

	var points = parentElem.append('g').attr('class', 'hw_panel_graph_series hw_panel_graph_scatter_series hw_panel_graph_series_' + series.config.name).selectAll('path.' + series.config.name).data(graph.config.data).enter().append('path').attr('transform', function (d) {
		var x = xScale(graph.config.xAxis.config.dataAccessor(d));
		var y = yScale(series.config.dataAccessor(d));
		return 'translate(' + x + ',' + y + ')';
	}).attr('d', function (d) {
		var value = series.config.dataAccessor(d);
		return symbolGenerator(value);
	});

	if (series.config.color !== null) {
		points.style('fill', series.config.color);
	}
}
// CONCATENATED MODULE: ./utils/panelgraph/functions/render-series.js





function renderSeries(parentElem, graph, panel, series, xScale, yScale) {

	switch (series.config.type) {
		case 'line':
			renderLineSeries(parentElem, graph, panel, series, xScale, yScale);
			break;
		case 'area':
			renderAreaSeries(parentElem, graph, panel, series, xScale, yScale);
			break;
		case 'range-bar':
			renderRangeBarSeries(parentElem, graph, panel, series, xScale, yScale);
			break;
		case 'scatter':
			renderScatterSeries(parentElem, graph, panel, series, xScale, yScale);
			break;
	}
}
// CONCATENATED MODULE: ./utils/panelgraph/functions/render-panel-baseline.js
function renderPanelBaseline(panelElem, panelLayout, xPadding) {

	// Offset the y coordinates by half a pixel - D3 offsets axis ticks by the same amount.
	panelElem.append('line').attr('class', 'hw_panel_graph_panel_baseline').attr('x1', panelLayout.x - xPadding).attr('x2', panelLayout.x + panelLayout.width + xPadding).attr('y1', panelLayout.y + panelLayout.height + 0.5).attr('y2', panelLayout.y + panelLayout.height + 0.5);
}
// CONCATENATED MODULE: ./utils/panelgraph/functions/render-panel-plot-bands.js
function renderPanelPlotBands(parentElem, panelLayout, xPadding, plotBands, xScale) {

	var plotLinesGroupElem = parentElem.append('g').attr('class', 'hw_panel_graph_plot_bands');

	plotBands.forEach(function (plotBand) {

		var x1 = plotBand.config.range[0] === null ? panelLayout.x - xPadding : xScale(plotBand.config.range[0]);

		var x2 = plotBand.config.range[1] === null ? panelLayout.x + panelLayout.width + xPadding : xScale(plotBand.config.range[1]);

		plotLinesGroupElem.append('rect').attr('class', 'hw_panel_graph_plot_band_' + plotBand.config.name).attr('x', x1).attr('y', panelLayout.y).attr('width', x2 - x1).attr('height', panelLayout.height);
	});
}
// CONCATENATED MODULE: ./utils/panelgraph/functions/render-panel-plot-lines.js
function renderPanelPlotLines(parentElem, panelLayout, panelIndex, plotLines, xScale) {

	var plotLinesGroupElem = parentElem.append('g').attr('class', 'hw_panel_graph_plot_lines');

	plotLines.forEach(function (plotLine) {

		var x = xScale(plotLine.config.x);

		plotLinesGroupElem.append('line').attr('class', 'hw_panel_graph_plot_line_' + plotLine.config.name).attr('x1', x).attr('x2', x).attr('y1', panelLayout.y).attr('y2', panelLayout.y + panelLayout.height);

		// Render the plot line label if this is the top panel and a label has been specified.
		if (plotLine.config.label !== null && panelIndex === 0) {
			plotLinesGroupElem.append('text').attr('class', 'hw_panel_graph_plot_line_label_' + plotLine.config.name).attr('x', x).attr('y', panelLayout.y + 2).attr('dy', '1em').attr('text-anchor', 'middle').text(plotLine.config.label);
		}
	});
}
// EXTERNAL MODULE: ./utils/panelgraph/components/axis-y.js
var axis_y = __webpack_require__("N0ou");

// CONCATENATED MODULE: ./utils/panelgraph/functions/render-panel.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
















function renderPanel(parentElem, graph, panel, panelIndex, panelLayout, xPadding, xScale, defs) {

	defs.append('clipPath').attr('id', 'hw_panel_graph_clip_path_' + panelIndex).append('rect').attr('x', panelLayout.x - xPadding).attr('y', panelLayout.y).attr('width', panelLayout.width + 2 * xPadding).attr('height', panelLayout.height);

	var panelElem = parentElem.append('g').attr('class', 'hw_panel_graph_panel');

	panelElem.append('rect').attr('class', 'hw_panel_graph_panel_bg').attr('x', panelLayout.x).attr('y', panelLayout.y).attr('width', panelLayout.width).attr('height', panelLayout.height);

	// Make sure to render plotlines behind the data.
	renderPanelPlotBands(panelElem, panelLayout, xPadding, graph.config.plotBands, xScale);
	renderPanelPlotLines(panelElem, panelLayout, panelIndex, graph.config.plotLines, xScale);

	var clippedRegion = panelElem.append('g').attr('clip-path', 'url(#hw_panel_graph_clip_path_' + panelIndex + ')');

	renderPanelBaseline(panelElem, panelLayout, xPadding);

	if (panel.config.axisDual === null && panel.config.axisLeft === null && panel.config.axisRight === null) {
		// Default to a dual axis
		panel.axisDual(Object(axis_y["a" /* yAxis */])());
	}

	var tickValuesLeft = void 0,
	    tickValuesRight = void 0;
	var scaleLeft = void 0,
	    scaleRight = void 0;
	var tickFormatterLeft = void 0,
	    tickFormatterRight = void 0;

	var panelAxisLeft = null;
	var panelAxisRight = null;

	if (panel.config.axisDual) {

		tickValuesLeft = tickValuesRight = getTickValues(panel.config.axisDual, null, panelLayout.height, getAxisExtent(graph, panel, null));

		scaleLeft = scaleRight = getScale(panelLayout, tickValuesLeft);

		tickFormatterLeft = panel.config.axisDual.config.formatters[0];
		tickFormatterRight = panel.config.axisDual.config.formatters[1] || tickFormatterLeft;

		panelAxisLeft = getD3Axis('left', tickValuesLeft, scaleLeft, tickFormatterLeft);
		panelAxisRight = getD3Axis('right', tickValuesRight, scaleRight, tickFormatterRight);
	} else if (panel.config.axisLeft || panel.config.axisRight) {

		var primaryAxis = void 0;

		if (!panel.config.axisRight) {
			primaryAxis = 'left';
		} else if (!panel.config.axisLeft) {
			primaryAxis = 'right';
		} else {
			primaryAxis = panel.config.axisRight.config.isPrimary ? 'right' : 'left';
		}

		if (primaryAxis === 'left') {

			tickValuesLeft = getTickValues(panel.config.axisLeft, 'left', panelLayout.height, getAxisExtent(graph, panel, 'left'));

			scaleLeft = getScale(panelLayout, tickValuesLeft);
			tickFormatterLeft = panel.config.axisLeft.config.formatters[0];
			panelAxisLeft = getD3Axis('left', tickValuesLeft, scaleLeft, tickFormatterLeft);

			if (panel.config.axisRight) {

				// Get tick values for right axis with matching number of ticks as the left axis
				tickValuesRight = getTickValues(panel.config.axisRight, 'right', panelLayout.height, getAxisExtent(graph, panel, 'right'), tickValuesLeft.length);

				scaleRight = getScale(panelLayout, tickValuesRight);
				tickFormatterRight = panel.config.axisRight.config.formatters[0];
				panelAxisRight = getD3Axis('right', tickValuesRight, scaleRight, tickFormatterRight);
			}
		} else {

			tickValuesRight = getTickValues(panel.config.axisRight, 'right', panelLayout.height, getAxisExtent(graph, panel, 'right'));

			scaleRight = getScale(panelLayout, tickValuesRight);
			tickFormatterRight = panel.config.axisRight.config.formatters[0];
			panelAxisRight = getD3Axis('right', tickValuesRight, scaleRight, tickFormatterRight);

			if (panel.config.axisLeft) {

				// Get tick values for left axis with matching number of ticks as the right axis
				tickValuesLeft = getTickValues(panel.config.axisLeft, 'left', panelLayout.height, getAxisExtent(graph, panel, 'left'), tickValuesRight.length);

				scaleLeft = getScale(panelLayout, tickValuesLeft);
				tickFormatterLeft = panel.config.axisLeft.config.formatters[0];
				panelAxisLeft = getD3Axis('left', tickValuesLeft, scaleLeft, tickFormatterLeft);
			}
		}
	}

	renderPanelGridlines(clippedRegion, tickValuesLeft, scaleLeft, panelLayout, xPadding);

	if (panelAxisLeft !== null) {
		renderPanelYAxis(panelElem, panelAxisLeft, panelLayout.x - xPadding);
	}

	if (panelAxisRight !== null) {
		renderPanelYAxis(panelElem, panelAxisRight, panelLayout.x + panelLayout.width + xPadding);
	}

	if (graph.config.legendEnabled) {
		renderPanelLegend(panelElem, panel, panelLayout);
	}

	panel.config.series.forEach(function (s) {
		s.associatedScale = s.config.side === 'right' ? scaleRight : scaleLeft;
		renderSeries(clippedRegion, graph, panel, s, xScale, s.associatedScale);
	});
}

function getScale(panelLayout, tickValues) {
	var axisExtent = Object(d3_array_src["extent"])(tickValues);

	return Object(d3_scale_src["scaleLinear"])().domain(axisExtent).range([panelLayout.y + panelLayout.height, panelLayout.y]);
}

function getTickValues(axis, side, height, dataExtent) {
	var fixedNumberOfTicks = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;


	if (Array.isArray(axis.config.tickValues)) {
		return axis.config.tickValues;
	}

	var existingConstraints = axis.config.constraints || {};

	var constraints = fixedNumberOfTicks === null ? existingConstraints : _extends({}, existingConstraints, { fixedNumberOfTicks: fixedNumberOfTicks });

	return calculateTickValues(dataExtent, height, constraints);
}

function getD3Axis(side, tickValues, scale, formatter) {
	return (side === 'left' ? Object(d3_axis_src["axisLeft"])() : Object(d3_axis_src["axisRight"])()).scale(scale).tickValues(tickValues).tickFormat(formatter).tickSizeInner(5).tickSizeOuter(0);
}
// EXTERNAL MODULE: ./utils/object-helpers.js
var object_helpers = __webpack_require__("o4Fd");

// CONCATENATED MODULE: ./utils/panelgraph/functions/position-individual-tooltips.js



function positionIndividualTooltips(layout, tooltips, series, closestPoint) {

	// Minimum spacing between tooltips (pixels)
	var minTooltipSpacing = 3;

	// Tooltips should not protrude above this top limit
	var topLimit = layout.plotAreaY + 5;

	// Tooltips should not protrude below this bottom limit
	var bottomLimit = layout.plotAreaY + layout.plotAreaHeight - 5;

	// Collect positional/dimensional information for each tooltip, but only for enabled tooltips.
	var yTooltips = Object(object_helpers["a" /* filterObj */])(tooltips.y, function (name, tt) {
		return tt.isEnabled;
	});

	var anyYTooltips = Object.keys(yTooltips).length > 0;

	var tooltipDimensions = anyYTooltips ? getTooltipDimensions(yTooltips, series, closestPoint) : [];

	// Dimensions of the x tooltips
	var xTooltipWidth = tooltips.x === null ? -1 : tooltips.x.top.node().offsetWidth;
	var xTooltipHeight = tooltips.x === null ? -1 : tooltips.x.top.node().offsetHeight;

	// Find the width of the widest tooltip
	// const maxYTooltipWidth = max(tooltipDimensions.map(dim => dim.width));
	// const maxTooltipWidth = Math.max(xTooltipWidth, maxYTooltipWidth);

	// If the widest tooltip does not comfortably fit on the left side of the closest point,
	// we will display all tooltips on the right side of the closest data point instead
	var displayOnRightSide = closestPoint.x < 160; // prevent flickering of which side tooltip sits on
	// const displayOnRightSide = closestPoint.x - maxTooltipWidth - 10 < layout.plotAreaX + 10;

	if (tooltipDimensions.length > 0) {

		// Calculate the left position for each tooltip.
		tooltipDimensions.forEach(function (dim) {
			dim.left = displayOnRightSide ? closestPoint.x + 10 : closestPoint.x - dim.width - 10;
		});

		// Sort from top to bottom
		tooltipDimensions.sort(function (a, b) {
			return a.top - b.top;
		});

		var overlaps = computeOverlaps(tooltipDimensions, topLimit, bottomLimit);

		// Iterate through a positioning algorithm which attempts to space the tooltips
		// out and remove any overlaps. Set a max iteration limit in case this isn't possible.
		var i = 0;

		while (Object(d3_array_src["min"])(overlaps) < minTooltipSpacing && i < 10) {

			adjustPositions(tooltipDimensions, overlaps, minTooltipSpacing);

			// Get updated set of overlaps after adjustments have been performed.
			overlaps = computeOverlaps(tooltipDimensions, topLimit, bottomLimit);

			i++;
		}

		// Now set the positions of the tooltip elements!
		tooltipDimensions.forEach(function (dim) {
			tooltips.y[dim.name].elem.style('left', dim.left + 'px').style('top', dim.top + 'px');
		});
	}

	if (tooltips.x !== null) {

		// Find the left position of the X tooltips
		var xTooltipLeft = displayOnRightSide ? closestPoint.x + 10 : closestPoint.x - xTooltipWidth - 10;

		// Position the top X tooltip
		tooltips.x.top.style('left', xTooltipLeft + 'px').style('top', layout.plotAreaY - xTooltipHeight - 5 + 'px');

		// Position the bottom Y tooltip
		tooltips.x.bottom.style('left', xTooltipLeft + 'px').style('top', layout.plotAreaY + layout.plotAreaHeight + 5 + 'px');
	}
}

function getTooltipDimensions(tooltips, series, closestPoint) {
	return Object(object_helpers["d" /* mapObjToArr */])(tooltips, function (name, tooltip) {

		var currentSeries = series[name];
		var currentSeriesValue = currentSeries.config.dataAccessor(closestPoint.value);
		var y = currentSeries.associatedScale(currentSeries.config.type === 'area' ? currentSeriesValue[1] : currentSeriesValue);

		var node = tooltip.elem.node();

		var w = node.offsetWidth;
		var h = node.offsetHeight;
		var top = y - h - 10;

		return {
			name: name,
			top: top,
			bottom: top + h,
			width: w,
			height: h
		};
	});
}

function adjustPositions(tooltipDimensions, overlaps, minTooltipSpacing) {

	var tooltipCount = tooltipDimensions.length;

	if (overlaps[0] < 0) {

		// If the top tooltip overlaps the top limit, adjust it downwards.
		var shiftDownBy = -overlaps[0];
		tooltipDimensions[0].top += shiftDownBy;
		tooltipDimensions[0].bottom += shiftDownBy;
	} else if (overlaps[overlaps.length - 1] < 0) {

		// If the bottom tooltip overlaps the bottom limit, adjust it upwards.
		var shiftUpBy = -overlaps[overlaps.length - 1];
		tooltipDimensions[tooltipCount - 1].top -= shiftUpBy;
		tooltipDimensions[tooltipCount - 1].bottom -= shiftUpBy;
	} else {

		// Otherwise iterate through the middle tooltips and adjust them to try and remove
		// any overlaps.

		for (var j = 1, n = overlaps.length; j < n - 1; j++) {

			if (overlaps[j] < minTooltipSpacing) {

				// The total amount that this tooltip-pair needs shifting apart. This will be split,
				// with the top tooltip being pushed upwards and the bottom tooltip being pushed
				// downwards, if possible.
				var shiftAmount = Math.abs(overlaps[j] - minTooltipSpacing);

				var shiftAmountTop = void 0;
				var shiftAmountBottom = void 0;

				if (j === 1) {

					// Overlap between top-most tooltip and the one directly below it.
					// Only shift up the top-most item up if there is room to do so.
					var canShiftUp = overlaps[0] > 0;

					if (canShiftUp) {

						shiftAmountTop = Math.min(0.5 * shiftAmount, overlaps[0]);
						shiftAmountBottom = shiftAmount - shiftAmountTop;
					} else {

						shiftAmountTop = 0;
						shiftAmountBottom = shiftAmount;
					}
				} else if (j === n - 2) {

					// Overlap between the bottom-most tooltip and the one directly above it.
					// Only shift down the bottom-most item if there is room to do so.
					var canShiftDown = overlaps[n - 1] > 0;

					if (canShiftDown) {

						shiftAmountBottom = Math.min(0.5 * shiftAmount, overlaps[n - 1]);
						shiftAmountTop = shiftAmount - shiftAmountBottom;
					} else {

						shiftAmountBottom = 0;
						shiftAmountTop = shiftAmount;
					}
				} else {

					// For other overlaps, shift the top one up and the bottom one down by equal amounts.
					shiftAmountTop = 0.5 * shiftAmount;
					shiftAmountBottom = 0.5 * shiftAmount;
				}

				// Adjust position of upper tooltip in the pair
				tooltipDimensions[j - 1].top -= shiftAmountTop;
				tooltipDimensions[j - 1].bottom -= shiftAmountTop;

				// Adjust position of lower tooltip in the pair
				tooltipDimensions[j].top += shiftAmountBottom;
				tooltipDimensions[j].bottom += shiftAmountBottom;
			}
		}
	}
}

function computeOverlaps(tooltipDimensions, topLimit, bottomLimit) {

	var n = tooltipDimensions.length;

	// The first overlap is between the top limit and the top-most tooltip.
	var overlaps = [tooltipDimensions[0].top - topLimit];

	for (var i = 1; i < n; i++) {
		overlaps.push(tooltipDimensions[i].top - tooltipDimensions[i - 1].bottom);
	}

	// The last overlap is between the bottom-most tooltip and the bottom limit.
	overlaps.push(bottomLimit - tooltipDimensions[n - 1].bottom);

	return overlaps;
}
// CONCATENATED MODULE: ./utils/panelgraph/functions/get-closest-point.js
function getClosestPoint(graph, xScale, xData, position) {

	// Convert x coordinate into a value within the scale's domain
	var domainXCoordinate = xScale.invert(position[0]);

	// Whether we are searching forwards from the start index or backwards
	var searchForwards = position[0] > (typeof graph.lastActivePositionX === 'number' ? graph.lastActivePositionX : 0);

	// The start index to start searching from when finding the nearest data point
	var startIndex = graph.lastActivePoint ? graph.lastActivePoint.index : searchForwards ? 0 : xData.length - 1;

	var closestPointIndex = getClosestPointIndex(xData, domainXCoordinate, startIndex, searchForwards);
	var closestPoint = graph.config.data[closestPointIndex];

	var closestPointDomainX = xData[closestPointIndex];
	var closestPointX = xScale(closestPointDomainX);

	return {
		index: closestPointIndex,
		value: closestPoint,
		x: closestPointX,
		domainX: closestPointDomainX
	};
}

function getClosestPointIndex(xData, domainXCoordinate, startIndex, searchForwards) {

	var minDiff = Number.POSITIVE_INFINITY;
	var i = startIndex;

	var iterate = function iterate(i) {
		var x = xData[i];
		var diff = Math.abs(domainXCoordinate - x);
		if (diff < minDiff) {
			minDiff = diff;
			return false;
		}
		return true;
	};

	// Find the index of the closest point by calculating the diff between each X value
	// and the domain X coordinate. The X data should be in order, so once we find
	// a diff larger than the previous we can stop searching. To optimise the algorithm,
	// we start at a previous index and search in the direction of change in the x-direction.

	if (searchForwards) {

		var n = xData.length;

		for (i = startIndex; i < n; i++) {

			var isDone = iterate(i);

			if (isDone) {
				break;
			}
		}
	} else {

		for (i = startIndex; i >= 0; i--) {

			var _isDone = iterate(i);

			if (_isDone) {
				break;
			}
		}
	}

	return searchForwards ? i - 1 : i + 1;
}
// EXTERNAL MODULE: ./utils/panelgraph/constants.js
var constants = __webpack_require__("gmeS");

// CONCATENATED MODULE: ./utils/panelgraph/functions/position-combined-tooltip.js



function positionCombinedTooltip(layout, tooltip, series, closestPoint) {
	var position = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'data';


	// Find the width of the widest tooltip
	var tooltipDim = tooltip.container.node().getBoundingClientRect();

	var cursorPadding = 25;
	var plotAreaPadding = 5;

	if (position === 'top') {
		var rightPosition = closestPoint.x + cursorPadding;
		var rightLimit = layout.plotAreaX + layout.plotAreaWidth - plotAreaPadding;
		var _displayOnRightSide = rightPosition + tooltipDim.width <= rightLimit;

		tooltip.container.style('left', (_displayOnRightSide ? rightPosition : closestPoint.x - tooltipDim.width - cursorPadding) + 'px').style('top', layout.plotAreaY + plotAreaPadding + 'px');

		return;
	}

	// If the widest tooltip does not comfortably fit on the left side of the closest point,
	// we will display all tooltips on the right side of the closest data point instead
	var displayOnRightSide = closestPoint.x - tooltipDim.width - cursorPadding < layout.plotAreaX + plotAreaPadding;

	if (displayOnRightSide) {
		tooltip.container.style('left', closestPoint.x + cursorPadding + 'px');
	} else {
		tooltip.container.style('left', closestPoint.x - tooltipDim.width - cursorPadding + 'px');
	}

	var yValues = [];

	Object(object_helpers["b" /* forEachObj */])(series, function (name, s) {
		var currentSeriesValue = s.config.dataAccessor(closestPoint.value);
		if (currentSeriesValue !== null) {
			var isRange = s.config.type === 'area' || s.config.type === 'range-bar';
			var y = s.associatedScale(isRange ? currentSeriesValue[1] : currentSeriesValue);
			yValues.push(y);
		}
	});

	if (yValues.length > 0) {

		var y = Object(d3_array_src["mean"])(yValues);

		var tooltipY = y - tooltipDim.height;

		if (tooltipY < layout.plotAreaY + plotAreaPadding) {
			tooltipY = layout.plotAreaY + plotAreaPadding;
		} else if (tooltipY + tooltipDim.height > layout.plotAreaY + layout.plotAreaHeight - plotAreaPadding) {
			tooltipY = layout.plotAreaY + layout.plotAreaHeight - tooltipDim.height - plotAreaPadding;
		}

		tooltip.container.style('top', tooltipY + 'px');
	}
}
// CONCATENATED MODULE: ./utils/panelgraph/functions/add-tooltips.js







function addTooltips(mode, graph, container, svgElem, layout, xScale) {

	var allSeries = Array.prototype.concat.apply([], graph.config.panels.map(function (panel) {
		return panel.config.series;
	}));

	var xData = graph.config.data.map(graph.config.xAxis.config.dataAccessor);

	var cursor = svgElem.append('line').attr('class', 'hw_panel_graph_tooltip_cursor').style('stroke-opacity', 0).attr('x1', layout.plotAreaX).attr('x2', layout.plotAreaX).attr('y1', layout.plotAreaY).attr('y2', layout.plotAreaY + layout.plotAreaHeight);

	var activePointsGroup = svgElem.append('g').attr('class', 'hw_panel_graph_active_points').style('fill-opacity', 0);

	var activePoints = {};
	var series = {};

	var isTooltipCombined = mode === constants["a" /* TOOLTIP_MODE */].COMBINED || mode === constants["a" /* TOOLTIP_MODE */].COMBINED_REVERSE;

	// Create the active point elements for each series
	allSeries.forEach(function (s) {
		series[s.config.name] = s;

		if (!s.config.activePointEnabled) {
			return;
		}

		var ptElem = activePointsGroup.append('circle').attr('class', 'hw_panel_graph_active_point_' + s.config.name).attr('r', 6);

		if (s.config.color !== null) {
			ptElem.style('fill', s.config.color);
		}

		activePoints[s.config.name] = {
			isEnabled: false,
			elem: ptElem
		};
	});

	var tooltips = {
		mode: mode,
		x: isTooltipCombined ? null : {},
		y: isTooltipCombined ? null : {},
		combined: isTooltipCombined ? {} : null
	};

	if (tooltips.x !== null) {

		tooltips.x.top = container.append('div').attr('class', 'hw_panel_graph_tooltip hw_panel_graph_tooltip_x').style('visibility', 'hidden');

		tooltips.x.bottom = container.append('div').attr('class', 'hw_panel_graph_tooltip hw_panel_graph_tooltip_x').style('visibility', 'hidden');
	}

	if (isTooltipCombined) {

		tooltips.combined = {
			labels: {}
		};

		tooltips.combined.container = container.append('div').attr('class', 'hw_panel_graph_tooltip_combined').style('visibility', 'hidden');

		tooltips.combined.labels.x = tooltips.combined.container.append('div').attr('class', 'hw_panel_graph_tooltip_combined_label_x');

		tooltips.combined.labels.y = {};

		var orderedSeries = allSeries.concat([]).sort(function (a, b) {
			var orderA = a.config.tooltipOrder === null ? Number.MAX_SAFE_INTEGER : a.config.tooltipOrder;
			var orderB = b.config.tooltipOrder === null ? Number.MAX_SAFE_INTEGER : b.config.tooltipOrder;
			return orderA - orderB;
		});

		var _series = mode === constants["a" /* TOOLTIP_MODE */].COMBINED_REVERSE ? orderedSeries.reverse() : orderedSeries;

		_series.forEach(function (s) {
			var ttLine = tooltips.combined.container.append('div').attr('class', 'hw_panel_graph_tooltip_combined_series_entry');

			var seriesName = ttLine.append('span').attr('class', 'hw_panel_graph_tooltip_combined_label_series_name hw_panel_graph_tooltip_combined_label_series_name_' + s.config.name).text(s.config.label + ': ');

			if (s.config.color !== null) {
				seriesName.style('color', s.config.color);
			}

			var seriesValue = ttLine.append('span').attr('class', 'hw_panel_graph_tooltip_combined_label_series_value hw_panel_graph_tooltip_combined_label_series_value_' + s.config.name);

			tooltips.combined.labels.y[s.config.name] = {
				elem: seriesValue,
				isEnabled: false
			};
		});
	} else {

		// Create the tooltip boxes
		allSeries.forEach(function (s) {
			var ttElem = container.append('div').attr('class', 'hw_panel_graph_tooltip hw_panel_graph_tooltip_y hw_panel_graph_tooltip_y_' + s.config.name).style('visibility', 'hidden');

			if (s.config.color !== null) {
				ttElem.style('color', s.config.color);
			}

			tooltips.y[s.config.name] = {
				isEnabled: false,
				elem: ttElem
			};
		});
	}

	var eventCapturingBox = svgElem.append('rect').attr('class', 'hw_panel_graph_event_capturing_box').attr('x', layout.plotAreaX).attr('y', layout.plotAreaY).attr('width', layout.plotAreaWidth).attr('height', layout.plotAreaHeight);

	eventCapturingBox.on('mouseover', function () {
		// Make sure the cursor is positioned before showing it. Mousemove may not
		// necessarily fire immediately after mouseover.
		var position = Object(src["mouse"])(svgElem.node());

		updateTooltips(graph, layout, cursor, activePoints, tooltips, series, graph.config.xAxis, xScale, xData, position);
		showCursor(cursor);
		showActivePoints(activePointsGroup);

		if (tooltips.x !== null) {
			showXTooltips(tooltips.x);
		}
	});

	var hide = function hide() {
		hideCursor(cursor);
		hideActivePoints(activePointsGroup);
		hideTooltips(tooltips);
	};

	eventCapturingBox.on('mouseout', hide);

	eventCapturingBox.on('mousemove', function () {
		var position = Object(src["mouse"])(svgElem.node());
		updateTooltips(graph, layout, cursor, activePoints, tooltips, series, graph.config.xAxis, xScale, xData, position);
	});

	eventCapturingBox.on('touchstart', function () {
		// Make sure the cursor is positioned before showing it. Mousemove may not
		// necessarily fire immediately after mouseover.
		var position = Object(src["touches"])(svgElem.node())[0];

		updateTooltips(graph, layout, cursor, activePoints, tooltips, series, graph.config.xAxis, xScale, xData, position);
		showCursor(cursor);
		showActivePoints(activePointsGroup);
		// The Y tooltips are shown and hidden each time tooltips are updated, so don't need to do that here. Only X tooltips.
		if (tooltips.x !== null) {
			showXTooltips(tooltips.x);
		}
	});

	eventCapturingBox.on('touchmove', function () {
		// Make sure the cursor is positioned before showing it. Mousemove may not
		// necessarily fire immediately after mouseover.
		var position = Object(src["touches"])(svgElem.node())[0];
		updateTooltips(graph, layout, cursor, activePoints, tooltips, series, graph.config.xAxis, xScale, xData, position);
	});

	// Expose event capturing box
	graph.eventCapturingBox = eventCapturingBox.node();

	// Expose the hide handler, so tooltips can be manually hidden in response to some external events.
	graph.hideTooltipFn = hide;
}

function showXTooltips(xTooltips) {
	xTooltips.top.style('visibility', '');
	xTooltips.bottom.style('visibility', '');
}

function hideTooltips(tooltips) {

	if (tooltips.y !== null) {
		// Hide the enabled tooltips still displayed on the screen
		Object(object_helpers["b" /* forEachObj */])(tooltips.y, function (seriesName, tooltip) {
			if (tooltip.isEnabled) {
				tooltip.elem.style('visibility', 'hidden');
			}
		});
	}

	if (tooltips.combined !== null) {
		tooltips.combined.container.style('visibility', 'hidden');
	}

	if (tooltips.x !== null) {
		tooltips.x.top.style('visibility', 'hidden');
		tooltips.x.bottom.style('visibility', 'hidden');
	}
}

function updateTooltips(graph, layout, cursor, activePoints, tooltips, series, xAxis, xScale, xData, position) {

	if (position[0] !== graph.lastActivePositionX) {

		// todo handle no closest point
		var closestPoint = getClosestPoint(graph, xScale, xData, position);

		if (tooltips.y !== null) {
			// Toggle tooltip elements on and off depending on their isEnabled state
			Object(object_helpers["b" /* forEachObj */])(tooltips.y, function (name, tooltip) {
				tooltip.isEnabled = series[name].config.dataAccessor(closestPoint.value) !== null;
				tooltip.elem.style('visibility', tooltip.isEnabled ? 'visible' : 'hidden');
			});
		}

		if (tooltips.combined !== null) {
			tooltips.combined.container.style('visibility', 'visible');

			// Toggle tooltip elements on and off depending on their isEnabled state
			Object(object_helpers["b" /* forEachObj */])(tooltips.combined.labels.y, function (name, tooltip) {
				tooltip.isEnabled = series[name].config.dataAccessor(closestPoint.value) !== null;
			});
		}

		// Toggle active points elements on and off depending on their isEnabled state
		Object(object_helpers["b" /* forEachObj */])(activePoints, function (name, point) {
			point.isEnabled = series[name].config.dataAccessor(closestPoint.value) !== null;
			point.elem.style('display', point.isEnabled ? '' : 'none');
		});

		updateTooltipsContent(tooltips, series, xAxis, closestPoint);
		positionTooltipComponents(graph, layout, cursor, series, activePoints, tooltips, closestPoint);

		// Keep track of the new active point index and x position to guide the process of finding
		// the closest data point the next time positioning is required.
		graph.lastActivePositionX = position[0];
		graph.lastActivePoint = closestPoint;
	}
}

function updateTooltipsContent(tooltips, series, xAxis, closestPoint) {

	if (tooltips.y !== null) {
		Object(object_helpers["b" /* forEachObj */])(tooltips.y, function (seriesName, tooltip) {
			if (tooltip.isEnabled) {
				var formattedValue = series[seriesName].config.tooltipFormatter(closestPoint.value);
				tooltip.elem.text(formattedValue);
			}
		});
	}

	if (tooltips.combined !== null) {
		Object(object_helpers["b" /* forEachObj */])(tooltips.combined.labels.y, function (seriesName, tooltip) {
			if (tooltip.isEnabled) {
				var formattedValue = series[seriesName].config.tooltipFormatter(closestPoint.value);
				tooltip.elem.text(formattedValue);
			} else {
				tooltip.elem.text('---');
			}
		});

		var formattedXValue = xAxis.config.tooltipFormatter(closestPoint.value);
		tooltips.combined.labels.x.text(formattedXValue);
	}

	if (tooltips.x !== null) {
		var _formattedXValue = xAxis.config.tooltipFormatter(closestPoint.value);
		tooltips.x.top.text(_formattedXValue);
		tooltips.x.bottom.text(_formattedXValue);
	}
}

function positionTooltipComponents(graph, layout, cursor, series, activePoints, tooltips, closestPoint) {

	positionCursor(cursor, closestPoint.x);
	positionActivePoints(activePoints, series, closestPoint);

	if (tooltips.mode === constants["a" /* TOOLTIP_MODE */].COMBINED || tooltips.mode === constants["a" /* TOOLTIP_MODE */].COMBINED_REVERSE) {
		positionCombinedTooltip(layout, tooltips.combined, series, closestPoint, graph.config.combinedTooltipPosition);
	} else {
		positionIndividualTooltips(layout, tooltips, series, closestPoint);
	}
}

function showCursor(cursor) {
	cursor.style('stroke-opacity', 1);
}

function hideCursor(cursor) {
	cursor.style('stroke-opacity', 0);
}

function positionCursor(cursor, x) {
	cursor.attr('x1', x).attr('x2', x);
}

function showActivePoints(points) {
	points.style('stroke-opacity', 1);
	points.style('fill-opacity', 1);
}

function hideActivePoints(points) {
	points.style('stroke-opacity', 0);
	points.style('fill-opacity', 0);
}

function positionActivePoints(activePoints, series, closestPoint) {

	for (var seriesName in series) {
		if (Object.prototype.hasOwnProperty.call(series, seriesName)) {

			var currentSeries = series[seriesName];
			var point = activePoints[seriesName];

			if (!point) {
				continue;
			}

			// Only move the point if it is enabled
			if (point.isEnabled) {

				var pointY = currentSeries.config.dataAccessor(closestPoint.value);

				// Area series have lower and upper data points. Return the top point (top of the area shape)
				var domainY = currentSeries.config.type === 'area' ? pointY[1] : pointY;

				var y = currentSeries.associatedScale(domainY);

				point.elem.attr('cx', closestPoint.x);
				point.elem.attr('cy', y);
			}
		}
	}
}
// CONCATENATED MODULE: ./utils/panelgraph/functions/render-x-axis.js
function renderXAxis(parentElem, axis, y) {

	parentElem.append('g').attr('class', 'hw_panel_graph_x_axis').attr('transform', 'translate(0,' + y + ')').call(axis);
}
// CONCATENATED MODULE: ./utils/panelgraph/functions/render-graph.js










function renderGraph(graph, containerElem) {

	var layout = layoutGraph(graph, containerElem);

	var container = Object(src["select"])(containerElem);
	container.html('');

	if (graph.config.name) {
		container.node().classList.add('hw_panel_graph_' + graph.config.name);
	}

	var svg = container.append('svg').attr('width', layout.width).attr('height', layout.height);

	var defs = svg.append('defs');

	var panelsGroupElem = svg.append('g').attr('class', 'hw_panel_graph_panels');

	var xExtent = graph.config.xAxis.config.range;

	var xScale = Object(d3_scale_src["scaleLinear"])().domain(xExtent).range([layout.plotAreaX + layout.xPadding, layout.plotAreaX + layout.plotAreaWidth - layout.xPadding]);

	layout.panels.forEach(function (panelLayout, i) {
		// Layout is null if the panel is not active
		if (panelLayout !== null) {
			renderPanel(panelsGroupElem, graph, graph.config.panels[i], i, panelLayout, layout.xPadding, xScale, defs);
		}
	});

	var xAxis = Object(d3_axis_src["axisBottom"])().scale(xScale).tickSizeInner(5).tickSizeOuter(0);

	if (graph.config.xAxis.config.tickValues !== null) {
		xAxis.tickValues(graph.config.xAxis.config.tickValues);
	}

	if (typeof graph.config.xAxis.config.formatter === 'function') {
		xAxis.tickFormat(graph.config.xAxis.config.formatter);
	}

	renderXAxis(svg, xAxis, layout.plotAreaY + layout.plotAreaHeight);

	if (graph.config.tooltipMode !== constants["a" /* TOOLTIP_MODE */].NONE) {
		addTooltips(graph.config.tooltipMode, graph, container, svg, layout, xScale);
	}
}
// CONCATENATED MODULE: ./utils/panelgraph/components/graph.js
/* harmony export (immutable) */ __webpack_exports__["a"] = graph_graph;
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var graph_Graph = function () {
	function Graph(name) {
		_classCallCheck(this, Graph);

		this.config = {
			name: name,
			data: [],
			height: 400,
			margins: [30, 40, 30, 40],
			panels: [],
			plotLines: [],
			plotBands: [],
			tooltipMode: constants["a" /* TOOLTIP_MODE */].INDIVIDUAL,
			combinedTooltipPosition: 'data',
			legendEnabled: true,
			xAxis: null
		};

		// When graph is rendered, will be set to the element where all events are captured within the
		// graph. Can be accessed to add custom events or similar.
		this.eventCapturingBox = null;

		// When graph is rendered, this will be a function that may be called to hide tooltips. Can
		// be useful for some external events.
		this.hideTooltipFn = null;
	}

	Graph.prototype.data = function data(_data) {
		this.config.data = _data;
		return this;
	};

	Graph.prototype.height = function height(h) {
		// h can be a numeric pixel value or a function which takes width and returns height
		this.config.height = h;
		return this;
	};

	Graph.prototype.margin = function margin(margins) {
		this.config.margins = margins;
		return this;
	};

	Graph.prototype.panels = function panels(_panels) {
		this.config.panels = _panels;
		return this;
	};

	Graph.prototype.plotLines = function plotLines(_plotLines) {
		this.config.plotLines = _plotLines;
		return this;
	};

	Graph.prototype.plotBands = function plotBands(_plotBands) {
		this.config.plotBands = _plotBands;
		return this;
	};

	Graph.prototype.tooltipMode = function tooltipMode(mode) {
		this.config.tooltipMode = mode;
		return this;
	};

	Graph.prototype.combinedTooltipPosition = function combinedTooltipPosition(position) {
		this.config.combinedTooltipPosition = position;
		return this;
	};

	Graph.prototype.legendEnabled = function legendEnabled(isEnabled) {
		this.config.legendEnabled = isEnabled;
		return this;
	};

	Graph.prototype.xAxis = function xAxis(axis) {
		this.config.xAxis = axis;
		return this;
	};

	Graph.prototype.render = function render(container) {
		renderGraph(this, container);
	};

	Graph.prototype.hideTooltips = function hideTooltips() {
		if (typeof this.hideTooltipFn === 'function') {
			this.hideTooltipFn();
		}
	};

	return Graph;
}();

function graph_graph(name) {
	return new graph_Graph(name);
}

/***/ }),

/***/ "dLxY":
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */
function debounce(func, wait, immediate) {
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function debounced() {
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function () {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };

  debounced.flush = function () {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;

      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

// Adds compatibility for ES modules
debounce.debounce = debounce;

module.exports = debounce;

/***/ }),

/***/ "gNwm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = formatTemperature;
/* harmony export (immutable) */ __webpack_exports__["g"] = formatTemperatureInterval;
/* harmony export (immutable) */ __webpack_exports__["e"] = formatRainfall;
/* harmony export (immutable) */ __webpack_exports__["d"] = formatRainRate;
/* harmony export (immutable) */ __webpack_exports__["c"] = formatPressure;
/* harmony export (immutable) */ __webpack_exports__["i"] = formatWindSpeed;
/* harmony export (immutable) */ __webpack_exports__["h"] = formatWindGust;
/* harmony export (immutable) */ __webpack_exports__["a"] = convertSpeedUnitToWindRunUnit;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return customLocale; });
/* harmony export (immutable) */ __webpack_exports__["j"] = getDateTimeFormatConverter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time_format__ = __webpack_require__("UYpZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("hafV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__date_utils__ = __webpack_require__("Z83D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__unit_converters__ = __webpack_require__("rbCG");





/**
 * Take a temperature value and unit, apply any necessary unit conversions and return a formatted value.
 *
 * @param value - temperature value
 * @param unit - see TEMPERATURE_UNIT
 * @param alreadyConverted - the value is already converted (default false)
 * @returns {string}
 */
function formatTemperature(value, unit) {
  var alreadyConverted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var convertedValue = alreadyConverted ? value : Object(__WEBPACK_IMPORTED_MODULE_3__unit_converters__["c" /* convertTemperature */])(value, unit);
  return convertedValue.toFixed(1);
}

/**
 * Take a temperature interval value and unit, apply any necessary unit conversions and return a formatted value.
 *
 * @param value - temperature value
 * @param unit - see TEMPERATURE_UNIT
 * @param alreadyConverted - the value is already converted (default false)
 * @returns {string}
 */
function formatTemperatureInterval(value, unit) {
  var alreadyConverted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var convertedValue = alreadyConverted ? value : Object(__WEBPACK_IMPORTED_MODULE_3__unit_converters__["d" /* convertTemperatureTrend */])(value, unit);
  return convertedValue.toFixed(1);
}

/**
 * Take a rainfall value and unit, apply any necessary unit conversions and return a formatted value.
 *
 * @param value - rainfall value
 * @param unit - see RAIN_UNIT
 * @param alreadyConverted - the value is already converted (default false)
 * @returns {string}
 */
function formatRainfall(value, unit) {
  var alreadyConverted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var convertedValue = alreadyConverted ? value : Object(__WEBPACK_IMPORTED_MODULE_3__unit_converters__["b" /* convertRainfall */])(value, unit);
  var dp = unit === __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* RAIN_UNIT */].IN ? 2 : 1;
  return convertedValue.toFixed(dp);
}

/**
 * Take a rain rate value and unit, apply any necessary unit conversions and return a formatted value.
 *
 * @param value - rain rate value
 * @param unit - see RAIN_UNIT
 * @param morePreciseWhenLow - return a more precise value when the value is lower than a certain threshold
 * @param alreadyConverted - the value is already converted (default false)
 * @returns {string}
 */
function formatRainRate(value, unit) {
  var morePreciseWhenLow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var alreadyConverted = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  // get the converted value
  var convertedValue = alreadyConverted ? value : Object(__WEBPACK_IMPORTED_MODULE_3__unit_converters__["b" /* convertRainfall */])(value, unit);

  // calculate the threshold value to compare against at which precision decreases
  var thresholdMm = unit === __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* RAIN_UNIT */].IN ? 50 / 25.4 : 50;

  // use higher precision if the `morePreciseWhenLow` flag is true and the value is below the threshold
  var useHigherPrecision = morePreciseWhenLow && convertedValue < thresholdMm;
  var decimalPlacesAdjustment = useHigherPrecision ? 1 : 0;

  var dp = (unit === __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* RAIN_UNIT */].IN ? 1 : 0) + decimalPlacesAdjustment;
  return convertedValue.toFixed(dp);
}

/**
 * Take a pressure value and unit, apply any necessary unit conversions and return a formatted value.
 *
 * @param value - pressure value
 * @param unit - see PRESSURE_UNIT
 * @param alreadyConverted - the value is already converted (default false)
 * @returns {string}
 */
function formatPressure(value, unit) {
  var alreadyConverted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var convertedValue = alreadyConverted ? value : Object(__WEBPACK_IMPORTED_MODULE_3__unit_converters__["a" /* convertPressure */])(value, unit);
  var dp = unit === __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* PRESSURE_UNIT */].INHG ? 2 : 1;
  return convertedValue.toFixed(dp);
}

/**
 * Take a wind speed value and unit, apply any necessary speed unit conversions
 * and return a formatted value.
 *
 * @param value - wind speed value
 * @param unit - see SPEED_UNIT
 * @param alreadyConverted - the value is already converted (default false)
 * @returns {string}
 */
function formatWindSpeed(value, unit) {
  var alreadyConverted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var convertedValue = alreadyConverted ? value : Object(__WEBPACK_IMPORTED_MODULE_3__unit_converters__["e" /* convertWindSpeed */])(value, unit);
  return convertedValue.toFixed(1);
}

/**
 * Take a wind gust value and unit, apply any necessary speed unit conversions
 * and return a formatted value.
 *
 * @param value - wind gust value
 * @param unit - see SPEED_UNIT
 * @param alreadyConverted - the value is already converted (default false)
 * @param roundHighMs - if the unit is m/s and the value is in double digits, should it be rounded to the nearest whole number? (default false)
 * @returns {string | number}
 */
function formatWindGust(value, unit) {
  var alreadyConverted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var roundHighMs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var convertedValue = alreadyConverted ? value : Object(__WEBPACK_IMPORTED_MODULE_3__unit_converters__["e" /* convertWindSpeed */])(value, unit);

  if (unit !== __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* SPEED_UNIT */].MS || roundHighMs && convertedValue >= 10) {
    return Math.round(convertedValue);
  }

  return convertedValue.toFixed(1);
}

/**
 * Converts a wind speed unit to a wind run unit.
 *
 * @param speedUnit - see SPEED_UNIT
 * @returns {string}
 */
function convertSpeedUnitToWindRunUnit(speedUnit) {
  switch (speedUnit) {
    case __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* SPEED_UNIT */].KMH:
      return 'km';
    case __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* SPEED_UNIT */].MPH:
      return 'miles';
    case __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* SPEED_UNIT */].KNOTS:
      return 'nautical miles';
    case __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* SPEED_UNIT */].MS:
      return 'km';
    default:
      return '';
  }
}

/**
 * Custom D3 date/time locale
 */
var customLocale = Object(__WEBPACK_IMPORTED_MODULE_0_d3_time_format__["timeFormatLocale"])({
  dateTime: '%-I:%M:%S %p %A %-d %B %Y',
  date: '%A %-d %B %Y',
  time: '%-I:%M %p',
  periods: ['am', 'pm'],
  days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  months: Object(__WEBPACK_IMPORTED_MODULE_2__date_utils__["a" /* getMonthNames */])(),
  shortMonths: Object(__WEBPACK_IMPORTED_MODULE_2__date_utils__["a" /* getMonthNames */])().map(function (month) {
    return month.slice(0, 3);
  })
});

/**
 * Return a function which converts from one datetime format to another.
 *
 * @param fromFormat - see D3 datetime format docs
 * @param toFormat - see D3 datetime format docs
 * @returns {function(string): string}
 */
function getDateTimeFormatConverter(fromFormat, toFormat) {
  var parser = customLocale.parse(fromFormat);
  var formatter = customLocale.format(toFormat);
  return function (t) {
    return formatter(parser(t));
  };
}

/***/ }),

/***/ "gmeS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOOLTIP_MODE; });
var TOOLTIP_MODE = {
	INDIVIDUAL: 1,
	COMBINED: 2,
	COMBINED_REVERSE: 3,
	NONE: 4
};

/***/ }),

/***/ "hVjA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return requestIdleCallbackWithFallback; });
var requestIdleCallbackWithFallback = function requestIdleCallbackWithFallback(callback) {

	if ('requestIdleCallback' in window) {
		window.requestIdleCallback(callback);
	} else {
		window.setTimeout(callback, 0);
	}
};

/***/ }),

/***/ "hafV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TEMPERATURE_UNIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SPEED_UNIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RAIN_UNIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PRESSURE_UNIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GRAPH_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GRAPH_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MESSAGE_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLIMATE_DATA_TABLE_VIEW; });
var TEMPERATURE_UNIT = {
	C: 'C',
	F: 'F'
};

var SPEED_UNIT = {
	KMH: 'km/h',
	MPH: 'mph',
	KNOTS: 'knots',
	MS: 'm/s'
};

var RAIN_UNIT = {
	MM: 'mm',
	IN: 'in.'
};

var PRESSURE_UNIT = {
	HPA: 'hPa',
	INHG: 'in. Hg'
};

var GRAPH_VIEW = {
	COMBINED: 'combined',
	TEMPERATURE: 'temperature',
	WIND: 'wind_speed_direction',
	RAIN: 'daily_rainfall',
	HUMIDITY: 'humidity',
	PRESSURE: 'pressure',
	RAIN_HOURLY: 'hourly_rainfall',
	WIND_ROSE: 'wind_rose'
};

var GRAPH_RANGE = {
	STANDARD: '24h',
	EXTENDED: '7d'
};

var MESSAGE_LEVEL = {
	INFO: 'info',
	WARNING: 'warning'
};

var CLIMATE_DATA_TABLE_VIEW = {
	SUMMARY: 'climate_summary',
	AVG_TEMPERATURE: 'mean_temperature',
	AVG_DAILY_HIGH: 'mean_daily_high_temperature',
	AVG_DAILY_LOW: 'mean_daily_low_temperature',
	HIGHEST_TEMPERATURE: 'highest_temperature',
	LOWEST_TEMPERATURE: 'lowest_temperature',
	WARMEST_DAY: 'warmest_day',
	COLDEST_DAY: 'coldest_day',
	LOWEST_DAILY_HIGH: 'lowest_daily_high_temperature',
	HIGHEST_DAILY_LOW: 'highest_daily_low_temperature',
	TOTAL_RAINFALL: 'total_rainfall',
	WET_DAYS: 'number_of_wet_days',
	WETTEST_DAY: 'highest_daily_rainfall',
	HIGHEST_HOURLY_RAINFALL: 'highest_hourly_rainfall',
	HIGHEST_RAIN_RATE: 'highest_rain_rate',
	HIGHEST_WIND_GUST: 'highest_wind_gust',
	HIGHEST_WIND_RUN: 'highest_daily_wind_run',
	LOWEST_WIND_RUN: 'lowest_daily_wind_run',
	HIGHEST_PRESSURE: 'highest_pressure',
	LOWEST_PRESSURE: 'lowest_pressure',
	HIGHEST_DEWPOINT: 'highest_dewpoint',
	LOWEST_DEWPOINT: 'lowest_dewpoint',
	LOWEST_HUMIDITY: 'lowest_humidity',
	NUMBER_DAYS_HIGH_TEMP_27_PLUS: 'number_days_high_temp_27plus',
	NUMBER_DAYS_HIGH_TEMP_25_PLUS: 'number_days_high_temp_25plus',
	NUMBER_DAYS_LOW_TEMP_5_BELOW: 'number_days_low_temp_5below',
	NUMBER_DAYS_LOW_TEMP_2_BELOW: 'number_days_low_temp_2below',
	NUMBER_DAYS_HIGH_DEWPOINT_20_PLUS: 'number_days_high_dewpoint_20plus'
};

/***/ }),

/***/ "iBxh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"no_data_wrapper":"no_data_wrapper__3TtTY","no_data":"no_data__1gVh_"};

/***/ }),

/***/ "l44Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__("Jxom");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * The Selector component displays a selection of options for the user to pick from.
 *
 * props:
 * - options: array of option data objects. { value: any, label: string, disabled: boolean }[]
 * - selectedValue: the value of the option currently selected
 * - onOptionSelect: callback function for when the user selects a new option
 */

var Selector = function (_Component) {
	_inherits(Selector, _Component);

	function Selector(props) {
		_classCallCheck(this, Selector);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.onSelectChange = _this.onSelectChange.bind(_this);
		return _this;
	}

	Selector.prototype.onSelectChange = function onSelectChange(evt) {
		var option = this.props.options[evt.target.selectedIndex];
		this.props.onOptionSelect(option);
	};

	Selector.prototype.render = function render(props) {
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ className: __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.selector_wrapper },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'select',
				{ className: __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.selector, onChange: this.onSelectChange },
				props.options.map(function (opt) {
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'option',
						{ value: opt.value,
							disabled: opt.disabled,
							selected: opt.value === props.selectedValue },
						opt.label
					);
				})
			)
		);
	};

	return Selector;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Selector);

/***/ }),

/***/ "lCuA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"message":"message__2Uupe","level_info":"level_info__3fOrw","level_warning":"level_warning__2wJqT","message_content":"message_content__1RTkA","message_icon":"message_icon__-L6vq","close_btn":"close_btn__3thh4"};

/***/ }),

/***/ "lHSP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M0 0h24v24H0z", fill: "none" });

var DropdownIcon = function DropdownIcon(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"svg",
		{ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M7 10l5 5 5-5z", fill: props.fill }),
		_ref
	);
};

/* harmony default export */ __webpack_exports__["a"] = (DropdownIcon);

/***/ }),

/***/ "lRsh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	"svg",
	{ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" }),
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M0 0h24v24H0z", fill: "none" })
);

/**
 * The RefreshIcon component renders an inline SVG which shows a refresh arrow. This
 * can be used inside Buttons to create retry or reload buttons.
 */

var RefreshIcon = function RefreshIcon() {
	return _ref;
};

/* harmony default export */ __webpack_exports__["a"] = (RefreshIcon);

/***/ }),

/***/ "lWMT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table":"table__31Tq3"};

/***/ }),

/***/ "nTP0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = xAxis;
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Axis = function () {
	function Axis() {
		_classCallCheck(this, Axis);

		this.config = {
			dataAccessor: function dataAccessor(d) {
				return 0;
			},
			min: null,
			max: null,
			tickValues: null,
			range: null,
			formatter: function formatter(value) {
				return value;
			},
			tooltipFormatter: function tooltipFormatter(value) {
				return value;
			}
		};
	}

	Axis.prototype.data = function data(_data) {
		this.config.dataAccessor = _data;
		return this;
	};

	Axis.prototype.tickValues = function tickValues(_tickValues) {
		this.config.tickValues = _tickValues;
		return this;
	};

	Axis.prototype.formatter = function formatter(_formatter) {
		this.config.formatter = _formatter;
		return this;
	};

	Axis.prototype.tooltipFormatter = function tooltipFormatter(formatter) {
		this.config.tooltipFormatter = formatter;
		return this;
	};

	Axis.prototype.range = function range(_range) {
		this.config.range = _range;
		return this;
	};

	return Axis;
}();

function xAxis() {
	return new Axis();
}

/***/ }),

/***/ "o4Fd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = forEachObj;
/* harmony export (immutable) */ __webpack_exports__["c"] = mapObj;
/* harmony export (immutable) */ __webpack_exports__["a"] = filterObj;
/* harmony export (immutable) */ __webpack_exports__["d"] = mapObjToArr;
function forEachObj(obj, fn) {

	for (var key in obj) {

		if (Object.prototype.hasOwnProperty.call(obj, key)) {
			fn(key, obj[key], obj);
		}
	}
}

function mapObj(obj, fn) {

	var result = {};

	forEachObj(obj, function (key, value, obj) {
		result[key] = fn(key, value, obj);
	});

	return result;
}

function filterObj(obj, fn) {

	var result = {};

	forEachObj(obj, function (key, value, obj) {
		var keep = fn(key, value, obj);
		if (keep) {
			result[key] = value;
		}
	});

	return result;
}

function mapObjToArr(obj, fn) {

	var result = [];

	forEachObj(obj, function (key, value, obj) {
		result.push(fn(key, value, obj));
	});

	return result;
}

/***/ }),

/***/ "pCTO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loading_screen":"loading_screen__3f1Uc"};

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (false) {
	navigator.serviceWorker.register(__webpack_public_path__ + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "rAoZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__("appZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);



/**
 * A Button component which renders a stylised button element. The content
 * displayed inside the button is specified via children elements.
 *
 * props:
 * - wide: should this be a wide button or not (true or false)
 * - isActive: is the button currently active (true or false)
 * - isDisabled: is the button currently disabled (true or false)
 * - data: Extra data for this button, passed into the provided clickHandler as the sole argument.
 * - clickHandler: handler function which responds to button click events.
 * - buttonTitle: title for this button
 */

var Button = function Button(props) {

	var cssClass = props.wide ? [__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.button_wide] : [__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.button];

	if (props.isActive) {
		cssClass.push(__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.active);
	}

	var onClick = function onClick() {
		return props.clickHandler(props.data);
	};

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'button',
		{ 'class': cssClass.join(' '),
			disabled: props.isDisabled,
			title: props.buttonTitle,
			onClick: onClick },
		props.children
	);
};

/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),

/***/ "rbCG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = convertTemperature;
/* harmony export (immutable) */ __webpack_exports__["d"] = convertTemperatureTrend;
/* harmony export (immutable) */ __webpack_exports__["b"] = convertRainfall;
/* harmony export (immutable) */ __webpack_exports__["a"] = convertPressure;
/* harmony export (immutable) */ __webpack_exports__["e"] = convertWindSpeed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("hafV");


function convertTemperature(value, unit) {
	return unit === __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* TEMPERATURE_UNIT */].F ? 32 + 1.8 * value : value;
}

function convertTemperatureTrend(value, unit) {
	return unit === __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* TEMPERATURE_UNIT */].F ? 1.8 * value : value;
}

function convertRainfall(value, unit) {
	return unit === __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* RAIN_UNIT */].IN ? value / 25.4 : value;
}

function convertPressure(value, unit) {
	return unit === __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* PRESSURE_UNIT */].INHG ? value / 33.8638867 : value;
}

function convertWindSpeed(value, unit) {
	switch (unit) {
		case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SPEED_UNIT */].MPH:
			return 0.6214 * value;
		case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SPEED_UNIT */].KNOTS:
			return 0.54 * value;
		case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SPEED_UNIT */].MS:
			return value / 3.6;
		default:
			return value;
	}
}

/***/ }),

/***/ "reV9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__("X8eH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button__ = __webpack_require__("rAoZ");




/**
 * The ButtonGroup component renders a collection of Button components
 * given the options provided as props. Only one may be active at any given
 * moment.
 *
 * props:
 * - options: an array of objects, e.g. { value: 1, label: 'Option 1' }
 * - activeOption: the value of the option which is active
 * - onBtnClick: click handler function, called when a button in the group is clicked.
 */

var ButtonGroup = function ButtonGroup(props) {

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.button_group },
		props.options.map(function (opt) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.button_group_option, key: opt.value },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_2__button__["a" /* default */],
					{ isActive: opt.value === props.activeOption,
						data: opt.value,
						clickHandler: props.onBtnClick },
					opt.label
				)
			);
		})
	);
};

/* harmony default export */ __webpack_exports__["a"] = (ButtonGroup);

/***/ }),

/***/ "sw5u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Link = exports.Match = undefined;

var _extends = Object.assign || function (target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i];for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key];
			}
		}
	}return target;
};

var _preact = __webpack_require__("KM04");

var _preactRouter = __webpack_require__("/QC5");

function _objectWithoutProperties(obj, keys) {
	var target = {};for (var i in obj) {
		if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	}return target;
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Match = exports.Match = function (_Component) {
	_inherits(Match, _Component);

	function Match() {
		var _temp, _this, _ret;

		_classCallCheck(this, Match);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.update = function (url) {
			_this.nextUrl = url;
			_this.setState({});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Match.prototype.componentDidMount = function componentDidMount() {
		_preactRouter.subscribers.push(this.update);
	};

	Match.prototype.componentWillUnmount = function componentWillUnmount() {
		_preactRouter.subscribers.splice(_preactRouter.subscribers.indexOf(this.update) >>> 0, 1);
	};

	Match.prototype.render = function render(props) {
		var url = this.nextUrl || (0, _preactRouter.getCurrentUrl)(),
		    path = url.replace(/\?.+$/, '');
		this.nextUrl = null;
		return props.children({
			url: url,
			path: path,
			matches: (0, _preactRouter.exec)(path, props.path, {}) !== false
		});
	};

	return Match;
}(_preact.Component);

var Link = function Link(_ref) {
	var activeClassName = _ref.activeClassName,
	    path = _ref.path,
	    props = _objectWithoutProperties(_ref, ['activeClassName', 'path']);

	return (0, _preact.h)(Match, { path: path || props.href }, function (_ref2) {
		var matches = _ref2.matches;
		return (0, _preact.h)(_preactRouter.Link, _extends({}, props, { 'class': [props.class || props.className, matches && activeClassName].filter(Boolean).join(' ') }));
	});
};

exports.Link = Link;
exports.default = Match;

Match.Link = Link;

/***/ }),

/***/ "tfzA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__("5gwI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);



/**
 * The FootNote component displays a footnote. Content is provided
 * as child elements.
 */
var FootNote = function FootNote(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.footnote },
    props.children
  );
};

/* harmony default export */ __webpack_exports__["a"] = (FootNote);

/***/ }),

/***/ "vNH8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = panel;
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Panel = function () {
	function Panel() {
		_classCallCheck(this, Panel);

		this.config = {
			axisLeft: null,
			axisRight: null,
			axisDual: null,
			primaryAxis: null,
			series: [],
			height: null, // remaining height is equally apportioned for panels with height: null
			isActive: true
		};
	}

	Panel.prototype.axisLeft = function axisLeft(axis) {
		var isPrimaryAxis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

		this.config.axisLeft = axis;

		if (isPrimaryAxis) {
			this.config.primaryAxis = 'left';
		}

		return this;
	};

	Panel.prototype.axisRight = function axisRight(axis) {
		var isPrimaryAxis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

		this.config.axisRight = axis;

		if (isPrimaryAxis) {
			this.config.primaryAxis = 'right';
		}

		return this;
	};

	Panel.prototype.axisDual = function axisDual(axis) {
		this.config.axisDual = axis;
		return this;
	};

	Panel.prototype.series = function series(_series) {
		this.config.series = _series;
		return this;
	};

	Panel.prototype.height = function height(_height) {
		this.config.height = _height;
		return this;
	};

	Panel.prototype.isActive = function isActive(_isActive) {
		this.config.isActive = _isActive;
		return this;
	};

	return Panel;
}();

function panel() {
	return new Panel();
}

/***/ }),

/***/ "wGJf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"card":"card__3w4ge","no_margin":"no_margin__usJic","card_title":"card_title__34Hvg","card_title_large":"card_title_large__1_ALn"};

/***/ }),

/***/ "x4D6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Tracker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EVENT_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENT_ACTION; });
var Tracker = function Tracker() {
	return {

		recordPageView: function recordPageView() {
			if ('ga' in window) {
				ga('send', 'pageview', window.location.pathname);
			} else {
				console.log('[Tracking] Page View', window.location.pathname);
			}
		},

		recordEvent: function recordEvent(action, category, label, value) {
			if ('ga' in window) {
				ga('send', 'event', category, action, label, value);
			} else {
				console.log('[Tracking] Event', action, label, value);
			}
		},

		recordException: function recordException(description, err) {
			var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


			var errStr = err ? ' error = ' + JSON.stringify(err, Object.getOwnPropertyNames(err)) : '';
			var dataStr = data ? ' data = ' + JSON.stringify(data) : '';

			var exceptionDesc = description + ':' + dataStr + errStr;

			if ('ga' in window) {
				ga('send', 'exception', {
					exDescription: exceptionDesc
				});
			} else {
				console.log('[Tracking] Exception', exceptionDesc);
			}
		}

	};
};

var EVENT_CATEGORY = {
	LIVE: 'live',
	GRAPHS: 'graphs',
	ABOUT: 'about',
	NEWS: 'news',
	SETTINGS: 'settings',
	HISTORY_DAILY: 'history_daily',
	HISTORY_MONTHLY: 'history_monthly',
	HISTORY_YEARLY: 'history_yearly',
	HISTORY_RAINFALL: 'history_rainfall',
	HISTORY_RECORDS: 'history_records',
	HISTORY_CLIMATE: 'history_climate',
	HISTORY_DOWNLOAD: 'history_download'
};

var EVENT_ACTION = {

	DISMISS_MESSAGE: 'dismiss_message',

	SETTINGS_SAVE: 'save_custom_settings',
	SETTINGS_RESET: 'reset_settings',
	SETTINGS_CONVERT: 'convert_settings',

	LIVE_TOGGLE_OBS_VIEW: 'toggle_recent_obs_view_%1',
	LIVE_RESTART_UPDATES: 'restart_live_updates',

	GRAPHS_SWITCH: 'graphs_view_%1_%2',
	GRAPHS_REFRESH: 'graphs_refresh',

	HISTORY_DAILY_TOGGLE_OBS_VIEW: 'daily_history_toggle_obs_view_%1',
	HISTORY_DAILY_SWITCH_DETAILED_OBS_PARAMETER: 'daily_history_switch_detailed_obs_%1',

	HISTORY_MONTHLY_TOGGLE_OBS_VIEW: 'monthly_history_toggle_obs_view_%1',
	HISTORY_MONTHLY_SWITCH_DETAILED_OBS_PARAMETER: 'monthly_history_switch_detailed_obs_%1',

	HISTORY_YEARLY_TOGGLE_GRAPH_VIEW: 'yearly_history_toggle_graph_view_%1',
	HISTORY_YEARLY_SWITCH_DETAILED_GRAPHS_PARAMETER: 'yearly_history_switch_detailed_obs_%1',

	HISTORY_RAINFALL_HIDE_YEAR: 'rainfall_history_hide_year',
	HISTORY_RAINFALL_SHOW_YEAR: 'rainfall_history_show_year',

	HISTORY_CLIMATE_SWITCH_DATA_TABLE_VIEW: 'climate_switch_data_table_view_%1',

	HISTORY_DOWNLOAD_DAILY_STATS: 'download_daily_stats',
	HISTORY_DOWNLOAD_MONTHLY_STATS: 'download_monthly_stats',
	HISTORY_DOWNLOAD_OBSERVATIONS: 'download_observations'

};

/***/ }),

/***/ "yR6k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"error":"error__2OMFq","error_message":"error_message__2bQSz","error_retry":"error_retry__ECnHa"};

/***/ }),

/***/ "yY49":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zfcO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wind_rose_description":"wind_rose_description__3OP6Y"};

/***/ })

},["pwNi"]);


// WEBPACK FOOTER //
// bundle.f0399.js